export const translationsEnUS = {
  "admin.discussion.searchTools.title.online": "Public Web search",
  "admin.discussion.searchTools.title.onlineRead": "Web page reading",
  "admin.discussion.searchTools.title.indexedDocuments": "Indexed document search",
  "admin.discussion.searchTools.title.unreadable": "Unrecognized search response",
  "admin.discussion.searchTools.outcome.FOUND": "Results found",
  "admin.discussion.searchTools.outcome.NO_RESULTS": "No results",
  "admin.discussion.searchTools.outcome.UNAVAILABLE": "Search unavailable",
  "admin.discussion.searchTools.recordedMessage": "Content of the Tool message saved in this discussion and prepared for the model. This message alone does not prove that a subsequent model request succeeded.",
  "admin.discussion.searchTools.request": "Agent request",
  "admin.discussion.searchTools.rawResponse": "View the saved JSON message",
  "admin.discussion.searchTools.callId": "Call identifier:",
  "admin.discussion.searchTools.missingContent": "This message’s content is unavailable.",
  "admin.discussion.searchTools.unreadable": "The content is missing or its format is not recognized. The original message remains available when retained; no search is run again.",
  "admin.discussion.searchTools.unavailable": "This call returned no usable content. This does not mean the requested information does not exist.",
  "admin.discussion.searchTools.noResults": "No results were returned for this request.",
  "admin.discussion.searchTools.previewsOnly": "Links and previews returned by the search engine. This call did not download these pages.",
  "admin.discussion.searchTools.partialSearch": "The returned list of previews is partial.",
  "admin.discussion.searchTools.requestedUrl": "Requested address:",
  "admin.discussion.searchTools.fetchedAt": "Page downloaded on",
  "admin.discussion.searchTools.partialBlock": "This portion contains only part of this text block.",
  "admin.discussion.searchTools.pageLinks": "Links included in the response ({count})",
  "admin.discussion.searchTools.hasMore": "More text remains in the downloaded copy. The Agent received a continuation cursor; this does not prove that it requested the next portion.",
  "admin.discussion.searchTools.endOfCopy": "This portion reaches the end of the downloaded copy’s text.",
  "admin.discussion.searchTools.continuationRequest": "Continuation requested with cursor:",
  "admin.discussion.searchTools.degraded": "Degraded result: part of the search or ranking could not be used.",
  "admin.discussion.searchTools.scoreHelp": "Scores apply to matched chunks, not to neighbors added to the text. Their kind is shown: cosine, bm25, rrf, etc. They are not comparable certainty percentages across methods.",
  "admin.discussion.searchTools.passage": "Passage {number}",
  "admin.discussion.searchTools.partialContext": "The text returned for this passage is partial.",
  "admin.discussion.searchTools.threshold": "threshold",
  "admin.discussion.searchTools.retrievalId": "Retrieval identifier:",
  "myAccount.myChatbot.readiness.onlineSearch.notConfigured": "Web search needs its secure configuration. Contact your administrator to finish preparing it.",
  "myAccount.myChatbot.readiness.onlineSearch.settingsRequired": "The search connection and internal-service protection still need configuring.",
  "myAccount.myChatbot.readiness.indexedDocuments.notConfigured":
    "Document search needs permission to read your documents and a search configuration. Contact your administrator to finish setup.",
  "myAccount.myChatbot.readiness.indexedDocuments.settingsRequired":
    "Document permissions and search settings need to be configured.",
  "knowledge.progress.title": "Knowledge imports",
  "knowledge.progress.description": "Find your latest imports and follow the preparation of each source.",
  "knowledge.progress.detail": "Import progress",
  "knowledge.progress.back": "All imports",
  "knowledge.progress.refresh": "Refresh",
  "knowledge.progress.refreshing": "Refreshing…",
  "knowledge.progress.loading": "Loading your imports…",
  "knowledge.progress.error": "Your imports are unavailable right now. Try Refresh again.",
  "knowledge.progress.detailError": "This import is unavailable or does not belong to your company. Return to the list or refresh.",
  "knowledge.progress.empty": "No imports yet. Requests prepared for your company will appear here.",
  "knowledge.progress.recent": "Your company’s 50 latest requests, newest first.",
  "knowledge.progress.target": "Preparation requested through:",
  "knowledge.progress.open": "View sources",
  "knowledge.progress.publication": "This screen follows source preparation. A completed import does not yet mean these sources have been published to your Agents.",
  "knowledge.progress.count.total": "sources",
  "knowledge.progress.count.completed": "completed",
  "knowledge.progress.count.failed": "to review",
  "knowledge.progress.noSources": "No sources recorded for this request.",
  "knowledge.progress.source": "Source {number}",
  "knowledge.progress.current": "Current stage",
  "knowledge.progress.notRequested": "Not requested",
  "knowledge.progress.failureAdvice": "This source needs a review. Contact your representative with the import date and source; the detailed diagnosis is available in the back office.",
  "knowledge.progress.stage.acquisition": "Reading the source",
  "knowledge.progress.stage.normalization": "Cleaning the content",
  "knowledge.progress.stage.chunking": "Organizing the text",
  "knowledge.progress.stage.embedding": "Preparing search",
  "knowledge.progress.stage.indexing": "Search index",
  "knowledge.progress.status.QUEUED": "Queued",
  "knowledge.progress.status.RUNNING": "In progress",
  "knowledge.progress.status.WAITING": "Waiting for a result",
  "knowledge.progress.status.RESUMABLE": "Waiting to resume",
  "knowledge.progress.status.SUCCEEDED": "Processing completed",
  "knowledge.progress.status.FAILED": "Needs a review",
  "knowledge.progress.status.CANCELLED": "Cancelled",
  "knowledge.progress.status.INTERRUPTED": "Interrupted",
  "admin.knowledge.recent.title": "The {limit} latest ingestion requests",
  "admin.knowledge.recent.applyFilter": "Filter by company",
  "admin.knowledge.recent.allCompanies": "All companies",
  "admin.knowledge.recent.selectedCompany": "Company: {name}",
  "admin.knowledge.recent.loading": "Loading the latest ingestion requests…",
  "admin.knowledge.inspection.title": "Ingestion progress",
  "admin.knowledge.inspection.back": "Ingestion requests",
  "admin.knowledge.inspection.refresh": "Refresh",
  "admin.knowledge.inspection.companyNumber": "Company {number}",
  "admin.knowledge.inspection.target": "Through",
  "admin.knowledge.inspection.totalDuration": "Total duration",
  "admin.knowledge.inspection.capturedAddress": "Captured URL",
  "admin.knowledge.inspection.capturedAt": "Capture recorded at",
  "admin.knowledge.inspection.successCount": "{count, plural, one {# source succeeded} other {# sources succeeded}} out of {total}",
  "admin.knowledge.inspection.failureCount": "{count, plural, one {# failure} other {# failures}}",
  "admin.knowledge.inspection.remainingCount": "{count} running or waiting",
  "admin.knowledge.inspection.interruptedCount": "{count, plural, one {# unknown outcome} other {# unknown outcomes}}",
  "admin.knowledge.inspection.cancelledCount": "{count, plural, one {# cancelled} other {# cancelled}}",
  "admin.knowledge.inspection.notStartedShort": "Not started",
  "admin.knowledge.inspection.previousAttempt": "You are viewing a previous attempt. The five stages above show the current processing chain.",
  "admin.knowledge.inspection.associatedOutput": "This output belongs to the selected attempt but is separate from its main result.",
  "admin.knowledge.inspection.frozenSettings": "Settings used for this request",
  "admin.knowledge.inspection.sourceList": "Sources",
  "admin.knowledge.inspection.findSource": "Search URLs",
  "admin.knowledge.inspection.filter": "Source status",
  "admin.knowledge.inspection.allSources": "All sources",
  "admin.knowledge.inspection.sourceNumber": "Source {number} — URL not recorded",
  "admin.knowledge.inspection.noSources": "No sources match this selection.",
  "admin.knowledge.inspection.stageList": "The five ingestion stages",
  "admin.knowledge.inspection.stageOutput": "Content produced by this stage",
  "admin.knowledge.inspection.attempt": "Attempt",
  "admin.knowledge.inspection.currentRevision": "Current processing",
  "admin.knowledge.inspection.invalidSelection": "This source, attempt or output does not belong to the selection. Choose a source and a stage from the list.",
  "admin.knowledge.inspection.stageFailed": "This stage encountered an error. Use the code below to find its cause in the technical details.",
  "admin.knowledge.inspection.noOutput": "This attempt has no saved content to inspect. Its status and events remain available in the technical details.",
  "admin.knowledge.inspection.notStarted": "No attempt for this stage is recorded for the selected processing chain.",
  "admin.knowledge.inspection.technicalDetails": "Technical details · attempts, events and identifiers",
  "admin.knowledge.inspection.rawJson": "Original output JSON",
  "admin.knowledge.inspection.actions": "History and actions for this request",
  "admin.knowledge.inspection.invalidContext": "Choose a company from the request list to open this view.",
  "admin.knowledge.inspection.accessDenied": "Your session cannot access this request. Sign in again with your administrator account.",
  "admin.knowledge.inspection.notFound": "This request was not found in the selected company.",
  "admin.knowledge.inspection.readFailed": "Reading failed. Try Refresh; it will not restart any processing.",
  "admin.knowledge.inspection.findText": "Find in this content",
  "admin.knowledge.inspection.nextMatch": "Next match",
  "admin.knowledge.inspection.noMatch": "No further matches. Click again to start from the beginning.",
  "admin.knowledge.inspection.capturedHtml": "Captured HTML, displayed as text",
  "admin.knowledge.inspection.capturedText": "Captured text",
  "admin.knowledge.inspection.failedWithoutContent": "This attempt failed without producing usable content. Its error code and retained diagnostics can help explain the cause.",
  "admin.knowledge.inspection.htmlIsText": "Saved private capture: this HTML is displayed as text, without running scripts or loading the website.",
  "admin.knowledge.inspection.scrapingDuration": "Scraping duration",
  "admin.knowledge.inspection.scrapingDiagnostics": "Browser downloads and errors",
  "admin.knowledge.inspection.downloadCount": "{count} tracked downloads",
  "admin.knowledge.inspection.scriptErrorCount": "{count} recorded JavaScript errors",
  "admin.knowledge.inspection.unsupportedCapture": "This format does not yet have a text preview. The original result remains available in the technical details.",
  "admin.knowledge.inspection.unreadableOutput": "This result cannot be displayed in this view. Inspect the original JSON in the technical details; no output is recreated.",
  "admin.knowledge.inspection.blockCount": "{count, plural, one {# normalized block} other {# normalized blocks}}",
  "admin.knowledge.inspection.compareAcquisition": "Compare with the HTML capture",
  "admin.knowledge.inspection.normalizedText": "Normalized text",
  "admin.knowledge.inspection.orderedBlocks": "Blocks in document order",
  "admin.knowledge.inspection.warnings": "Extraction details to review",
  "admin.knowledge.inspection.warning.BODY_FALLBACK": "No main content area was identified; the page body was used.",
  "admin.knowledge.inspection.warning.IMAGE_WITHOUT_TEXT": "An image has no usable text.",
  "admin.knowledge.inspection.warning.STATIC_STREAM_ASSEMBLY": "HTML fragments were assembled before extraction.",
  "admin.knowledge.inspection.showMore": "Show more",
  "admin.knowledge.inspection.chunkCount": "{count, plural, one {# saved passage} other {# saved passages}}",
  "admin.knowledge.inspection.passage": "Passage",
  "admin.knowledge.inspection.tokenCount": "{count} embedding tokens",
  "admin.knowledge.inspection.chunkText": "Passage text",
  "admin.knowledge.inspection.chunkTextHelp": "The normalized document text, without added headings. Use this text to quote the passage.",
  "admin.knowledge.inspection.searchText": "Text sent for embedding",
  "admin.knowledge.inspection.searchTextHelp": "The same passage, preceded by available headings to compute its search vector. Without headings, both texts are identical.",
  "admin.knowledge.inspection.overlapCharacters": "Overlap with the previous passage: {count} Unicode characters from the normalized document. This is not a token count.",
  "admin.knowledge.inspection.originBlocks": "Included block identifiers",
  "admin.knowledge.inspection.citations": "Retained origins and citation links",
  "admin.knowledge.inspection.embeddedCount": "{count, plural, one {# text converted to a vector} other {# texts converted to vectors}}",
  "admin.knowledge.inspection.model": "Recorded model",
  "admin.knowledge.inspection.dimensions": "Vector dimensions",
  "admin.knowledge.inspection.measuredTokens": "Provider-measured tokens",
  "admin.knowledge.inspection.providerCall": "Provider call",
  "admin.knowledge.inspection.reusedCall": "Saved response reused",
  "admin.knowledge.inspection.newCall": "New call made",
  "admin.knowledge.inspection.callUnknown": "Not recorded in this output",
  "admin.knowledge.inspection.accounting": "Cost accounting",
  "admin.knowledge.inspection.accounted": "Cost recorded in the journal",
  "admin.knowledge.inspection.accountingNotConfirmed": "Cost recording not confirmed in this view",
  "admin.knowledge.inspection.indexedCount": "{count, plural, one {# passage from this source indexed} other {# passages from this source indexed}}",
  "admin.knowledge.inspection.indexDestination": "Technical detail: Elasticsearch index",
  "admin.knowledge.inspection.versionSelected": "This version was selected when this attempt completed. A newer ingestion may have replaced it since.",
  "admin.knowledge.inspection.versionSuperseded": "This version was not selected: a newer version of this source was already indexed.",
  "admin.knowledge.inspection.selectionUnknown": "This result does not record which version was selected.",
  "admin.knowledge.inspection.retrievalPending": "Agent search over these passages is not connected yet. Successful indexing does not prove an Agent can use them.",
  "admin.knowledge.predecessor": "Retained input: predecessor attempt",
  "admin.knowledge.recordedSteps": "Recorded sub-operations",
  "admin.knowledge.inputFingerprint": "Input fingerprint",
  "admin.knowledge.outputFingerprint": "Output fingerprint",
  "admin.knowledge.step.acquire": "Acquire the content",
  "admin.knowledge.step.parse": "Extract the structure",
  "admin.knowledge.step.normalize": "Normalize the document",
  "admin.knowledge.step.chunk": "Split into passages",
  "admin.knowledge.step.embed": "Compute vectors",
  "admin.knowledge.step.index": "Store the search projection",
  "admin.knowledge.sourceHistory": "Source ingestion history (up to 50)",
  "admin.knowledge.retryPreview": "Review retry for this source",
  "admin.knowledge.retryScope": "Retry this stage, then continue to the ingestion request’s stopping point:",
  "admin.knowledge.retryPreserves": "Previous stages and receipts are preserved. A new attempt is recorded without rewriting history.",
  "admin.knowledge.retryPaid": "I authorize any new embedding calls needed for this retry.",
  "admin.knowledge.retryNoNewPaidCall": "This retry creates no new paid call: existing receipts still govern execution.",
  "admin.knowledge.retryConfirm": "Confirm targeted retry",
  "admin.knowledge.retryBlocked.SOURCE_NOT_RETRYABLE": "This source is no longer failed or cancelled. Refresh its journey.",
  "admin.knowledge.retryBlocked.PROFILE_INCOMPATIBLE": "This ingestion request uses an older profile. Automatic conversion is not allowed.",
  "admin.knowledge.retryBlocked.ATTEMPT_LIMIT": "The attempt limit has been reached. Review the cause before considering a new explicit ingestion request.",
  "admin.knowledge.retryBlocked.INPUT_UNAVAILABLE": "The previous output is absent, expired or corrupt. No implicit acquisition is allowed.",
  "admin.knowledge.retryBlocked.PAID_OUTCOME_UNCERTAIN": "The paid call’s outcome is unknown. Recover its receipt before retrying; confirmation cannot bypass this block.",
  "admin.knowledge.retryBlocked.RETAINED_RECEIPT_INVALID": "The embedding receipt is invalid or its content has expired. This retry cannot issue a second call for the same input.",
  "admin.knowledge.activity": "Pipeline activity",
  "admin.knowledge.serviceState": "View service status",
  "admin.knowledge.diagnostic.CONSUMERS_MISSING": "Capacity requested, no ready instance observed. Check the manager and health checks.",
  "admin.knowledge.diagnostic.CAPACITY_SATURATED": "All observed slots are busy and more work is waiting. Increasing capacity remains subject to the VPS budget.",
  "admin.knowledge.diagnostic.WORK_STALLED": "Work has waited over five minutes without a recent success despite a ready instance. Inspect attempts and scheduled delays.",
  "admin.knowledge.diagnostic.PUBLICATION_OVERDUE": "A notification has been due for over a minute. Check the publisher and RabbitMQ; this does not prove lost work.",
  "admin.knowledge.diagnostic.EXECUTION_LEASE_EXPIRED": "An execution lease expired. Recovery follows the journal; do not force success or a new paid call.",
  "admin.knowledge.diagnostic.REPEATED_FAILURES": "At least three attempts failed or were interrupted in five minutes. Inspect their causes before retrying.",
  "admin.knowledge.refresh": "Refresh",
  "admin.knowledge.activityUnavailable": "The activity journal is unavailable. Docker state never implies business success.",
  "admin.knowledge.managerUnobserved": "No recent manager observation. Instances may still be running: check Knowledge Management and the runtime manager.",
  "admin.knowledge.observedAt": "Manager observation",
  "admin.knowledge.step": "Stage",
  "admin.knowledge.configured": "Desired",
  "admin.knowledge.started": "Started",
  "admin.knowledge.ready": "Ready",
  "admin.knowledge.stopping": "Stopping",
  "admin.knowledge.queued": "Waiting work",
  "admin.knowledge.activeWork": "Active work",
  "admin.knowledge.suspended": "Suspended / resumable",
  "admin.knowledge.failed": "Failures",
  "admin.knowledge.throughput": "Succeeded / 5 min",
  "admin.knowledge.noReadyInstances": "Capacity requested, no ready instance observed",
  "admin.knowledge.oldest": "Oldest",
  "admin.knowledge.activityHelp": "Instances come from a recent Docker observation. Work comes from PostgreSQL, not RabbitMQ message counts. A suspended acquisition releases its worker; one render instance may have several active slots.",
  "admin.knowledge.operations": "Ingestion controls",
  "admin.knowledge.capacity": "Desired instances",
  "admin.knowledge.capacityHelp": "One task per instance. Zero pauses the stage after active tasks drain, without deleting work. Rendering has its own Chromium slots.",
  "admin.knowledge.browserPlaces": "Chromium slots per render instance",
  "admin.knowledge.revision": "Revision",
  "admin.knowledge.budget": "Reserved resources",
  "admin.knowledge.budgetExceeded": "This capacity exceeds the approved budget. Reduce the counts or have the VPS budget reviewed.",
  "admin.knowledge.capacityUnavailable": "Configuration unavailable. Existing instances are preserved; this is not a request to scale to zero.",
  "admin.knowledge.saveCapacity": "Apply this capacity",
  "admin.knowledge.createIngestionRequest": "Start an ingestion request",
  "admin.knowledge.explicitUrls": "One URL per line, up to 100. No automatic crawl. An ingestion request through indexing may call the configured embedding provider.",
  "admin.knowledge.urls": "Sources to ingest (one URL per line)",
  "admin.knowledge.throughStage": "Process through",
  "admin.knowledge.chunking.title": "Passage splitting",
  "admin.knowledge.chunking.maxTokens": "Maximum tokens per chunk",
  "admin.knowledge.chunking.maxTokensHelp": "Includes titles and overlap. Choose an integer from 1 to {maximum}; a chunk may be shorter. This size stays fixed for the entire request.",
  "admin.knowledge.chunking.sizeSummary": "Maximum: {amount} tokens per chunk",
  "admin.knowledge.embedding.title": "Vector model",
  "admin.knowledge.embedding.model": "Model",
  "admin.knowledge.embedding.provider": "Provider",
  "admin.knowledge.embedding.dimensions": "Dimensions",
  "admin.knowledge.embedding.profile": "Recorded profile",
  "admin.knowledge.embedding.help":
    "This choice is retained with the request. Compare models using separate requests; their vectors are not interchangeable.",
  "admin.knowledge.embedding.indexHelp":
    "The knowledge-base index uses one model so its vectors remain comparable. To test another model, stop this request at the Embedding stage.",
  "admin.knowledge.embedding.unknown": "Retained model not recorded",
  "admin.knowledge.chunking.help": "These choices are kept for the entire request. Overlap repeats at most {maximum} % of the previous passage’s tokens, excluding titles. It may be reduced to respect chunk size and document structures.",
  "admin.knowledge.chunking.overlap": "Overlap",
  "admin.knowledge.chunking.none": "None (0)",
  "admin.knowledge.chunking.tokens": "Token count",
  "admin.knowledge.chunking.percent": "Percentage of the previous passage",
  "admin.knowledge.chunking.quantity": "Requested amount",
  "admin.knowledge.chunking.boundary": "Prefer breaks",
  "admin.knowledge.chunking.word": "Between words",
  "admin.knowledge.chunking.sentence": "At sentence ends (when a sentence fits in a chunk)",
  "admin.knowledge.chunking.tokenAmount": "{amount} tokens",
  "admin.knowledge.chunking.percentAmount": "{amount} %",
  "admin.knowledge.chunking.invalid": "Choose a positive integer chunk size and amount within the displayed limits.",
  "admin.knowledge.urlSelectionInvalid": "Enter between 1 and 100 explicit URLs.",
  "admin.knowledge.cancelIngestionRequest": "Cancel remaining work",
  "admin.knowledge.cancelConfirm": "Cancel waiting work and request active work to stop? Saved results and their history will be preserved.",
  "admin.knowledge.commandSaved": "Command saved. The manager applies capacity; workers continue authorized work.",
  "admin.knowledge.commandFailed": "Command not confirmed. Retry the same request: its identity is preserved to prevent duplication.",
  "admin.knowledge.conflict": "The configuration or command has changed. Reload the page and review the values before trying again.",
  "admin.knowledge.title": "Knowledge ingestion",
  "admin.knowledge.description": "Follow each source through its attempts and blockers. This inspection does not change Agents.",
  "admin.knowledge.company": "Company ID",
  "admin.knowledge.inspect": "View ingestion requests",
  "admin.knowledge.unavailable": "Inspection is unavailable. Check Knowledge Management, then reload this page.",
  "admin.knowledge.ingestionRequests": "Recent ingestion requests (up to 50)",
  "admin.knowledge.empty": "No ingestion requests for this company.",
  "admin.knowledge.sources": "Source journey",
  "admin.knowledge.waitingRender": "Acquisition is waiting for a durable web-render result. Its worker is free; other sources can progress.",
  "admin.knowledge.notStarted": "No attempt recorded for this stage.",
  "admin.knowledge.render": "Delegated web render",
  "admin.knowledge.eligibleAt": "Next execution eligible from",
  "admin.knowledge.artifact": "View private artifact",
  "admin.knowledge.expires": "Expires",
  "admin.knowledge.inert": "Displayed as text only. No scripts or remote resources are executed.",
  "admin.knowledge.sources.title":
    "Passage origins — up to the first {count} locations",
  "admin.knowledge.sources.captureOnly":
    "These locations describe the captured version. The website may have changed; navigation and highlighting depend on its current content and your browser.",
  "admin.knowledge.sources.revision": "Document revision",
  "admin.knowledge.sources.textRange":
    "Exact positions retained within the original excerpt; the link may target the whole element.",
  "admin.knowledge.sources.elementOnly":
    "Element or section location, without exact positions in the original text.",
  "admin.knowledge.sources.documentOnly": "Source document known, without a reliable passage location.",
  "admin.knowledge.sources.reason.ELEMENT_NOT_IN_CAPTURE": "Document only: the element was not found in the original capture.",
  "admin.knowledge.sources.reason.NO_RELIABLE_LOCATION": "Document only: no reliable passage location could be retained.",
  "admin.knowledge.sources.open": "Open the current source",
  "admin.knowledge.expired": "Content expired or unavailable. Metadata remains available; no acquisition is triggered.",
  "admin.knowledge.providerReceipt": "Provider receipt and accounting state",
  "admin.knowledge.stage.acquisition": "1. Acquisition",
  "admin.knowledge.stage.normalization": "2. Normalization",
  "admin.knowledge.stage.chunking": "3. Chunking",
  "admin.knowledge.stage.embedding": "4. Embedding",
  "admin.knowledge.stage.indexing": "5. Indexing",
  "admin.knowledge.status.QUEUED": "Waiting for execution",
  "admin.knowledge.status.RUNNING": "Running",
  "admin.knowledge.status.WAITING": "Suspended, waiting for render",
  "admin.knowledge.status.RESUMABLE": "Result available, waiting to resume",
  "admin.knowledge.status.SUCCEEDED": "Succeeded",
  "admin.knowledge.status.FAILED": "Failed",
  "admin.knowledge.status.CANCELLED": "Cancelled",
  "admin.knowledge.status.INTERRUPTED": "Interrupted, outcome unknown",
  "admin.company.usageLoadError":
    "Usage could not be loaded. Reload the page to try again.",
  "admin.supportDelivery.loadError":
    "Support delivery status could not be loaded.",
  "admin.supportDelivery.loading": "Checking support deliveries…",
  "admin.supportDelivery.title": "Support request deliveries",
  "admin.supportDelivery.historical":
    "Recorded delivery outcomes. A saved request or a successful Agent turn does not prove delivery to Slack. Fixing Slack does not automatically resend blocked requests.",
  "admin.supportDelivery.truncated":
    "Only the 100 most recently updated deliveries are shown.",
  "admin.supportDelivery.action.CHECK_CHANNEL":
    "Check the Slack channel ID and invite the ChatSystem app to that channel. Slack could not access it.",
  "admin.supportDelivery.action.INVITE_BOT":
    "Invite the ChatSystem app to the Slack channel. It was not a member when delivery was attempted.",
  "admin.supportDelivery.action.CHANGE_CHANNEL":
    "The Slack channel was archived. Select an active channel in the Tool settings.",
  "admin.supportDelivery.action.REAUTHORIZE":
    "Update the Slack authorization from the Tool settings, then check channel access.",
  "admin.supportDelivery.action.CHECK_CONFIGURATION":
    "Delivery was rejected. Check the connection and channel in the Tool settings. The retained error does not establish a more precise cause.",
  "admin.supportDelivery.action.VERIFY_DELIVERY":
    "Delivery is uncertain. Verify the destination before any resend to avoid a duplicate.",
  "discussion.toolsUnavailable.customer":
    "{count, plural, one {One Tool is missing for this reply} other {Several Tools (#) are missing for this reply}}: {tools}.",
  "discussion.toolsUnavailable.admin":
    "The following Tools could not be offered during this turn: {tools}.",
  "discussion.toolsUnavailable.checkVersion":
    "Your client version may be out of date. Could you check that you are using the latest version of {packageLink}, available on npm?",
  "discussion.toolsUnavailable.checkConfiguration":
    "{count, plural, one {The Tool {tools} may not be configured correctly. Could you check its configuration in {settingsLink}?} other {The Tools {tools} may not be configured correctly. Could you check their configuration in {settingsLink}?}}",
  "discussion.toolsUnavailable.agentSettings": "your Agent’s settings",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.unknown":
    "Unable to verify Slack right now. Try checking again.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.reconnect":
    "The Slack connection is no longer valid. Reconnect your workspace.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.connected":
    "Connected to Slack",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.button":
    "Test connection",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.again":
    "Test again",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.recommended":
    "We recommend a quick test to confirm that this tool’s notifications reach this channel.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.recommendedLabel":
    "Channel not yet tested for this tool",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.verifiedLabel":
    "Channel tested for this tool",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.sending":
    "Sending…",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.hint":
    "A short test message will be sent to the channel saved for this Tool.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.saveFirst":
    "Save your channel so you can send the test message there.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.SENT":
    "Your test message is on its way! You can find it in your Slack channel.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.NOT_CONFIGURED":
    "To give it a try, first save this Tool’s Slack connection and channel.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.CHANNEL_INACCESSIBLE":
    "We couldn’t send the message to this channel. Could you check the channel and invite the ChatSystem app, then try again?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.CHANNEL_ARCHIVED":
    "This Slack channel is archived. Could you choose an active channel, then try again?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.RECONNECT_REQUIRED":
    "Your Slack connection needs to be renewed. Could you reconnect your workspace, then try again?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.MISSING_PERMISSION":
    "A permission is missing to send the message. Could you update the Slack authorization, then try again?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.UNAVAILABLE":
    "The test couldn’t complete just now. Could you try again in a minute?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.test.result.UNCERTAIN":
    "We haven’t received confirmation. The message may have arrived: could you check your Slack channel before trying again?",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.ready":
    "ChatSystem has access to the configured channel. This check does not send a test message.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.noChannel":
    "Select and save a channel to receive requests.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.unavailable":
    "The configured channel is inaccessible. Check its ID and invite the ChatSystem app to that channel.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.notMember":
    "Invite the ChatSystem app to the configured channel, then check again.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.archived":
    "This channel is archived. Choose an active channel.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.permissions":
    "Slack permissions are incomplete. Update the Slack authorization.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.health.channelUnknown":
    "Channel access could not be verified. Try checking again.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.manageAuthorization":
    "Update Slack authorization",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.checkAgain":
    "Check again",
  "admin.agentTurn.compact.title": "Agent execution",
  "admin.agentTurn.compact.calls": "Tools called",
  "admin.agentTurn.compact.trace": "View technical trace ({count} events)",
  "admin.agentTurn.compact.promptReference":
    "Prompt #{number} — available above, not repeated here.",
  "admin.agentTurn.compact.export": "Download raw evidence (JSON)",
  "admin.discussion.systemInstructions": "System instructions — message #{id}",
  "myAccount.supportRequests.detail.loading": "Loading request details…",
  "myAccount.supportRequests.detail.retry": "Try again",
  "admin.agentTurn.tools.unknown":
    "The complete Tool list could not be read. Consult the retained technical evidence.",
  "admin.agentTurn.tools.resume":
    "Resuming {functionName}. No new functions are advertised to the model.",
  "admin.agentTurn.tools.count": "Available Tools: {count}",
  "admin.agentTurn.tools.providerCount":
    "Functions advertised in this request: {count}",
  "admin.agentTurn.tools.instructions":
    "Tool descriptions and instruction sources",
  "admin.agentTurn.tools.schema": "Input schema",
  "admin.agentTurn.tools.excluded": "Excluded Tools",
  "admin.agentTurn.source.AGENT_OVERRIDE":
    "Instructions overridden for this Agent",
  "admin.agentTurn.source.TOOL_DEFAULT": "Default Tool instructions",
  "admin.agentTurn.source.FUNCTION_DESCRIPTION":
    "Function description used as instructions",
  "admin.agentTurn.legacy":
    "6.3: original system messages are sent unchanged. Tool instructions describe the resolved configuration, not a recomposed historical prompt.",
  "admin.agentTurn.unknown": "Unknown",
  "admin.agentTurn.yes": "Yes",
  "admin.agentTurn.no": "No",
  "admin.agentTurn.protocol.absent": "None",
  "admin.agentTurn.header.SUPPORTED": "Recognized",
  "admin.agentTurn.header.MISSING": "Missing",
  "admin.agentTurn.header.INVALID": "Invalid",
  "admin.agentTurn.admission.requested": "Requested protocol",
  "admin.agentTurn.admission.header": "Protocol header",
  "admin.agentTurn.admission.effective": "Effective protocol",
  "admin.agentTurn.admission.enabled": "Continuation enabled in process",
  "admin.agentTurn.admission.token": "App Token present",
  "admin.agentTurn.reason.INTERACTIVE_WIDGET_PROTOCOL_REQUIRED":
    "Required interactive protocol unavailable: check the prerequisites below.",
  "admin.agentTurn.reason.LOCAL_PREVIEW_UNAVAILABLE":
    "Local preview unavailable",
  "admin.agentTurn.reason.DEMO_EXECUTION_NOT_AUTHORIZED":
    "Execution not authorized for this demo",
  "admin.agentTurn.reason.DELEGATED_EXECUTION_DISABLED":
    "Delegated execution disabled",
  "admin.agentTurn.reason.IDENTITY_REQUIRED": "Visitor identity required",
  "admin.agentTurn.reason.IDENTITY_EXPIRED": "Visitor identity expired",
  "admin.agentTurn.citations.reference": "Source {number} · result {position} of the call",
  "admin.agentTurn.citations.saved": "Sources saved with this response",
  "admin.agentTurn.citations.origin.web_page": "Web page read",
  "admin.agentTurn.citations.origin.search_excerpt": "Search preview, not a downloaded page",
  "admin.agentTurn.citations.origin.indexed_document": "Company indexed document",
  "admin.agentTurn.citations.reused": "Source from an earlier turn",
  "admin.agentTurn.citations.new": "Source found during this turn",
  "admin.agentTurn.citations.toolResult": "View the Tool result in this discussion",
  "admin.agentTurn.citations.diagnostic": "Removed reference or missing citation (not shown to the visitor)",
  "admin.agentTurn.event.CITATION_EVIDENCE_REJECTED": "Saved source excluded from the model request",
  "admin.agentTurn.event.CITATIONS_PREPARED": "Citation references checked",
  "admin.agentTurn.event.CITATIONS_PERSISTED": "Response and citations saved",
  "admin.agentTurn.event.CITATIONS_STREAM_WRITE_ATTEMPTED": "Final metadata written to the stream (not browser acknowledgement)",
  "admin.agentTurn.event.CONTEXT_RESOLVED": "Turn configuration resolved",
  "admin.agentTurn.event.PROVIDER_REQUEST": "Request sent to the model",
  "admin.agentTurn.event.PROVIDER_RESPONSE_HEADERS":
    "Provider response received",
  "admin.agentTurn.event.PROVIDER_TRANSPORT_FAILED":
    "Provider transport failed",
  "admin.agentTurn.event.TOOL_STARTED": "Tool execution started",
  "admin.agentTurn.event.TOOL_RETURNED": "Tool returned a result",
  "admin.agentTurn.event.TOOL_FAILED": "Tool execution failed",
  "admin.agentTurn.event.TOOL_SUSPENDED":
    "Turn waiting for visitor interaction",
  "admin.agentTurn.event.SESSION_COMPLETED": "Model response completed",
  "admin.agentTurn.event.SESSION_FAILED": "Model response failed",
  "admin.agentTurn.event.TURN_FAILED": "Turn failed",
  "admin.agentTurn.event.TURN_PERSISTED": "Conversation saved",
  "admin.agentTurn.event.TURN_PERSISTENCE_FAILED":
    "Conversation could not be saved",
  "admin.agentTurn.event.CONTINUATION_COMPLETED": "Continuation completed",
  "admin.agentTurn.event.CONTINUATION_COMPLETION_FAILED":
    "Continuation could not be finalized",
  "admin.agentTurn.title": "Agent turn — execution evidence",
  "admin.agentTurn.unreadable":
    "This execution record is incomplete or uses an unsupported version. It does not mean that no Tools were available.",
  "admin.agentTurn.historical":
    "Configuration resolved for this execution. Later configuration changes do not modify this record.",
  "admin.agentTurn.prompt": "Effective system prompt",
  "admin.agentTurn.configuration":
    "Instructions, sources and available functions",
  "admin.agentTurn.details": "Technical details and retained payloads",
  "admin.agentTurn.truncated":
    "Bounded snapshot: the full content was not retained. The fingerprint covers the complete input.",
  "generic.language.english": "English",
  "generic.language.french": "French",
  "generic.connect.google": "Connect with Google",
  "generic.button.title.save": "Save",
  "generic.crud.create.cta": "Create",
  "generic.use.none": "None",
  "generic.use.next": "Next",
  "generic.dataType.string": "character strings",
  "generic.dataType.string.developped":
    "various words and texts, URL and others",
  "generic.dataType.boolean": "true / false",
  "generic.dataType.boolean.developped":
    "a value that can only be true or false, like yes or no",
  "generic.dataType.number": "figures and numbers",
  "generic.dataType.number.developped":
    "any kind of number. Can not contain any word.",
  "generic.dataType.date": "dates",
  "generic.dataType.date.developped":
    "any kind of dates, containing at least the year",
  "generic.dataType.enum": "defined list",
  "generic.dataType.enum.developped":
    "list that contains only limited and known values",
  "generic.form.dropdown.placeholder": "Select ...",
  "generic.form.uploadButton.label": "Choose image",
  "generic.form.uploadButton.hint": "PNG, JPG, WebP… up to 10MB.",
  "generic.form.uploadButton.drop": "Or drag & drop your image here",
  "generic.form.uploadButton.preview": "Preview",
  "generic.form.uploadButton.loading": "Uploading…",
  "generic.save": "Save",
  "locale.en-US.label": "English",
  "locale.fr-FR.label": "French",
  "generic.delete": "Delete",
  "generic.cancel": "Cancel",
  "generic.close": "Close",
  "generic.name": "Name",
  "generic.description": "Description",
  "generic.deleting.ellipsis": "Deleting ...",
  "generic.notification.error": "There has been an error. Please try later.",
  "generic.notification.error.showMessage":
    "There has been an error while doing the operation. Error :",
  "generic.contactUs.calendly": "Book a call",
  "generic.demo.calendly": "Book",
  "generic.loading": "Loading...",

  "myAccount.page.myAgents.edit.tools.customerSupport.slack.title":
    "Slack customer support",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.description":
    "Connect Slack, create or choose a support channel, invite the bot, then paste the channel ID here.",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.slack.title":
    "Also receive requests in Slack — optional",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.slack.description":
    "Each new request will be automatically published in the selected Slack channel so your team can process it and contact the visitor. We recommend creating a dedicated channel, for example #customer-requests, to keep requests visible and easy to follow.",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.slack.configured":
    "New requests will be automatically sent to the configured Slack channel ({channelId}).",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.slack.persistence":
    "Requests remain saved in ChatSystem even when Slack is not connected.",
  "myAccount.page.leftMenu.supportRequests": "Customer requests",
  "myAccount.supportRequests.title": "Customer requests",
  "myAccount.supportRequests.description":
    "Review requests collected by your Agents and keep their follow-up status up to date.",
  "myAccount.supportRequests.filter.status": "Status",
  "myAccount.supportRequests.filter.agent": "Agent",
  "myAccount.supportRequests.status.open": "Open",
  "myAccount.supportRequests.status.resolved": "Resolved",
  "myAccount.supportRequests.status.all": "All",
  "myAccount.supportRequests.agent.all": "All Agents",
  "myAccount.supportRequests.loading": "Loading requests...",
  "myAccount.supportRequests.error.load": "The requests could not be loaded.",
  "myAccount.supportRequests.error.detail":
    "The request details could not be loaded.",
  "myAccount.supportRequests.error.update":
    "The request status could not be updated.",
  "myAccount.supportRequests.empty": "No request matches these filters.",
  "myAccount.supportRequests.redacted":
    "Content deleted according to the retention policy.",
  "myAccount.supportRequests.select": "Select a request to see its details.",
  "myAccount.supportRequests.contact": "Contact",
  "myAccount.supportRequests.message": "Request",
  "myAccount.supportRequests.resolve": "Mark as resolved",
  "myAccount.supportRequests.reopen": "Reopen",
  "myAccount.supportRequests.discussion": "View conversation",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.connect":
    "Connect Slack",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.reconnect":
    "Reconnect Slack",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.connecting":
    "Connecting...",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.loading":
    "Loading Slack setup...",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.connected":
    "Connected to workspace {workspace}.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.notConnected":
    "Slack is not connected yet.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.step.connect":
    "Connect this ChatSystem tool to your Slack workspace.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.step.channel":
    "Create a dedicated support channel, or choose an existing one.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.step.invite":
    "Invite the ChatSystem bot to that Slack channel.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.step.channelId":
    "Paste the Slack channel ID below and save.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.channelId.label":
    "Slack channel ID",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.saveChannel":
    "Save channel",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.saving":
    "Saving...",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.channelHint":
    "Use the Slack channel ID, not the channel name. Public channel IDs usually start with C; private channel IDs usually start with G.",
  "myAccount.page.myAgents.edit.operatorLocale.title":
    "Company communication language",
  "myAccount.page.myAgents.edit.operatorLocale.description":
    "Used whenever this agent sends operational messages to your company team.",
  "myAccount.page.myAgents.edit.operatorLocale.inherit":
    "Company language ({language})",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.load.error":
    "Failed to load Slack customer support setup.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.activationLoad.error":
    "Failed to load customer support tool activation.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.connect.error":
    "Failed to connect Slack.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.channel.required":
    "Please enter the Slack channel ID.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.workspace.required":
    "Connect Slack before saving a support channel.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.workspace.reused":
    "Your company’s Slack workspace is connected. Select and save this Tool’s channel.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.channel.saved":
    "Slack customer support channel saved.",
  "myAccount.page.myAgents.edit.tools.customerSupport.slack.toast.channel.error":
    "Failed to save Slack support channel.",

  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.title":
    "Support business hours",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.description":
    "Show a contact form immediately when live support is outside configured hours.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.timezone":
    "Timezone",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedCaptureEnabled":
    "Show closed-hours form",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.schedule":
    "Weekly schedule",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.require.email":
    "Email required",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.require.phone":
    "Phone required",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.require.reason":
    "Reason required",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.requiredFieldsDescription":
    "Data requested from the customer so support can contact them again.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.addInterval":
    "Add time slot",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.removeInterval":
    "Remove",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDay":
    "Closed",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.title":
    "Public holidays",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.calendar":
    "Calendar",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.description":
    "Public holidays are added as closed days. You can edit or remove them.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.reset":
    "Reset holidays",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.addAll":
    "Add all public holidays",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.toast.load.error":
    "Unable to load public holidays.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.holidays.toast.empty":
    "No public holiday preset is available for this calendar.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.title":
    "Closed days",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.description":
    "Live chat stays closed on these dates, using the support timezone.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.add":
    "Add closed day",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.remove":
    "Remove",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.closedDays.empty":
    "No closed day configured.",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.from":
    "from",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.to": "to",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.monday":
    "Monday",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.tuesday":
    "Tuesday",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.wednesday":
    "Wednesday",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.thursday":
    "Thursday",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.friday":
    "Friday",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.saturday":
    "Saturday",
  "myAccount.page.myAgents.edit.tools.customerSupport.businessHours.day.sunday":
    "Sunday",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.title":
    "Fallback contact capture",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.description":
    "Ask for email and phone when support has not replied after the configured delay.",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.timeout":
    "Delay before form (minutes)",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.requireEmail":
    "Require email",
  "myAccount.page.myAgents.edit.tools.customerSupport.fallback.requirePhone":
    "Require phone",
  "myAccount.page.myAgents.edit.tools.directChatCustomerSupport.name":
    "Direct chat customer support",
  "myAccount.page.myAgents.edit.tools.directChatCustomerSupport.description":
    "Connect the customer with company support through live chat.",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.name":
    "Customer support request",
  "myAccount.page.myAgents.edit.tools.customerSupportRequest.description":
    "Collect a complete request and send it to your support team for an asynchronous reply.",
  "myAccount.page.myAgents.edit.tools.structuredForm.title": "Visitor form",
  "myAccount.page.myAgents.edit.tools.structuredForm.description":
    "Adapt the French and English copy, then choose the information your team needs.",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.title": "Title",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.submit":
    "Submit button",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.cancel":
    "Cancel button",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.success":
    "Confirmation message",
  "myAccount.page.myAgents.edit.tools.structuredForm.copy.description":
    "Introduction",
  "myAccount.page.myAgents.edit.tools.structuredForm.remove": "Remove",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.label": "Label",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.placeholder":
    "Placeholder",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type": "Field type",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.text": "Text",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.email": "Email",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.tel": "Phone",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.textarea":
    "Long text",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.select":
    "Choice list",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.type.checkbox":
    "Checkbox",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.visible": "Visible",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.required":
    "Required",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.moveUp":
    "Move field up",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.moveDown":
    "Move field down",
  "myAccount.page.myAgents.edit.tools.structuredForm.field.add": "Add a field",
  "myAccount.page.myAgents.edit.tools.structuredForm.option.value":
    "Option value",
  "myAccount.page.myAgents.edit.tools.structuredForm.option.label":
    "Option label",
  "myAccount.page.myAgents.edit.tools.structuredForm.option.remove":
    "Remove option",
  "myAccount.page.myAgents.edit.tools.structuredForm.option.add": "Add option",

  "site.global.tabTitle":
    "Chatsystem.ai | Sales Agent for your ecommerce products",
  "site.global.description": "Please your customers with the best AI advice",

  "pagination.previous": "previous",
  "pagination.next": "next",

  "discussion.internal.label": "Internal Test",
  "discussion.internal.yes": "Yes",
  "discussion.internal.no": "No",
  "admin.discussion.origin.label": "Origin",
  "admin.discussion.origin.all": "All origins",
  "admin.discussion.origin.customer": "Customer",
  "admin.discussion.origin.internalTest": "Internal test",
  "admin.discussion.origin.acquisitionDemo": "Acquisition demo",
  "admin.discussion.origin.openAcquisition": "Open acquisition dashboard",
  "message.origin.audio.label": "Audio",
  "message.origin.audio.tooltip": "Message was audio",
  "message.author.customerSupportOperator.label": "Customer support",
  "admin.page.companies.monthlyReports.title": "Monthly Reports",
  "admin.page.companies.monthlyReports.description":
    "Generate and review customer-facing monthly activity reports per agent.",
  "admin.page.companies.monthlyReports.auto.enabled":
    "Auto monthly reporting enabled",
  "admin.page.companies.monthlyReports.auto.disabled":
    "Auto monthly reporting disabled",
  "admin.page.companies.monthlyReports.manualHint":
    "Automatic generation runs on the fourth day of the month for companies with activity reporting enabled. You can also generate the previous month manually here.",
  "admin.page.companies.monthlyReports.empty.salesAgents":
    "No sales agent is available for monthly activity reporting.",
  "admin.page.companies.monthlyReports.agent.label": "Sales Agent",
  "admin.page.companies.monthlyReports.monthInput.label": "Report month",
  "admin.page.companies.monthlyReports.generateMonth": "Generate {month}",
  "admin.page.companies.monthlyReports.button.loading": "Generating...",
  "admin.page.companies.monthlyReports.button.default": "Generate report",
  "admin.page.companies.monthlyReports.available": "Available reports",
  "admin.page.companies.monthlyReports.loading": "Loading...",
  "admin.page.companies.monthlyReports.count": "{count} reports",
  "admin.page.companies.monthlyReports.empty.reports":
    "No monthly reports available yet.",
  "admin.page.companies.monthlyReports.conversations": "{count} conversations",
  "admin.page.companies.monthlyReports.toast.load.error":
    "Failed to load monthly reports.",
  "admin.page.companies.monthlyReports.toast.generate.error":
    "Failed to generate monthly report.",
  "admin.page.companies.monthlyReports.toast.generate.success":
    "Monthly report generated.",
  "admin.page.companies.monthlyReports.chart.total": "Total",
  "admin.page.companies.monthlyReports.chart.empty": "No data found.",
  "admin.page.companies.monthlyReports.report.toast.company.error":
    "Failed to load company.",
  "admin.page.companies.monthlyReports.report.toast.load.error":
    "Failed to load monthly report.",
  "admin.page.companies.monthlyReports.report.loading":
    "Loading monthly report...",
  "admin.page.companies.monthlyReports.report.error":
    "We could not load this monthly report.",
  "admin.page.companies.monthlyReports.report.eyebrow": "ChatSystem Report",
  "admin.page.companies.monthlyReports.report.generatePdf":
    "Generate report PDF",
  "admin.page.companies.monthlyReports.report.generatePdf.loading":
    "Generating PDF...",
  "admin.page.companies.monthlyReports.report.regeneratePdf":
    "Regenerate report PDF",
  "admin.page.companies.monthlyReports.report.downloadPdf": "Download PDF",
  "admin.page.companies.monthlyReports.report.downloadDiscussionExportPdf":
    "Download discussions PDF",
  "admin.page.companies.monthlyReports.report.back": "Back to company",
  "admin.page.companies.monthlyReports.report.toast.generatePdf.success":
    "PDF generated successfully.",
  "admin.page.companies.monthlyReports.report.toast.generatePdf.error":
    "Failed to generate PDF.",
  "admin.page.companies.monthlyReports.report.metrics.conversations":
    "Conversations",
  "admin.page.companies.monthlyReports.report.metrics.resolved": "Resolved",
  "admin.page.companies.monthlyReports.report.metrics.unresolved": "Unresolved",
  "admin.page.companies.monthlyReports.report.executiveSummary":
    "Executive Summary",
  "admin.page.companies.monthlyReports.report.chart.intents.title":
    "Discussion intents",
  "admin.page.companies.monthlyReports.report.chart.intents.subtitle":
    "Distribution by primary intent",
  "admin.page.companies.monthlyReports.report.chart.intents.total":
    "Conversations",
  "admin.page.companies.monthlyReports.report.chart.strengths.title":
    "What works well",
  "admin.page.companies.monthlyReports.report.chart.strengths.subtitle":
    "Top resolved intent groups",
  "admin.page.companies.monthlyReports.report.chart.strengths.total":
    "Resolved",
  "admin.page.companies.monthlyReports.report.chart.improvements.title":
    "Evolution recommendations",
  "admin.page.companies.monthlyReports.report.chart.improvements.subtitle":
    "Top unresolved intent groups",
  "admin.page.companies.monthlyReports.report.chart.improvements.total":
    "Unresolved",
  "admin.page.companies.monthlyReports.report.highlights.title":
    "Conversation examples",
  "admin.page.companies.monthlyReports.report.highlights.subtitle":
    "A selection of representative customer conversations from this month.",
  "admin.page.companies.monthlyReports.report.highlights.empty":
    "No conversation example was selected for this month.",
  "admin.page.companies.monthlyReports.report.highlights.rank":
    "Example #{rank}",
  "admin.page.companies.monthlyReports.report.strengths.title":
    "What Works Well",
  "admin.page.companies.monthlyReports.report.strengths.empty":
    "No strength insight is available for this month.",
  "admin.page.companies.monthlyReports.report.improvements.title":
    "Evolution Recommendations",
  "admin.page.companies.monthlyReports.report.improvements.empty":
    "No improvement recommendation is available for this month.",
  "admin.page.companies.monthlyReports.report.highlightReason.productClick":
    "Resolved with product click",
  "admin.page.companies.monthlyReports.report.highlightReason.shopInfo":
    "Used shop-specific information",
  "admin.page.companies.monthlyReports.report.highlightReason.criteria":
    "Recommendation by criteria",
  "admin.page.companies.monthlyReports.report.highlightReason.similar":
    "Similar product example",
  "admin.page.companies.monthlyReports.report.highlightReason.exact":
    "Exact product lookup",
  "admin.page.companies.monthlyReports.report.highlightReason.representative":
    "Representative discussion",

  "textarea.placeholder.nonBoolean.semanticDescription":
    "Ex: The size of the clothe",
  "textarea.placeholder.boolean.semanticDescription":
    "Ex: Is that meal gluten free?",
  "textarea.errorMessage.minLength0":
    "This sentence is very important to help the robot analyze what the customer is asking.",
  "textarea.errorMessage.shouldEndWithQuestionMark":
    "In case of true/false column, your description must be a question. Example: Is this dish vegetarian? The sentence must finish with a question mark.",
  "input.placeholder.columnName": "Ex: Type of Boardgames",
  "input.errorMessage.minLength0":
    "This field is mandatory for the robot to understand what is the data about. Give a name a friend would understand.",

  "page.login.button.login": "Login / Register",
  "page.login.personalizedDemo.title": "Sign in to create your free demo",
  "page.login.personalizedDemo.description":
    "You will then return directly to the website you entered to prepare your personalized Agent.",
  "page.login.google.login": "Continue with Google",
  "page.login.localDevelopment.title": "Local development",
  "page.login.localAdmin.login": "Sign in as administrator",
  "page.login.localOnboarding.login": "Test a fresh customer workspace",

  "navbar.button.home": "Home",
  "navbar.button.pricing": "Pricing",
  "navbar.button.login": "Login",
  "navbar.button.demo": "Try",
  "navbar.userMenu.logout": "Log out",
  "navbar.userMenu.profile": "Profile",
  "navbar.userMenu.admin": "Admin",
  "navbar.userMenu.backOffice": "Back-office",

  "home.header.catchphase": "Finally a smart chatbot",
  "home.header.subcatchphase":
    "Discover the chatbot that knows your products inside out",
  "home.header.CTA": "See more",

  "home.sloganHeader.slogan":
    "The AI assistant that recommends the right product",
  "home.sloganHeader.slogan.otherTry":
    "Every visitor deserves a good recommendation.",
  "home.sloganHeader.slogan.sub":
    "Discover a specialized agent that understands your business inside and out",
  "home.sloganHeader.slogan.sub.otherTry":
    "Guide your visitors to the right product with an AI assistant that knows your catalogue perfectly.",
  "home.sloganHeader.slogan.cta": "See the demo",
  "home.sloganHeader.slogan.tryTool": "Try",
  "home.sloganHeader.slogan.contactUs": "Contact Us",
  "home.sloganHeader.badge.title": "Shopping IA",
  "home.sloganHeader.badge.text": "Ideal for e-commerce teams",

  "home.section.bulletsPointSection.title": "Why Choose Us",

  "home.section.bulletsPointParagraphe1.title": "Relevant",
  "home.section.bulletsPointParagraphe1.b.title": "Sales-playbook aligned",
  "home.section.bulletsPointParagraphe1.text":
    "Makes the best product recommendations based on your inventory and customer demand",
  "home.section.bulletsPointParagraphe1.b.text":
    "Speaks in your brand voice, follows your rules, and sells your way. Every answer feels consistent—like your best rep, on their best day.",

  "home.section.bulletsPointParagraphe2.title": "Listening",
  "home.section.bulletsPointParagraphe2.text":
    "Really understands your customers and their purchase intent before responding to them",
  "home.section.bulletsPointParagraphe2.b.title": "Catalog-intelligent",
  "home.section.bulletsPointParagraphe2.b.text":
    "Understands specs, constraints, compatibility, and real trade-offs. Not “here are options”—it explains why this is the right fit.",

  "home.section.bulletsPointParagraphe3.title": "Flexible",
  "home.section.bulletsPointParagraphe3.text":
    "Adjusts to customer requests to always provide an appropriate response",
  "home.section.bulletsPointParagraphe3.b.title": "Grounded recommendations",
  "home.section.bulletsPointParagraphe3.b.text":
    "Recommends from real stock and real business logic—not vibes. Customers get confident picks you can actually fulfill.",

  "home.section.video.showcase.title": "A quick, concrete demo—no fluff",
  "home.section.video.showcase.title.subtitle":
    "Watch the agent in action: precise answers, a consistent tone, and a smoother customer journey.",
  "home.section.video.showcase.tip.title": "Key highlight",
  "home.section.video.showcase.tip.text":
    "The chatbot adapts to the customer’s tone and follows your company’s sales approach.",

  "home.realm.title": "The next generation of artificial intelligence",
  "home.realm.text":
    "Next-generation AI is transforming online support: it’s no longer just a basic chatbot, but a true sales advisor. Our agent guides customers from intent to purchase with reliable, actionable recommendations, grounded in your real data.",
  "home.realm.cta": "Discover our solution",
  "home.realm.secondary.title": "See the root of your business in a few clicks",
  "home.realm.secondary.text":
    "The security of your data is at the heart of our concerns. Our software was created in France, we are ISO 27001 certified and all our servers are located in Europe.",
  "home.realm.secondary.cta": "Discover our solution",
  "home.realm.b1": "Available 24/7: every visitor gets instant answers.",
  "home.realm.b2":
    "Beginner to expert: adapts the depth of advice automatically.",
  "home.realm.b3":
    "Grounded recommendations: only what you can actually fulfill (stock, variants, constraints).",
  "home.realm.b4":
    "Turns “I’m not sure what I need” into a confident recommendation with clear trade-offs.",
  "home.realm.b5":
    "Improves conversion by removing doubt right before checkout.",

  "home.stats.eyebrow": "DESIGNED FOR E-COMMERCE TEAMS",
  "home.stats.title": "ChatSystem at a glance",
  "home.stats.subtitle":
    "Measurable impact on customer guidance and conversion—right where it matters: on your product pages.",
  "home.stats.performance.title": "Performance Overview",
  "home.stats.performance.title.md": "Overview",
  "home.stats.keyNumbers.title.md": "KPIs",
  "home.stats.s1": "incremental revenue",
  "home.stats.s2": "conversion on AI-assisted conversations",
  "home.stats.s3": "product advice automated on your website",
  "home.stats.s4": "available 24/7 for your customers",
  "home.stats.footnote":
    "Indicative figures based on deployments and pilot tests. Results vary depending on catalog and traffic.",

  "home.testimonials.title": "What our customers say",
  "home.testimonials.1.text":
    "Since using the software, we have better control of the flow of goods and relevant performance monitoring.",
  "home.testimonials.1.job": "Developer @Wordpress",
  "home.testimonials.1.name": "Loic Martins",
  "home.testimonials.2.text":
    "Putting the software solution into production allowed us to completely reorganize the teams.",
  "home.testimonials.2.job": "Community Manager @Comet",
  "home.testimonials.2.name": "Anna Wang",
  "home.testimonials.3.text":
    "Mastery of the logistics subject is obvious with the software solution.",
  "home.testimonials.3.job": "Product Owner @April",
  "home.testimonials.3.name": "Louis Bachant",
  "home.test.section.title": "Try it out now",
  "home.book.section.title": "Try our solution",
  "home.test.section.CTA": "See our solution",

  "home.section.faq.title": "Your most common questions",

  "home.section.faq.howIsThisDifferentFromOtherChatbots.title":
    "How is this different from other chatbots ?",
  "home.section.faq.howIsThisDifferentFromOtherChatbots.answer":
    "ChatSystem really knows how you sell and follows your commercial playbook. It is not just a generic chatbot plugged on an API. It is really bringing your expertise into the customer journey.",

  "home.section.faq.canItDoSomethingElse.title": "Can it do other things ?",
  "home.section.faq.canItDoSomethingElse.answer":
    "We can add custom functionalities to the chatbot depending on your needs. Agent and AI can do many things - please contact us.",

  "home.section.faq.isItGDPRCompatible.title": "Is it GDPR compliant ?",
  "home.section.faq.isItGDPRCompatible.answer":
    "Yes, we are fully GDPR compliant.",

  "home.section.faq.doesItSpeakSeveralLanguages.title":
    "Does it speak several languages?",
  "home.section.faq.doesItSpeakSeveralLanguages.answer":
    "The chatbot speaks many languages, including English, Spanish, French, and many others.",

  "home.section.faq.doesItWorkOnAnyProducts.title":
    "Does it work on any product?",
  "home.section.faq.doesItWorkOnAnyProducts.answer":
    "Yes, it does work on any product. It's a matter of setup between your company and ours, particularly your expertise.",

  "home.section.faq.isItEasyToImplement.title": "Is it easy to implement?",
  "home.section.faq.isItEasyToImplement.answer":
    "Yes. For a complete implementation, count about two weeks.",

  "home.section.faq.canItBeCustomed.title":
    "Can the look and feel be customized?",
  "home.section.faq.canItBeCustomed.answer":
    "Yes—completely. You can tailor the design to match your brand, including your visuals and styling.",

  "article.doesntExist":
    "This article does not exist. Please head back to the homepage.",

  "pricing.CTA.pleaseLogin": "Login to buy",
  "pricing.page.eyebrow": "ChatSystem pricing",
  "pricing.page.title": "A clear plan for every stage",
  "pricing.page.subtitle":
    "Give your Agents the capabilities of your choice from the catalogue of actions offered by ChatSystem to assist customers, generate leads and route requests to your support team.",
  "pricing.demo.badge": "Free personalized demo",
  "pricing.demo.title": "See what ChatSystem can do for your website",
  "pricing.demo.description":
    "Enter your website. ChatSystem prepares a personalized Agent you can test and share with your team before choosing a production plan.",
  "pricing.demo.feature.website": "An Agent prepared from your website",
  "pricing.demo.feature.test": "A real chatbot you can try",
  "pricing.demo.feature.share": "A link ready to share with your team",
  "pricing.plans.eyebrow": "Production plans",
  "pricing.plans.title": "Choose the plan that fits your traffic",
  "pricing.plans.introduction":
    "Try your personalized demo for free, then choose a plan when you’re ready.",
  "pricing.demo.card.title": "Personalized demo",
  "pricing.demo.card.free": "Free",
  "pricing.demo.card.noCard": "No card required",
  "pricing.demo.card.description":
    "Try an Agent built from your website and share it with your team before going live.",
  "pricing.demo.card.boundary":
    "A private preview to review and share. Choose a paid plan to install it on your website.",
  "pricing.plans.description":
    "Put your Agent online, connect its Tools and increase its capacity as your needs grow.",
  "pricing.page.toggle.yearly": "Yearly",
  "pricing.page.toggle.monthly": "Monthly",
  "pricing.page.toggle.saveUpTo": "Save up to {percent}%",
  "pricing.page.toggle.yearlyHelp":
    "One annual payment, with your usage capacity renewed every month.",
  "pricing.page.toggle.monthlyHelp":
    "Flexible monthly billing with no annual commitment.",
  "pricing.page.family.perMonth": "/ month",
  "pricing.page.family.billedYearly": "Billed yearly",
  "pricing.page.family.billedMonthly": "No commitment",
  "pricing.page.family.monthlyRenewalInfo":
    "Renews automatically every month. Cancel at any time; cancellation takes effect at the end of the paid billing period.",
  "pricing.page.family.onlyInterval": "Only available with {interval} billing",
  "pricing.page.family.aiResponsesMonthly": "maximum AI responses per month",
  "pricing.page.family.aiResponsesHelp":
    "Estimate based on standard AI responses. The actual number varies depending on the Tools used by the Agent.",
  "pricing.page.family.agents":
    "{count, plural, one {# Agent} other {# Agents}}",
  "pricing.page.family.agents.unlimited": "Unlimited Agents",
  "pricing.page.family.domains":
    "{count, plural, one {# domain} other {# domains}}",
  "pricing.page.family.domains.unlimited": "Unlimited domains",
  "pricing.page.family.members":
    "{count, plural, one {# team member} other {# team members}}",
  "pricing.page.family.members.unlimited": "Unlimited team members",
  "pricing.page.family.allTools": "All ChatSystem Tools",
  "pricing.page.family.whiteLabel": "No “Powered by ChatSystem” label",
  "pricing.page.family.directSupport": "Dedicated email support",
  "pricing.page.family.aiResponsesPeriod":
    "maximum AI responses per billing period",
  "pricing.page.family.flexibleCreditMonthly":
    "flexible usage credit renewed monthly",
  "pricing.page.family.flexibleCreditPeriod":
    "flexible usage credit for each billing period",
  "pricing.page.family.sharedTools":
    "AI responses and enabled search tools share the same credit",
  "pricing.page.family.topUp": "One-time top-ups to extend usage",
  "pricing.page.family.topUp.promotional": "One-time top-ups with bonus usage",
  "pricing.page.plan.highlight": "Recommended",
  "pricing.page.interval.month": "month",
  "pricing.page.interval.year": "year",
  "pricing.page.usageOnly": "Pay for what you use",
  "pricing.page.taxIncluded": "Prices include tax",
  "pricing.page.metered.block": "per {count} {metric}",
  "pricing.page.funding.postpaid": "Monthly usage limit: {amount}",
  "pricing.page.funding.uncapped": "Usage billed after consumption",
  "pricing.page.funding.periodic": "{amount} usage credit renewed {cadence}",
  "pricing.page.funding.cadence.monthly": "every month",
  "pricing.page.funding.cadence.period": "each billing period",
  "pricing.page.aiResponses.maximum": "Up to {count} AI responses per month",
  "pricing.page.funding.rolling":
    "{amount} usage credit included and carried forward",
  "pricing.page.funding.rechargePack": "{price}",
  "pricing.page.funding.rechargePack.promotion":
    "{price} paid → {credit} usage credit",
  "pricing.page.funding.rechargePacks": "Optional one-time top-ups: {packs}",
  "pricing.page.chooseOffer": "Choose this plan",
  "pricing.page.checkout.opening": "Opening secure checkout…",
  "pricing.page.checkout.error":
    "Secure checkout could not be opened. Please try again or contact support.",
  "billing.portal.offer.selectedFromPricing": "Selected on pricing page",
  "admin.publicOfferCatalog.load.error":
    "The public pricing catalogue could not be loaded. Refresh before changing its presentation.",
  "admin.subscriptionOffer.retire.confirm":
    "Stop offering this version to new customers? Existing subscriptions and their terms will remain unchanged.",
  "admin.subscriptionOffer.retire.error":
    "The offer could not be retired. Refresh and try again.",
  "admin.subscriptionOffer.retire.success":
    "The offer is no longer available to new customers. Existing subscriptions are unchanged.",
  "admin.subscriptionOffer.retire.pending": "Retiring…",
  "admin.subscriptionOffer.retire.action": "Stop offering",
  "pricing.page.custom.description":
    "We can create custom capabilities for your Agents, perfectly tailored to your company’s needs. The possibilities are extensive: contact us to design your solution together and receive a custom quote.",
  "pricing.page.custom.agents": "A number of Agents adapted to your needs",
  "pricing.page.custom.billing": "Flexible billing",
  "pricing.page.custom.volume": "Dedicated usage volumes and limits",
  "pricing.page.custom.integrations": "Custom Tool creation",
  "pricing.page.custom.support": "Contract and support adapted to your team",
  "pricing.page.unavailable.title": "Our plans are temporarily unavailable",
  "pricing.page.unavailable.description":
    "Please try again shortly or contact us.",
  "pricing.page.buttonText.buy": "Buy",
  "pricing.page.buttonText.YouAlreadyHaveIt": "Your current formula",
  "pricing.page.formula.feature.alreadySubbed": "Already Subscribed",
  "pricing.page.formulaName.fixedIncreasable": "Fixed renewable",
  "pricing.page.formulaName.fixedPlusDynamic": "Fixed + Variable",
  "pricing.page.formulaName.fullDynamic": "Fully variable",
  "pricing.page.formulaName.fullFixed": "Fixed capped",
  "pricing.page.formulaName.custom": "Custom",
  "pricing.enterprise.audience": "Enterprise",
  "pricing.enterprise.description":
    "Built for enterprises with multiple brands, multiple teams and specific business needs. Let’s design Agents that meet your ambitions together.",
  "pricing.enterprise.quote": "Custom quote",
  "pricing.enterprise.contact": "Let’s discuss your project",
  "pricing.enterprise.scope": "An offer built around your needs",
  "pricing.enterprise.agents.title": "Unlimited Agents",
  "pricing.enterprise.agents.description":
    "Agents for your brands, websites and teams, with no cap on their number in your custom plan.",
  "pricing.enterprise.behavior.title": "Behavior designed together",
  "pricing.enterprise.behavior.description":
    "Tone, answers, actions and team handoffs: we design your chatbots’ behavior with you around your business needs.",
  "pricing.enterprise.responses.title": "Unlimited AI responses",
  "pricing.enterprise.responses.description":
    "An uncapped response plan, quoted individually for the use cases we agree together.",
  "pricing.enterprise.analytics.title": "Tailored advanced analytics",
  "pricing.enterprise.analytics.description":
    "Conversions, request resolution and satisfaction: dashboards to be developed around your metrics.",
  "pricing.enterprise.integrations.title": "Business integrations",
  "pricing.enterprise.integrations.description":
    "CRM, catalogues and support: custom connections and actions designed with your teams.",
  "pricing.enterprise.partnership.title": "Dedicated partnership",
  "pricing.enterprise.partnership.description":
    "Rollout, performance reviews and priority support, with service commitments agreed together.",
  "pricing.page.buttonText.contactUs": "Contact us",
  "pricing.page.formula.feature.botAccess": "Chatbot Access",
  "pricing.page.formula.feature.limitedAccess": "Limited Access",
  "pricing.page.formula.feature.unlimitedAccess": "Illimited Access",
  "pricing.page.formula.feature.userFollowUp": "User Discussion Follow-up",
  "pricing.page.formula.feature.useAtscale": "Use at scale",
  "pricing.page.formula.feature.customMadeDev":
    "Custom development for your system",
  "pricing.page.formula.feature.smallBudget": "Small budget",

  "subscribe.paymentRecap.title": "Payment Summary",
  "subscribe.paymentRecap.customerName": "Name",
  "subscribe.paymentRecap.customerMail": "Email",
  "subscribe.paymentRecap.additionnalMention": "Mention to add",
  "subscribe.paymentRecap.totalAmount": "Total Amount",
  "subscribe.paymentForm.title": "Bank card",
  "subscribe.paymentForm.cardNumber": "Card number",
  "subscribe.paymentForm.expiresAt": "Expires at",
  "subscribe.paymentForm.CVCNumber": "CVC number",
  "subscribe.paymentForm.CTA.loading": "Loading ...",
  "subscribe.paymentForm.CTA.pay": "Pay now",

  "subscribe.success.title": "Payment successful",
  "subscribe.success.paragraph1":
    "Your payment has been processed successfully. You are now suscribed !",
  "subscribe.success.paragraph2": "Your new options are now available.",

  "myAccount.page.leftMenu.general": "General",
  "myAccount.page.leftMenu.profile": "My Company",
  "myAccount.page.leftMenu.dashboard": "Dashboard",
  "myAccount.page.leftMenu.setup": "Setup",
  "myAccount.page.leftMenu.upload": "Upload Products",
  "myAccount.page.leftMenu.myCatalogs": "My Catalogs",
  "myAccount.page.leftMenu.productCollections": "Product Collections",
  "myAccount.page.leftMenu.myAgents": "My Agents",
  "myAccount.page.myAgents.toast.slackCustomerSupport.connected":
    "Your Slack workspace is connected. Check that the desired channel is saved for your Tool.",
  "myAccount.page.leftMenu.myTools": "Agent Tools",
  "myAccount.page.leftMenu.myDNS": "My authorized domain names",
  "myAccount.page.leftMenu.sessions": "User Discussions",
  "myAccount.page.leftMenu.testMyChatbot": "Test my Chatbot",
  "myAccount.page.leftMenu.settings": "Settings",
  "myAccount.page.leftMenu.devSpace": "Developper Area",
  "myAccount.page.leftMenu.clientScript": "Client SDK",
  "myAccount.page.leftMenu.apiAccessToken": "API Access Token",
  "myAccount.page.leftMenu.documentation": "Documentation",
  "myAccount.auth.error.title": "We couldn't open your workspace",
  "myAccount.auth.error.description":
    "A temporary problem prevented us from loading your account. Try again in a moment.",
  "myAccount.auth.error.retry": "Try again",
  "myAccount.auth.error.retrying": "Trying again…",
  "myAccount.auth.error.reconnect": "Sign in again",
  "myAccount.page.myAgentDisplays.customCss.warn":
    "Your custom CSS has warnings. It will be saved, but some rules may be ignored.",
  "myAccount.page.myAgentDisplays.customCss.warnings.title":
    "Found {count, plural, one {# warning} other {# warnings}} with your CSS:",

  "myAccount.page.dashboard.eyebrow": "Your activity",
  "myAccount.page.dashboard.title": "Dashboard - {companyName}",
  "myAccount.page.dashboard.companyFallback": "your company",
  "myAccount.page.dashboard.subtitle":
    "Track your monthly discussions, engagement, consumed usage, and available capacity from one place.",
  "myAccount.page.dashboard.usageCapacityUsedBadge":
    "{percent}% of usage capacity occupied",
  "myAccount.page.dashboard.usageBilledAfterConsumption":
    "Usage billed after consumption",
  "myAccount.page.dashboard.error":
    "We could not load your dashboard data. Please try again later.",
  "myAccount.page.dashboard.currentMonth": "Current month",
  "myAccount.page.dashboard.lastMonth": "Last month",
  "myAccount.page.dashboard.monthOverMonth": "Month over month",
  "myAccount.page.dashboard.discussionsInMonth": "Discussions in {month}",
  "myAccount.page.dashboard.noPriorData": "No prior data to compare",
  "myAccount.page.dashboard.vsLastMonth": "{value}% vs last month",
  "myAccount.page.dashboard.discussionsComparison.title":
    "Discussions: current vs last month",
  "myAccount.page.dashboard.discussionsComparison.subtitle":
    "Monthly comparison based on subscription activity",
  "myAccount.page.dashboard.discussionsEmpty":
    "No discussion data available yet.",
  "myAccount.page.dashboard.usageCredit.title": "Usage credit",
  "myAccount.page.dashboard.usageLimit.title": "Monthly usage limit",
  "myAccount.page.dashboard.usageCapacity.subtitle":
    "Consumed, in progress, and available in the current billing period",
  "myAccount.page.dashboard.usageCapacity.consumed": "Consumed",
  "myAccount.page.dashboard.usageCapacity.reserved": "In progress",
  "myAccount.page.dashboard.usageCapacity.remaining": "Available",
  "myAccount.page.dashboard.usageCapacity.total": "Total capacity",
  "myAccount.page.dashboard.usageCapacity.empty":
    "No usage has been recorded yet.",
  "myAccount.page.dashboard.unboundedUsage":
    "Your offer has no fixed monetary usage limit. Every priced usage event is recorded and billed after consumption.",
  "myAccount.page.dashboard.usageUnavailable":
    "Your usage details will appear here when an active metered subscription is available.",
  "myAccount.page.dashboard.legacyMeteredUsage":
    "This historical offer meters usage directly and does not use a shared monetary capacity.",
  "myAccount.page.dashboard.currentUsage": "Usage consumed this billing period",
  "myAccount.page.dashboard.currentUsage.subtitle":
    "Value of completed priced usage only. It does not include your subscription price or your available usage credit.",
  "myAccount.page.dashboard.currentUsage.reserved":
    "Usage in progress: {amount}",
  "myAccount.page.dashboard.performance.title": "Month-over-month performance",
  "myAccount.page.dashboard.performance.subtitle":
    "Discussions, impressions, clicks, and CTR for the last six months",
  "myAccount.page.dashboard.performanceEmpty":
    "No monthly performance data available yet.",
  "myAccount.page.myTools.subtitle":
    "All tools currently available to your company.",
  "myAccount.page.myTools.readonlyHint":
    "To activate tools, open an agent and configure them in Agent Settings.",
  "myAccount.page.myTools.create.cta": "Create a company-owned tool",
  "myAccount.page.myTools.create.title": "Create a company-owned tool",
  "myAccount.page.myTools.create.description":
    "Create a capability that your agents can use automatically when a conversation requires it. The tool calls one of your company endpoints to read data or perform a business operation, with identity verification when access must be restricted to the signed-in customer.",
  "myAccount.page.myTools.empty": "No available tools for your company.",
  "myAccount.page.myTools.status.enabled": "Enabled",
  "myAccount.page.myTools.status.disabled": "Disabled",
  "myAccount.page.myTools.noDescription": "No description available.",
  "myAccount.page.myTools.card.activationLabel": "Activation",
  "myAccount.page.myTools.card.toggleAria": "Toggle tool activation",
  "myAccount.page.myTools.toast.loadTools.error":
    "Failed to load available tools.",
  "myAccount.page.myTools.toast.loadActivations.error":
    "Failed to load activations.",
  "myAccount.page.myTools.toast.toggle.error":
    "Failed to update tool activation.",
  "toolForm.toast.loadResolvers.error": "Failed to load resolvers.",
  "toolForm.toast.nameDisplay.required": "Name and display name are required.",
  "toolForm.toast.function.required":
    "Function name and function description are required.",
  "toolForm.toast.httpConfig.invalid": "httpConfig must be valid JSON.",
  "toolForm.toast.parameterSchema.invalid": "Invalid parameter schema.",
  "toolForm.toast.save.error": "Failed to save tool.",
  "toolForm.validation.duplicateParameter": "Duplicate parameter name: {name}",
  "toolForm.validation.emptyEnumValues":
    "Parameter {name} has empty enum values.",
  "toolForm.validation.resolverRequired":
    "Parameter {name} requires a resolver.",
  "toolForm.validation.unsupportedParameterType":
    "Unsupported parameter type for {name}",
  "toolForm.toast.assetUpload.afterCreate":
    "Asset upload is available after tool creation.",
  "toolForm.toast.assetUpload.error": "Failed to upload asset.",
  "toolForm.toast.assetUpload.success": "Asset uploaded.",
  "toolForm.readOnly.codeTool":
    "This is a code tool. It can be viewed here but must be edited in code.",
  "toolForm.name": "Name",
  "toolForm.displayName": "Display Name",
  "toolForm.shortDescription": "Short Description",
  "toolForm.asset": "Asset",
  "toolForm.asset.uploadTitle": "Upload a file",
  "toolForm.asset.or": "or",
  "toolForm.asset.publicUrlTitle": "Use a public URL",
  "toolForm.asset.publicUrlHint":
    "Paste the direct URL of an image already hosted publicly.",
  "toolForm.logoUrl": "Logo (URL)",
  "toolForm.uploadAsset": "Upload Asset to S3",
  "toolForm.uploadAsset.editHint":
    "Uploaded file URL will be set in Logo automatically.",
  "toolForm.uploadAsset.createHint": "Create the tool first to upload assets.",
  "toolForm.preview": "Preview",
  "toolForm.preview.logoAlt": "Tool logo preview",
  "toolForm.preview.empty": "No preview",
  "toolForm.functionName": "Function Name",
  "toolForm.functionName.help":
    "Use a self-explanatory name. The model uses this name as a strong signal to decide when to call the tool.",
  "toolForm.functionDescription": "Function Description",
  "toolForm.functionDescription.help":
    "Required. Keep it concise but precise so the agent can reliably choose this tool at the right moment.",
  "toolForm.execution": "Execution",
  "toolForm.execution.server": "server",
  "toolForm.executorType": "Executor Type",
  "toolForm.executorType.http": "http",
  "toolForm.executorType.code": "code",
  "toolForm.executorType.composite": "composite",
  "toolForm.handlerId": "Handler Id (code tools)",
  "toolForm.active": "Active",
  "toolForm.public": "Public",
  "toolForm.public.companyOwnedHint":
    "Public visibility is disabled for company-owned tools.",
  "toolForm.tabs.general": "General",
  "toolForm.tabs.asset": "Asset",
  "toolForm.tabs.execution": "Execution",
  "toolForm.tabs.parameters": "Parameters",
  "toolForm.parameters": "Parameters",
  "toolForm.parameters.add": "Add parameter",
  "toolForm.parameters.help":
    "Define LLM parameters for this tool. For string parameters, enums can be static or resolver-driven.",
  "toolForm.parameters.name.placeholder": "parameter name",
  "toolForm.parameters.required": "Required",
  "toolForm.parameters.remove": "Remove",
  "toolForm.parameters.description.placeholder":
    "Description (concise and precise)",
  "toolForm.parameters.enum.none": "No enum restriction",
  "toolForm.parameters.enum.static": "Static enum values",
  "toolForm.parameters.enum.resolver": "Dynamic enum from resolver",
  "toolForm.parameters.enum.static.placeholder": "value1, value2, value3",
  "toolForm.parameters.resolver.select": "Select resolver",
  "toolForm.parameters.arrayItemType": "Array item type",
  "toolForm.parameterType.http": "http",
  "toolForm.parameterType.string": "string",
  "toolForm.parameterType.number": "number",
  "toolForm.parameterType.integer": "integer",
  "toolForm.parameterType.boolean": "boolean",
  "toolForm.parameterType.array": "array",
  "toolForm.httpConfig": "HTTP Config (JSON)",
  "toolForm.save.saving": "Saving...",
  "toolForm.save.create": "Create tool",
  "toolForm.save.update": "Save changes",
  "myAccount.tools.category.generic": "Generic",
  "myAccount.tools.category.custom": "Custom",
  "myAccount.page.myChatbot.selectAgent.label": "Select agent to test",
  "myAccount.page.myChatbot.selectAgent.empty": "No available agent",
  "myAccount.page.myChatbot.info":
    "You can test every active Agent in your company here.",
  "myAccount.page.myChatbot.archivedAgents":
    "{count, plural, one {# archived Agent} other {# archived Agents}}",
  "myAccount.page.myChatbot.archivedAgents.link": "View my Agents",
  "myAccount.page.myChatbot.noAgent": "No agent found for your company.",
  "myAccount.page.myUserSessions.filters.agent": "Filter by agent",
  "myAccount.page.myUserSessions.filters.agent.all": "All agents",
  "myAccount.page.myUserSessions.filters.sort": "Sort",
  "myAccount.page.myUserSessions.filters.sort.latest": "Latest first",
  "myAccount.page.myUserSessions.filters.sort.agentAsc": "Agent (A-Z)",
  "myAccount.page.myUserSessions.filters.sort.agentDesc": "Agent (Z-A)",
  "myAccount.page.myUserSessions.filters.isResolved": "Resolution",
  "myAccount.page.myUserSessions.filters.isResolved.all": "All",
  "myAccount.page.myUserSessions.filters.isResolved.true": "Resolved only",
  "myAccount.page.myUserSessions.filters.isResolved.false": "Not resolved",
  "myAccount.page.myUserSessions.filters.requestedActionability":
    "Requested actionability",
  "myAccount.page.myUserSessions.filters.requestedActionability.all": "All",
  "discussionReport.common.notAvailable": "N/A",
  "discussionReport.requestedActionability.basic_conversation":
    "Basic conversation",
  "discussionReport.requestedActionability.recommendation": "Recommendation",
  "discussionReport.requestedActionability.lookup": "Lookup",
  "discussionReport.requestedActionability.transaction": "Transaction",
  "discussionReport.requestedActionability.human_help": "Human help",
  "discussionReport.requestedActionability.other": "Other",
  "discussionReport.resolutionStatus.resolved": "Resolved",
  "discussionReport.resolutionStatus.partially_resolved": "Partially resolved",
  "discussionReport.resolutionStatus.unresolved": "Unresolved",
  "discussionReport.summary.label": "Conversation summary",
  "discussionReport.summary.empty":
    "No summary is available for this discussion yet.",
  "discussionReport.insights.label": "Report insights",
  "discussionReport.resolution.label": "Resolution",
  "discussionReport.requestedActionability.label": "Requested actionability",
  "discussionReport.pendingMetadata.message":
    "Metadata like the conversation summary and discussion classification is typically added after a few days.",

  "myAccount.page.leftMenu.trackingSpace": "Tracking",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR": "Product stats",
  "myAccount.page.leftMenu.trackingSpace.dailyKPI": "Daily KPIs",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity":
    "Discussion Activity",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP":
    "Discussion by IP",
  "myAccount.page.leftMenu.trackingSpace.monthlyPerformance":
    "Monthly Performance",
  "myAccount.page.leftMenu.trackingSpace.monthlyReports": "Monthly Reports",
  "myAccount.page.monthlyReports.back": "Back to monthly reports",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR":
    "Products Stats per month",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.title.mostClicked":
    "Most Clicked Products (in total)",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.title.mostViewed":
    "Most Viewed Products (in total)",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.title.mostCTR":
    "Most Clicked Products per view (in total)",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.url": "Product URL",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.impressions":
    "Impressions",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.clicks": "Clicks",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.CTR": "CTR",
  "myAccount.page.leftMenu.trackingSpace.allTimeProductCTR.none":
    "No stats yet.",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.url": "Product URL",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.impressions":
    "Impressions",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.clicks": "Clicks",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.CTR": "CTR",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.none":
    "No stats yet.",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.clicked.table.title":
    "Most Clicked Products (month score)",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.viewed.table.title":
    "Most Viewed Products (month score)",
  "myAccount.page.leftMenu.trackingSpace.monthlyProductCTR.ctr.table.title":
    "Most clickedd products per view (month score)",
  "myAccount.page.leftMenu.trackingSpace.generic.ctr": "CTR",
  "myAccount.page.leftMenu.trackingSpace.generic.clicks": "Clicks",
  "myAccount.page.leftMenu.trackingSpace.generic.impressions": "Impressions",
  "myAccount.page.leftMenu.trackingSpace.generic.discussions": "Discussions",
  "myAccount.page.leftMenu.trackingSpace.generic.month": "Month",
  "myAccount.page.leftMenu.trackingSpace.generic.day": "Day",
  "myAccount.page.leftMenu.trackingSpace.dailyKPI.title": "Daily KPIs",
  "myAccount.page.dailyKPI.chart.title": "Daily performance",
  "myAccount.page.dailyKPI.chart.subtitle":
    "Discussions, clicks, impressions, and CTR",
  "myAccount.page.dailyKPI.chart.empty": "No daily KPI data yet.",
  "myAccount.page.monthlyPerformance.chart.title": "Monthly performance",
  "myAccount.page.monthlyPerformance.chart.subtitle":
    "Discussions, clicks, impressions, and CTR",
  "myAccount.page.monthlyPerformance.chart.empty":
    "No monthly performance data yet.",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP.title":
    "Discussions Grouped by IP",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP.ip":
    "Customer IP (hashed)",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP.firstSeen":
    "First Discussion started at",
  "myAccount.page.leftMenu.trackingSpace.discussionGroupedByIP.lastSeen":
    "Last Discussion finished at",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.title":
    "Discussion Activity",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.startingTime":
    "Starting Time",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.endTime":
    "End Time",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.type": "Type",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.ipCustomerRaw":
    "IP Customer (raw)",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.ipCustomerHashed":
    "IP Customer (hashed)",
  "myAccount.page.leftMenu.trackingSpace.discussionActivity.discussionId":
    "Discussion ID",

  "myAccount.page.setup.badge": "Website installation",
  "myAccount.page.setup.title": "Install your Agent on your website",
  "myAccount.page.setup.description":
    "Choose your Agent, copy its installation code and add it to the global template of your website.",
  "myAccount.page.setup.client": "Client side",
  "myAccount.page.setup.api": "Api side",
  "myAccount.page.setup.apiAccess.methods":
    "There are two ways to authenticate programmatically: rotating tokens (mint short-lived JWTs) or static API keys (long-lived).",
  "myAccount.page.setup.apiAccess.hint":
    "Use rotating tokens when you want expiring access tokens; use API keys for server-to-server access and rotate by revoking and creating a new key.",
  "myAccount.page.setup.jwt.description": "Your JWT for API use:",
  "myAccount.page.setup.jwt.copyClipboard": "JWT copied !",
  "myAccount.page.sesstions.title": "User Discussions",
  "myAccount.page.discusion.byHashedIP.title": "User Discussions by IP",
  "myAccount.page.subscriptionFormulas.title": "Subscription offers",
  "myAccount.page.setup.subscribe":
    "Subscribe to get your access token and be able to use the app.",
  "myAccount.page.setup.appTokenIs": "Your appToken is",
  "myAccount.page.setup.copySnippetWidget":
    "Copy this into your html page to make it work",
  "myAccount.page.setup.copySnippetReact":
    "Import the react app at the root of your tree with the props appToken",
  "myAccount.page.setup.agentSelection.label": "Agent for snippets",
  "myAccount.page.setup.agentSelection.hint":
    "Choose which agent ID should be injected into your integration snippets.",
  "myAccount.page.setup.agentSelection.optional":
    "If no agent is provided, your company default agent is used.",
  "myAccount.page.agentContext.select.label": "Target agent",
  "myAccount.page.agentContext.select.empty": "No available agent",
  "myAccount.page.setup.snippet.copy.cta": "Copy snippet",
  "myAccount.page.setup.snippet.copy.success": "Snippet copied to clipboard.",
  "myAccount.page.setup.snippet.copy.error": "Failed to copy snippet.",
  "myAccount.page.setup.guide.title": "Install it in three steps",
  "myAccount.page.setup.guide.choose.title": "Choose your Agent",
  "myAccount.page.setup.guide.choose.description":
    "Select the Agent that should welcome visitors on your website.",
  "myAccount.page.setup.guide.copy.title": "Copy the code",
  "myAccount.page.setup.guide.copy.description":
    "Use the copy button below. The code already contains the correct company and Agent identifiers.",
  "myAccount.page.setup.guide.publish.widget.title": "Add it to your website",
  "myAccount.page.setup.guide.publish.react.title":
    "Add it to your application",
  "myAccount.page.setup.guide.publish.widget.description":
    "Paste the tag just before {bodyTag} in your global template or site-wide custom code area, then publish.",
  "myAccount.page.setup.guide.publish.react.description":
    "Integrate the component at the root of your React application, then deploy the change.",
  "myAccount.page.setup.guide.publish.react.chatbox.description":
    "Place the component where the conversation should appear in the page, then deploy the change.",
  "myAccount.page.setup.configure.title": "Your installation code",
  "myAccount.page.setup.configure.description":
    "Choose the Agent, integration method and display format. The code is updated automatically.",
  "myAccount.page.setup.displayMode.label": "Display format",
  "myAccount.page.setup.displayMode.launcher": "Floating button",
  "myAccount.page.setup.displayMode.launcher.description":
    "A discreet button opens the Agent over your website.",
  "myAccount.page.setup.displayMode.chatbox": "Embedded chat",
  "myAccount.page.setup.displayMode.chatbox.description":
    "The conversation fills the location where you add the component.",
  "myAccount.page.setup.reactMultiView.note":
    "Displaying both formats on the same page?",
  "myAccount.page.setup.reactMultiView.link":
    "See the advanced multi-view example.",
  "myAccount.page.setup.handoff.title": "Someone else manages your website?",
  "myAccount.page.setup.handoff.description":
    "Copy a ready-to-send message for your developer, agency or website administrator.",
  "myAccount.page.setup.handoff.copy.cta": "Copy instructions to send",
  "myAccount.page.setup.handoff.copy.success":
    "Instructions copied. You can send them to your technical contact.",
  "myAccount.page.setup.handoff.widget":
    "Hello, could you install ChatSystem on every page of our website? Add the following tag just before the closing {bodyTag} tag in the global website template, then publish the change.\n\n{snippet}",
  "myAccount.page.setup.handoff.react":
    "Hello, could you add ChatSystem to our React application? Integrate the following component at the application root so it is available on every relevant page, then deploy the change.\n\n{snippet}",
  "myAccount.page.setup.handoff.react.chatbox":
    "Hello, could you add ChatSystem to our React application? Place the following component where the conversation should appear in the page, then deploy the change.\n\n{snippet}",
  "myAccount.page.setup.verify.title": "After publishing",
  "myAccount.page.setup.verify.description":
    "Open your website, check that the Agent appears, then send a message. If it does not load, first verify that the website domain is authorized.",
  "myAccount.page.setup.verify.domains.cta": "Check authorized domains",
  "myAccount.page.setup.verify.agent.cta": "Test my Agent",

  "dev.companyApi.quickstart": "Quick start",
  "dev.companyApi.title": "Company API Access",
  "dev.companyApi.subtitle":
    "Create a refresh token for your company integration. Use it to mint short-lived access JWTs.",
  "dev.companyApi.refreshOnce": "Refresh token (shown once)",
  "dev.companyApi.refreshOnce.help":
    "Copy and store it now (password manager / vault / CI secrets).",
  "dev.companyApi.tokenLabel": "Token",
  "dev.companyApi.important": "Important",
  "dev.companyApi.warning.once":
    "You will not be able to view this refresh token again.",
  "dev.companyApi.warning.rotation":
    "Refresh tokens rotate: each mint call returns a NEW refresh token and revokes the previous one.",
  "dev.companyApi.create.title": "Create a token",
  "dev.companyApi.create.name": "Token name",
  "dev.companyApi.create.scopes": "Scopes",
  "dev.companyApi.create.scopesHelp": "Leave '*' for full access.",
  "dev.companyApi.create.expires": "Expires in days",
  "dev.companyApi.create.expiresHelp":
    "If empty, the token does not expire (until revoked).",
  "dev.companyApi.create.cta": "Create token",
  "dev.companyApi.working": "Working...",
  "dev.companyApi.existing": "Existing tokens",
  "dev.companyApi.revokeAll": "Revoke all",
  "dev.companyApi.none": "No tokens yet.",
  "dev.companyApi.revoke": "Revoke",
  "dev.companyApi.tip":
    "Tip: refresh token rotation is automatic when minting access tokens.",

  "dev.companyApiKey.quickstart": "Quick start",
  "dev.companyApiKey.title": "Company API Keys",
  "dev.companyApiKey.subtitle":
    "Create a long-lived API key for server-to-server access. Keys do not rotate automatically and are shown only once.",
  "dev.companyApiKey.once": "API key (shown once)",
  "dev.companyApiKey.once.help":
    "Copy and store it now (password manager / vault / CI secrets).",
  "dev.companyApiKey.keyLabel": "Key",
  "dev.companyApiKey.important": "Important",
  "dev.companyApiKey.warning.once":
    "You will not be able to view this key again.",
  "dev.companyApiKey.warning.rotation":
    "API keys are static. Revoke and create a new key to rotate.",
  "dev.companyApiKey.create.title": "Create an API key",
  "dev.companyApiKey.create.name": "Key name",
  "dev.companyApiKey.create.scopes": "Scopes",
  "dev.companyApiKey.create.scopesHelp": "Leave '*' for full access.",
  "dev.companyApiKey.create.expires": "Expires in days",
  "dev.companyApiKey.create.expiresHelp":
    "If empty, the key does not expire (until revoked).",
  "dev.companyApiKey.create.cta": "Create key",
  "dev.companyApiKey.working": "Working...",
  "dev.companyApiKey.existing": "Existing keys",
  "dev.companyApiKey.revokeAll": "Revoke all",
  "dev.companyApiKey.none": "No keys yet.",
  "dev.companyApiKey.revoke": "Revoke",
  "dev.companyApiKey.tip":
    "Tip: API keys are static. Revoke and create a new key to rotate.",

  "myAccount.page.setup.documentation.title": "Documentation",
  "myAccount.page.setup.documentation.documentationExplaination":
    "Documentation is available on that ",
  "myAccount.page.setup.documentation.documentationExplaination.link": "link",
  "myAccount.page.setup.documentation.swaggerExplaination":
    "Swagger is available on that ",
  "myAccount.page.setup.documentation.swaggerExplaination.link": "link",

  "documentation.hub.metaTitle": "ChatSystem documentation",
  "documentation.hub.metaDescription":
    "Practical guides for configuring ChatSystem and integrating it into your customer journey.",
  "documentation.hub.eyebrow": "ChatSystem guides",
  "documentation.hub.title": "Documentation",
  "documentation.hub.subtitle":
    "Choose a guide to configure your agents, connect your services, and validate the customer experience.",
  "documentation.hub.resources.label": "Available guides",
  "documentation.hub.productSearch.title": "Set up product search for an agent",
  "documentation.hub.productSearch.description":
    "Create a Product Collection, configure the agent search profile, and validate product recommendations.",
  "documentation.hub.productSearch.action": "Open the product search guide",
  "documentation.hub.identity.title": "Set up Identity Delegation",
  "documentation.hub.identity.description":
    "Connect your existing login system and let agents securely perform actions for signed-in customers.",
  "documentation.hub.identity.action": "Open the integration guide",
  "documentation.hub.clientSdk.title": "Client SDK",
  "documentation.hub.clientSdk.description":
    "Find the integration snippets and settings required to add ChatSystem to your website.",
  "documentation.hub.clientSdk.action": "Open the Client SDK guide",
  "documentation.hub.api.title": "API reference",
  "documentation.hub.api.description":
    "Explore the available API routes, request formats, and response schemas.",
  "documentation.hub.api.action": "Open the API reference",
  "documentation.guide.back": "All documentation",
  "documentation.productSearch.metaTitle":
    "Set up product search for an agent | ChatSystem",
  "documentation.productSearch.metaDescription":
    "Create a Product Collection, connect it to an agent, and test product search in ChatSystem.",
  "documentation.clientSdk.metaTitle": "Install the Client SDK | ChatSystem",
  "documentation.clientSdk.metaDescription":
    "Install one ChatSystem widget or share one Agent conversation between inline and launcher React views.",

  "myAccount.page.upload.title": "Upload your products",
  "myAccount.page.upload.catalogSelection.manualUpload.title":
    "This is a manual file upload path. Do not use it if you use the API",
  "myAccount.page.upload.uploadFile.explaination":
    "Please choose a CSV or XLSX file containing your products.",
  "myAccount.page.upload.catalogSelection.dropdown.explaination":
    "Choose a catalog to upload your products to. You can create a catalog from a file, or upload products on an existing catalog.",
  "myAccount.page.upload.catalogSelection.dropdown.placeholder":
    "Choose a catalog",
  "myAccount.page.upload.catalogSelection.dropdown.addNew":
    "Create a new catalog",

  "myAccount.page.upload.uploadFile.noFile": "No files have been uploaded.",

  "myAccount.page.upload.MandatoryColumns.title":
    "Mandatory Columns for the agent",
  "myAccount.page.upload.MandatoryColumns.explaination":
    "In order to properly construct customer response messages, we need to know specifically the following columns in your file. These columns are mandatory so that the robot's return is at the expected quality level.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.description":
    "Description",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.description.details":
    "Specify the column containing the product description. The more detailed the description, the better the search will be.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.doesNotExist":
    "Does not exist in this file",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.fr":
    "Product Name FR",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.fr.details":
    "Indicate the column containing the FRENCH name of your product. This is the name that will be displayed in the chat when your product is recommended by the robot. Only one language is mandatory for product names.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.en":
    "Product Name EN",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.productName.en.details":
    "Indicate the column containing the ENGLISH name of your product. This is the name that will be displayed in the chat when your product is recommended by the robot. Only one language is mandatory for product names.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.sellingPrice":
    "Selling Price",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.sellingPrice.details":
    "Indicate the column containing the price of the product. This is the price that will be indicated in the chat when the product is recommended.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.urlProduct":
    "URL Product",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.urlProduct.details":
    "Indicate the column containing the URL of the product sheet. This is the URL that will be used to redirect the user when they click on the product in the chat.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.imageSrc":
    "URL Product Image",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.imageSrc.details":
    "Specify the column containing the product image URL. This image will be displayed in the chat result.",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.customerProductId":
    "Product ID",
  "myAccount.page.upload.MandatoryColumns.fieldToFill.customerProductId.details":
    "Specify the column containing the product ID. Each ID should be unique for each product.",
  "myAccount.page.upload.MandatoryColumns.validation.cta": "Ok",

  "myAccount.page.upload.columnSearchSelection.introduction":
    "Which columns do you want to use to filter products for your customers ? Choose the ones that make sense, that define your product, on which a search can be made.",
  "myAccount.page.upload.columnSearchSelection.title": "Select useful columns",

  "myAccount.page.upload.mandatoryColumns.title": "Select mandatory columns",
  "myAccount.page.upload.mandatoryColumns.explanaition":
    "Among the search criteria, is a criteria mandatory? To offer products to your customers? For example, to advise a board game to a customer, age is very important: for a child we do not recommend the same game as for an adult.",
  "myAccount.page.upload.mandatoryColumns.explanaition.two":
    "If you check a box here, the robot will request this information from the customer.",
  "myAccount.page.upload.mandatoryColumns.maximumSelection":
    "Please choose 3 mandatory categories maximum.",

  "myAccount.page.upload.columnDefinition.title":
    "Explain your data to the robot",
  "myAccount.page.upload.columnDefinition.explaination.danger":
    "The robot needs to understand what data it is browsing. This step is very important for understanding the products in your catalog.",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.name":
    "Give easy-to-understand names",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.dataType":
    "Specify the type of data so that the robot knows how to browse it",
  "myAccount.page.upload.columnDefinition.explaination.guidelines.list.semanticDescription":
    "Explain each data in one sentence",
  "myAccount.page.upload.columnDefinition.explaination.recap.understanding":
    "It is very important that the robot understands what data it is consulting when it searches for a product. Are they numbers, dates, a set of words, or true/false columns?",
  "myAccount.page.upload.columnDefinition.explaination.recap.qualityMatters":
    "Depending on the quality of the information entered, the robot will be more or less efficient in providing product advice.",
  "myAccount.page.upload.columnDefinition.explaination.recap.checkColumns":
    "Let's check each column together.",
  "myAccount.page.upload.columnDefinition.explaination.recap.numberOfColumns":
    "Number of filters : ",
  "myAccount.page.upload.columnDefinition.form.invalid":
    "Some columns have not been completely filled out. Look for the red fields!",

  "myAccount.page.upload.columnDefinitionSetter.mandatory": "Mandatory",
  "myAccount.page.upload.columnDefinitionSetter.mandatoryExplaination":
    "This column is mandatory and cannot be modified",
  "myAccount.page.upload.columnDefinitionSetter.emptyLine": "Empty line",

  "myAccount.page.upload.columnDefinition.column": "Defining Column",
  "myAccount.page.upload.columnDefinition.name": "Name for the robot",
  "myAccount.page.upload.columnDefinition.type": "Type",
  "myAccount.page.upload.columnDefinition.semanticDescription": "Explaination",

  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.ProductName":
    "Product Name",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.ProductName":
    "The name of the product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.Price":
    "Product Price",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.Price":
    "The price of the product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.Description":
    "Product Description",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.Description":
    "The description of the product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.URLProduct":
    "URL Product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.URLProduct":
    "The URL that links to the product",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.ImageURL":
    "Url Product Image",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.ImageURL":
    "The URL that links to the product image",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.name.customerProductId":
    "Product ID",
  "myAccount.page.upload.columnDefinition.searchFilter.mandatoryProperties.semanticDescription.customerProductId":
    "The unique identifier of the product",

  "myAccount.page.upload.columnDefinition.type.chosenType":
    "Current type entered:",
  "myAccount.page.upload.columnDefinition.type.dataSample":
    "Example data for this column from your data:",
  "myAccount.page.upload.columnDefinition.type.editType": "Change column type:",

  "myAccount.page.upload.columnDefinition.columnNameHelper.header":
    "More information about the name",
  "myAccount.page.upload.columnDefinition.columnNameHelper.intro":
    "Indicate an easy-to-understand name for the robot.",
  "myAccount.page.upload.columnDefinition.columnNameHelper.explicationOne":
    "The simple, explanatory name is important because it helps the robot understand what data we are talking about.",
  "myAccount.page.upload.columnDefinition.columnNameHelper.explicationTwo":
    "Examples: 'board games', 'number of players' are simple nouns. 'UK_896' is not a simple name.",

  "myAccount.page.upload.columnDefinition.columnTypeHelper.header":
    "More information about the type",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.explaination":
    "Specifying the column type is very important because it allows the robot to know how to search.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.intro":
    "Here are the different possible types:",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.enum.title":
    "Defined list",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.enum.content":
    "A defined list is a list of which we know all the values in advance. For example, clothing sizes: S, XS, M, L, XL, XXL. Or tags for products - for example, 'Science Fiction', 'Western', 'Romance' for books. It’s a fixed list, of which we know all the options.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.text.title": "Text",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.text.content":
    "This is the broadest section. For all unstructured texts, such as a description, classic information.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.number.title":
    "Figures and numbers",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.number.content":
    "If the data is a number or a digit. There can't be a letter. '91' is a number, '91z' is text.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.date.title": "Date",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.date.content":
    "If the data is a date.",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.boolean.title":
    "True/False",
  "myAccount.page.upload.columnDefinition.columnTypeHelper.boolean.content":
    "If the data is of type yes/no, or true/false. For example, is a dish gluten-free.",

  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.header":
    "More information on description",

  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionOne":
    "Explain in one sentence what this column contains, in a simple way that a friend would understand.",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionTwo":
    "Example: a column with a name 'game duration' could contain the following sentence: 'The game duration desired by the customer'",
  "myAccount.page.upload.columnDefinition.columnTypeSemanticDescription.explanaitionThree":
    "True/false columns must be a question. Example: 'Is this dish gluten-free?'",

  "myAccount.page.upload.columnDefinition.name.mandatory.isMappedTo":
    "Is tagged as mandatory field ",

  "columnDefinition.checkbox.isRequired.name": "Required",
  "columnDefinition.checkbox.isRequired.explaination":
    "This data is required for the AI assistant",
  "columnDefinition.checkbox.isImportant.name": "Important",
  "columnDefinition.checkbox.isImportant.explaination":
    "This column is important : it will have a bonus score when searching if it matches.",
  "myAccount.page.upload.columnDefinition.meta.section": "Metadata",
  "myAccount.page.upload.columnDefinition.meta.helper":
    "Use “Required” when the column must be present to process a product. If it is not, the model will infer it. Mark “Important” to prioritize this column in advice and ranking. Most columns should not be marked as Important or Required.",
  "columnDefinition.cta.addProperty": "Add a property",

  "myAccount.page.upload.productDefinition.title":
    "Catalog Products Definition",
  "myAccount.page.upload.productDefinition.intro":
    "This is for the robot to understand your data. Please indicate a short name that summarize the type of article that you will reference in the robot. This description will once again help him to be a good seller in the category you are going to indicate.",
  "myAccount.page.upload.productDefinition.placeholder":
    "Indicate the category of your products. Example : Smartphones",
  "myAccount.page.upload.catalog.title": "Catalog Name",
  "myAccount.page.upload.catalog.intro":
    "Give a name to your catalog. This name if for your internal use only",
  "myAccount.page.upload.catalog.placeholder": "Smartphones",

  "myAccount.page.upload.processing.singleValueError.boolean":
    "Boolean value non recognized",
  "myAccount.page.upload.processing.singleValueError.number":
    "Number value non recognized",
  "myAccount.page.upload.processing.singleValueError.date":
    "Date value non recognized",
  "myAccount.page.upload.processing.singleValueError.text":
    "Text value non recognized",
  "myAccount.page.upload.processing.singleValueError.enum":
    "Enum value non recognized",
  "myAccount.page.upload.processing.singleValueError.url":
    "Url value non recognized. It should start with 'http'.",
  "myAccount.page.upload.processing.lineError":
    "Line: {indexProduct} - Error while parsing: Property: {property} / Value received: {value}",
  "myAccount.page.upload.processing.notHandledError":
    "Line: {indexProduct} - Data not handled: Property: {property} / Value received: {value}",

  "myAccount.page.upload.error.intro": "There are errors processing your file.",
  "myAccount.page.upload.error.explaination":
    "Each line with an error is shown below. Please check the corresponding content and correct it. You may then upload it again (your settings are not lost)",
  "myAccount.page.upload.button.cta": "Upload",
  "myAccount.page.upload.success.notification":
    "Your file has been successfully uploaded.",
  "myAccount.page.upload.failure.notification":
    "Your file could not be uploaded. Please fix the errors displayed, either in the file or in the column definitions, and upload again.",
  "myAccount.page.upload.failure.restartUpload": "Recommencer",

  "myAccount.page.upload.success.component.title": "Success",
  "myAccount.page.upload.success.component.explaination":
    "Your file have been successfully uploaded.",
  "myAccount.page.upload.success.component.explaination2":
    "Products will now be displayed in the chatbot results to your customers.",

  "myAccount.page.myCatalogs.catalog.title": "Catalog",
  "myAccount.page.myCatalogs.catalog.name": "Name",
  "myAccount.page.myCatalogs.catalog.isDefault": "Is Default",
  "myAccount.page.myCatalogs.catalog.default": "Default",
  "myAccount.page.myCatalogs.catalog.productDefinition":
    "Product Catalog Definition",
  "myAccount.page.myCatalogs.catalog.delete": "Delete the catalog",
  "myAccount.page.myCatalogs.catalog.delete.success":
    "The catalog has been deleted.",
  "myAccount.page.myCatalogs.catalog.products.delete.cta":
    "Delete Products of the catalog.",
  "myAccount.page.myCatalogs.catalog.products.delete.success":
    "The products of the catalog has been deleted.",
  "myAccount.page.myCatalogs.catalog.numberOfProducts": "Number of products:",
  "myAccount.page.myCatalogs.catalog.header.desc":
    "Manage your catalog details, filters and products.",
  "myAccount.page.myCatalogs.catalog.details.title": "Catalog details",
  "myAccount.page.myCatalogs.catalog.name.hint":
    "The name that describes the category of products in this catalog.",
  "myAccount.page.myCatalogs.catalog.productDefinition.hint":
    "Describe in one or two sentences what qualifies a product for this catalog.",
  "myAccount.page.myCatalogs.catalog.filters.callout":
    "Fine‑tune your search filters to populate this catalog with the most relevant products.",
  "myAccount.page.myCatalogs.catalog.dangerZone.title": "Danger Zone",
  "myAccount.page.myCatalogs.catalog.dangerZone.desc":
    "These actions cannot be undone. Proceed with caution.",
  "myAccount.page.myCatalogs.catalog.deleteProducts.hint":
    "Removes all products currently in this catalog.",
  "myAccount.page.myCatalogs.catalog.deleteCatalog.hint":
    "Permanently deletes this catalog, its products, and all of its settings",
  "myAccount.page.myCatalogs.all.noCatalogs":
    "You don't have any catalogs for now",
  "myAccount.page.myCatalogs.cta.create": "Create a catalog",
  "myAccount.page.myCatalogs.cta.save": "Save catalog",
  "myAccount.page.myCatalogs.save.success":
    "Your catalog has been successfully created.",
  "myAccount.page.myCatalogs.save.error":
    "There has been an error creating your catalog. Please contact support.",
  "myAccount.page.myCatalogs.creation.success.title": "Success",
  "myAccount.page.myCatalogs.creation.success.explaination":
    "Your catalog has been successfully created.",
  "myAccount.page.myCatalogs.creation.success.explaination2":
    "You can now use it to upload products onto your chatbot agent.",
  "myAccount.page.myCatalogs.edition.save.cta": "Save modifications",
  "myAccount.page.myCatalogs.edition.searchFilter.edit.cta":
    "Edit Search Filter",
  "myAccount.page.myCatalogs.edition.searchFilter.save.cta":
    "Save Search Filters",
  "myAccount.page.myCatalogs.edition.save.success":
    "Your catalog has been successfully edited.",
  "myAccount.page.myCatalogs.searchFiltersedition.title": "Edit Search Filters",
  "myAccount.page.myCatalogs.searchFiltersedition.save.success":
    "Your search filters have been successfully edited.",
  "myAccount.page.myCatalogs.searchFiltersedition.edit.notIfProductsExist":
    "You cannot edit Search Filters from a Catalog with existing products. Empty all products of the Catalog before changing it.",

  "myAccount.page.myAgents.cta.save": "Save Agent",
  "myAccount.page.myAgents.cta.title": "Edit Agent",
  "myAccount.page.myAgents.cta.changeAppearance": "Change appearance",
  "myAccount.page.myAgents.cta.explaination":
    "Edit the details, welcome message and appearance for your chatbot agent.",
  "myAccount.page.myAgents.cta.field.name": "Agent Name (internal)",
  "myAccount.page.myAgents.cta.field.customNameToDisplay":
    "Assistant Name Shown to Customers",
  "myAccount.page.myAgents.cta.field.startingText": "Chatbot Starting Text",
  "myAccount.agentConversationStarters.title": "Suggested first questions",
  "myAccount.agentConversationStarters.helper":
    "Optionally offer up to three useful questions when the conversation opens. A visitor can send one with a single click.",
  "myAccount.agentConversationStarters.inputLabel":
    "Suggested question {number}",
  "myAccount.agentConversationStarters.placeholder":
    "For example: Which service best fits my needs?",
  "myAccount.agentConversationStarters.remove":
    "Remove suggested question {number}",
  "myAccount.agentConversationStarters.add": "Add a suggested question",
  "myAccount.page.myAgents.cta.field.initialSystemPrompt": "Agent instructions",
  "myAccount.page.myAgents.cta.field.initialSystemPrompt.helper":
    "Customize your Agent's role, company context, communication and boundaries here.",
  "myAccount.agentPrompt.legacy.helper":
    "This Agent still uses one legacy instruction block. You can keep editing it or move it unchanged into the structured editor.",
  "myAccount.agentPrompt.convert": "Use the structured editor",
  "myAccount.agentPrompt.composition.title":
    "Clear instructions, one purpose per section",
  "myAccount.agentPrompt.composition.helper":
    "ChatSystem adds the instructions for each enabled Tool automatically. Manage Tool-specific guidance in the Agent Tools tab.",
  "myAccount.agentPrompt.role": "Agent role",
  "myAccount.agentPrompt.role.helper":
    "Who the Agent is and the role it plays for visitors.",
  "myAccount.agentPrompt.objectives": "Objectives and audience",
  "myAccount.agentPrompt.objectives.helper":
    "What the Agent should help visitors accomplish first.",
  "myAccount.agentPrompt.organization": "Organization represented",
  "myAccount.agentPrompt.organization.helper":
    "Reviewed facts, services and context the Agent may use about your organization.",
  "myAccount.agentPrompt.communication": "Communication and conversation",
  "myAccount.agentPrompt.communication.helper":
    "Tone, response style, useful questions and recommendation approach.",
  "myAccount.agentPrompt.safeguards": "Reliability and boundaries",
  "myAccount.agentPrompt.safeguards.helper":
    "What the Agent must verify, avoid inventing or explain transparently.",
  "myAccount.agentPrompt.miscellaneous": "Additional instructions",
  "myAccount.agentPrompt.miscellaneous.helper":
    "Anything important that does not fit another section.",
  "admin.agentPromptWorkspace.title": "Agent prompt construction",
  "admin.agentPromptWorkspace.description":
    "Inspect the exact configured prompt and understand where every instruction comes from.",
  "admin.agentPromptWorkspace.tab.overview": "Overview",
  "admin.agentPromptWorkspace.tab.edit": "Edit instructions",
  "admin.agentPromptInspection.error":
    "The prompt construction could not be loaded.",
  "admin.agentPromptInspection.retry": "Try again",
  "admin.agentPromptInspection.unavailable":
    "This runtime does not expose a unified configured prompt. No partial reconstruction is displayed.",
  "admin.agentPromptInspection.runtime": "Runtime",
  "admin.agentPromptInspection.composition": "Composition",
  "admin.agentPromptInspection.activeTools": "Active Tools in prompt",
  "admin.agentPromptInspection.characters": "Rendered characters",
  "admin.agentPromptInspection.group.agent.title": "Agent configuration",
  "admin.agentPromptInspection.group.agent.description":
    "Instructions owned by this Agent and editable by the company or an administrator.",
  "admin.agentPromptInspection.group.tools.title": "Active Tools",
  "admin.agentPromptInspection.group.tools.description":
    "Only enabled Tools whose instructions are added to this configured prompt.",
  "admin.agentPromptInspection.group.platform.title": "Runtime rules",
  "admin.agentPromptInspection.group.platform.description":
    "Code-owned orchestration and reliability rules added by ChatSystem.",
  "admin.agentPromptInspection.section.empty":
    "No instruction is configured in this section.",
  "admin.agentPromptInspection.rendered.title": "Exact configured prompt",
  "admin.agentPromptInspection.copy": "Copy prompt",
  "admin.agentPromptInspection.copied": "Copied",
  "admin.agentPromptInspection.source.agentComposition": "Agent configuration",
  "admin.agentPromptInspection.source.agentOverride": "Agent Tool override",
  "admin.agentPromptInspection.source.toolDefault": "Tool default",
  "admin.agentPromptInspection.source.functionDescription":
    "Tool function description",
  "admin.agentPromptInspection.source.platformPolicy":
    "ChatSystem runtime policy",
  "myAccount.page.myAgents.cta.field.displayMode": "Display Mode",
  "myAccount.page.myAgents.cta.field.displayMode.default": "Default",
  "myAccount.page.myAgents.cta.field.displayMode.spritesheet": "SpriteSheet",
  "myAccount.page.myAgents.cta.displayMode.spritesheet.upload.label":
    "Upload spritesheet image",
  "myAccount.page.myAgents.edit.displayMode.title": "Themes",
  "myAccount.page.myAgents.edit.displayMode.explaination":
    "Choose the theme you want to use, adapt, or create a new one.",
  "myAccount.page.myAgents.edit.displayMode.name.title": "Edit My Theme",
  "myAccount.page.myAgents.edit.displayMode.name.edit": "Edit Theme Name",
  "myAccount.page.myAgents.edit.displayMode.name.edit.explainations":
    "Edit Theme Name and access each of your theme appearance.",
  "myAccount.page.myAgents.edit.displayMode.name.edit.facets.title":
    "All Theme Appearances",
  "myAccount.page.myAgents.edit.overline": "Agent Settings",
  "myAccount.page.myAgents.edit.title": "Edit Agent",
  "myAccount.page.myAgents.edit.subtitle":
    "Configure behavior, instructions, visual style, and tool activation for this agent.",
  "myAccount.page.myAgents.edit.back": "Back to agents",
  "myAccount.page.myAgents.edit.tabs.general": "General",
  "myAccount.page.myAgents.edit.tabs.prompts": "Instructions",
  "myAccount.page.myAgents.edit.tabs.appearance": "Appearance",
  "myAccount.page.myAgents.edit.tabs.tools": "Agent Tools",
  "myAccount.page.myAgents.edit.preview": "Preview",
  "myAccount.page.myAgents.edit.appearance.empty": "No display selected.",
  "myAccount.page.myAgents.edit.tools.noCompany":
    "Company context is missing to load tools.",
  "myAccount.page.myAgents.edit.toast.load.error": "Failed to load agent.",
  "myAccount.page.myAgents.edit.toast.save.error":
    "Failed to save agent settings.",
  "myAccount.page.myAgents.edit.toast.save.success": "Agent settings saved.",
  "myAccount.page.myAgents.edit.save.saving": "Saving...",
  "myAccount.page.myAgents.edit.tools.loading": "Loading tools...",
  "myAccount.page.myAgents.edit.tools.empty":
    "No tools are currently available for your company.",
  "myAccount.page.myAgents.edit.tools.summary":
    "{enabledCount} of {totalCount} tools enabled on this agent.",
  "myAccount.page.myAgents.edit.tools.activationLabel":
    "Activation for this agent",
  "myAccount.page.myAgents.edit.tools.toggleAria":
    "Toggle tool activation for this agent",
  "myAccount.page.myAgents.edit.tools.agentInstructions.title":
    "Instructions for this Agent",
  "myAccount.page.myAgents.edit.tools.agentInstructions.help":
    "Adapt when and how this Agent should use the Tool. Platform safety rules remain enforced.",
  "myAccount.page.myAgents.edit.tools.agentInstructions.reset":
    "Use recommended instructions",
  "myAccount.page.myAgents.edit.tools.agentInstructions.custom":
    "Custom instructions are active.",
  "myAccount.page.myAgents.edit.tools.agentInstructions.default":
    "The Tool's recommended instructions are active.",
  "myAccount.page.myAgents.edit.tools.status.enabled": "Enabled",
  "myAccount.page.myAgents.edit.tools.status.disabled": "Disabled",
  "myAccount.page.myAgents.edit.tools.status.unsaved": "Unsaved changes",
  "myAccount.page.myAgents.edit.tools.noDescription":
    "No description available.",
  "myAccount.page.myAgents.edit.tools.toast.loadAvailable.error":
    "Failed to load available tools.",
  "myAccount.page.myAgents.edit.tools.toast.loadAgent.error":
    "Failed to load agent tools.",
  "myAccount.page.myAgents.edit.tools.toast.toggle.error":
    "Failed to update tool activation.",
  "myAccount.page.myAgents.edit.tools.toast.save.error":
    "Failed to save tool settings.",
  "myAccount.page.myAgents.edit.tools.toast.validation.title":
    "Please fix the tool configuration errors.",
  "myAccount.page.myAgents.edit.tools.validation.title": "Configuration issues",
  "myAccount.page.myAgents.edit.tools.validation.searchableUrl.requiredWhenEnabled":
    "At least one URL is required to enable this tool.",
  "myAccount.page.myAgents.edit.tools.validation.searchableUrl.invalidList":
    "Please enter valid http(s) URLs only.",

  "myAccount.page.myDNS.intro":
    "Manage the domains authorized for your company",
  "myAccount.page.myDNS.CTA.addFirstDNS": "Enter a domain",
  "myAccount.page.myDNS.CTA.addNewDNS": "Enter another domain",
  "myAccount.page.myDNS.CTA.save": "Save changes",
  "myAccount.page.myDNS.CTA.cancel": "Cancel changes",
  "myAccount.page.myDNS.CTA.confirmDelete": "Confirm removal",
  "myAccount.page.myDNS.CTA.delete": "Remove this domain",
  "myAccount.page.myDNS.empty": "No authorized domain has been entered yet.",
  "myAccount.page.myDNS.save.success":
    "Authorized domain names have been successfully updated",
  "myAccount.page.myDNS.save.failure":
    "Domain names could not be updated. Please contact support.",
  "myAccount.page.myDNS.delete.pending.title": "Removal pending",
  "myAccount.page.myDNS.delete.pending.description":
    "{count, plural, one {The domain {domains} remains authorized until you confirm its removal.} other {The domains {domains} remain authorized until you confirm their removal.}}",
  "myAccount.page.myDNS.delete.success":
    "{count, plural, one {The domain has been removed} other {The domains have been removed}}",

  "myAccount.page.profile.company.header.title": "Company settings",
  "myAccount.page.profile.company.header.desc":
    "Manage your company profile and spending preferences.",
  "myAccount.page.profile.company.defaultLocale.title":
    "Company communication language",
  "myAccount.page.profile.company.defaultLocale.description":
    "Used for messages ChatSystem sends to your team. An agent can override it when needed.",
  "myAccount.page.profile.title": "My profile",
  "myAccount.page.profile.company.name.title": "Company Name",
  "myAccount.page.profile.company.name.queryParamToAppend":
    "Query Param to Add",
  "myAccount.page.profile.company.profile.title": "Company profile",
  "myAccount.page.profile.company.placeholder": "Add your company name",
  "myAccount.page.profile.company.queryParam.placeholder":
    "Create a Query Param that will be added to all your URLs",
  "myAccount.page.profile.company.save.success":
    "Your company has been successfully updated.",
  "myAccount.page.company.save.failure":
    "Your company could not be updated. Please contact support.",
  "myAccount.page.profile.company.cannotEditMaxBudget":
    "Since your formula has a fixed spending threshold, you cannot modify this field.",
  "myAccount.page.profile.company.subscriptionPlan.unknown": "Uknown",
  "myAccount.page.profile.company.subscriptionPlan.label": "Subscription",
  "myAccount.page.profile.company.subscriptionPlan.hint.fixedShort":
    "Fixed threshold",
  "myAccount.page.profile.company.subscriptionPlan.hint.dynamicShort":
    "Budget configurable",
  "myAccount.page.profile.company.subscriptionPlan.availableDescription":
    "Compare the public and private plans currently available to your company.",
  "myAccount.page.profile.company.subscriptionPlan.availableAction":
    "View available plans",
  "myAccount.page.profile.company.subscriptionFormula.name.fullFixed": "Fixed",
  "myAccount.page.profile.company.subscriptionFormula.name.fixedIncreasable":
    "Fixed + Increasable per level",
  "myAccount.page.profile.company.subscriptionFormula.name.fixedPlusDynamic":
    "Fixed + Increasable dynamically",
  "myAccount.page.profile.company.subscriptionFormula.name.fullDynamic":
    "Completely Dynamic",
  "myAccount.page.profile.company.notSubscribed.message":
    "You're not subscribed, please subscribe to manage your payment settings.",
  "myAccount.page.profile.company.notSubscribed.cta": "Subscribe now",
  "myAccount.page.profile.company.currentConsumption.title":
    "Usage consumed this billing period",
  "myAccount.page.profile.company.currentConsumption.loading":
    "Loading current consumption...",
  "myAccount.page.profile.company.currentConsumption.error":
    "We couldn't load your current consumption.",
  "myAccount.page.profile.company.currentConsumption.value": "{amount}",
  "myAccount.page.profile.company.currentConsumption.subtitle":
    "Completed priced usage only; subscription price and available credit are excluded.",
  "myAccount.page.profile.company.currentConsumption.badge": "Up to date",

  "myAccount.page.myUserSessions.all.table.title": "User Discussions",
  "myAccount.page.myUserSessions.all.table.id": "Id",
  "myAccount.page.myUserSessions.all.table.agent": "Agent",
  "myAccount.page.myUserSessions.all.table.numberOfMessages":
    "Number of messages",
  "myAccount.page.myUserSessions.all.table.Totalduration": "Total Duration",
  "myAccount.page.myUserSessions.all.table.TFTduration": "TFT Duration",
  "myAccount.page.myUserSessions.all.table.COT": "COT",
  "myAccount.page.myUserSessions.all.table.LastUse": "Created at",
  "myAccount.page.myUserSessions.all.noUserSession":
    "You don't have any user discussion for now.",

  "admin.page.companies.all.table.title": "Companies",
  "admin.page.companies.all.table.id": "Id",
  "admin.page.companies.all.table.name": "Name",
  "admin.page.companies.all.table.mail": "Mail",
  "admin.page.companies.all.noCompanies":
    "There are not any companies for now.",
  "admin.page.companies.crud.edit.title": "Update a company",
  "admin.page.companies.crud.edit.agentsDisplayed.title": "Company Agents",
  "admin.page.companies.crud.create": "Create a company",
  "admin.page.companies.crud.create.success":
    "The company has been created successfully.",
  "admin.page.companies.crud.update.success":
    "The company has been updated successfully.",
  "admin.page.companies.activityReporting.title": "Discussion analysis",
  "admin.page.companies.activityReporting.description":
    "Analyze this company's customer discussions to add the metadata used by monthly reports.",
  "admin.page.companies.activityReporting.auto.enabled":
    "Automatic analysis enabled",
  "admin.page.companies.activityReporting.auto.disabled":
    "Automatic analysis disabled",
  "admin.page.companies.activityReporting.auto.saving": "Saving...",
  "admin.page.companies.activityReporting.manualHint":
    "The manual trigger analyzes root customer discussions and only reprocesses metadata that is missing or stale.",
  "admin.page.companies.activityReporting.metrics.totalDiscussions":
    "Total discussions",
  "admin.page.companies.activityReporting.metrics.eligibleDiscussions":
    "Eligible discussions",
  "admin.page.companies.activityReporting.metrics.generated": "Analyzed",
  "admin.page.companies.activityReporting.metrics.failed": "Failed",
  "admin.page.companies.activityReporting.metrics.skipped": "Skipped",
  "admin.page.companies.activityReporting.button.default":
    "Analyze discussions",
  "admin.page.companies.activityReporting.button.loading":
    "Analyzing discussions...",
  "admin.page.companies.activityReporting.toast.generate.success":
    "Discussion analysis finished.",
  "admin.page.companies.activityReporting.toast.generate.error":
    "Failed to analyze discussions.",
  "admin.page.companies.activityReporting.toast.autoSave.success":
    "Automatic analysis setting updated.",
  "admin.page.companies.activityReporting.toast.autoSave.error":
    "Failed to update automatic analysis.",

  "admin.page.agents.all.table.title": "Agents",
  "admin.page.agents.all.table.id": "Id",
  "admin.page.agents.all.table.name": "Name",
  "admin.page.agents.all.table.isDefault": "is Default",
  "admin.page.agents.all.table.company": "Company",
  "admin.page.agents.all.table.companyId": "Company Id",
  "admin.page.agents.all.table.implementation": "Agent type",
  "admin.page.agents.all.filters.implementation": "Agent type",
  "admin.page.agents.all.filters.allImplementations": "All Agent types",
  "admin.page.agents.all.filters.allCompanies": "Show all companies",
  "admin.page.agents.all.implementation.unassigned": "Legacy / unassigned",
  "admin.page.agents.all.company.unnamed": "Unnamed company",
  "admin.page.agents.all.company.none": "No company",
  "admin.page.agents.all.noAgents": "There are not any agents for now.",
  "admin.page.agents.crud.edit.title": "Update a Agent",
  "admin.page.agents.crud.edit.modernTitle": "Edit {name}",
  "admin.page.agents.crud.edit.eyebrow": "Agent configuration · #{agentId}",
  "admin.page.agents.crud.edit.subtitle":
    "Review its configuration, understand the prompt it receives and manage its connected knowledge and capabilities.",
  "admin.page.agents.crud.edit.back": "Back to Agents",
  "admin.page.agents.crud.edit.save": "Save changes",
  "admin.page.agents.crud.edit.loadError": "This Agent could not be loaded.",
  "admin.page.agents.crud.edit.nav.configuration": "Configuration",
  "admin.page.agents.crud.edit.nav.prompt": "Prompt",
  "admin.page.agents.crud.edit.nav.catalogs": "Catalogs",
  "admin.page.agents.crud.edit.nav.tools": "Tools",
  "admin.page.agents.crud.edit.configuration.title": "General configuration",
  "admin.page.agents.crud.edit.configuration.description":
    "Identity, presentation, runtime and persisted Agent settings.",
  "admin.page.agents.crud.edit.catalogs.description":
    "Knowledge sources currently connected to this Agent.",
  "admin.page.agents.crud.update.success":
    "The agent has been updated successfully.",

  "admin.page.catalogs.all.table.title": "Catalogs",
  "admin.page.catalogs.all.table.id": "Id",
  "admin.page.catalogs.all.table.name": "Name",
  "admin.page.catalogs.all.table.agentId": "Agent Id",
  "admin.page.catalogs.all.nocatalogs": "There are not any catalogs for now.",
  "admin.page.companies.crud.edit.catalogDisplayed.title": "Agent Catalogs",
  "admin.page.catalogs.crud.edit.title": "Update a Catalog",
  "admin.page.catalogs.crud.update.success":
    "The catalog has been updated successfully.",

  "admin.page.users.all.table.title": "Users",
  "admin.page.users.all.table.id": "Id",
  "admin.page.users.all.table.name": "Name",
  "admin.page.users.all.table.mail": "Mail",
  "admin.page.users.all.noUsers": "There are not any users for now.",
  "admin.page.users.crud.edit.title": "Update an user",
  "admin.page.users.crud.update.success":
    "The user has been updated successfully.",

  "myAccount.page.oneSession.title": "User Discussion",
  "myAccount.discussion.load.loading": "Loading the discussion…",
  "myAccount.discussion.load.error.title":
    "This discussion could not be displayed",
  "myAccount.discussion.load.error.description":
    "The discussion could not be loaded. Please try again in a moment.",
  "myAccount.discussion.load.retry": "Try again",

  "myAccount.page.myChatbot.errorBlockingAgentDisplay":
    "Some errors prevent the chatbot to display.",
  "myAccount.page.myChatbot.noSearchFilter.title": "No Search Filters",
  "myAccount.page.myChatbot.noSearchFilter":
    "You have no search filters setup for your chatbot. It means it cannot use criterias to search. Please set them up.",
  "myAccount.page.myChatbot.noProducts.title": "No products",
  "myAccount.page.myChatbot.noProducts":
    "You have no products setup for your chatbot. It means it cannot find anything. Please upload them.",
  "myAccount.page.myChatbot.noCatalogs.title": "No Catalog",
  "myAccount.page.myChatbot.noCatalogs":
    "You have no products catalogs for your chatbot. It means it cannot find or search anything. Please create them.",

  "admin.page.leftMenu.entity": "Entities",
  "admin.page.leftMenu.kpis": "KPIs",
  "admin.page.leftMenu.workflow": "Workflow",
  "admin.page.leftMenu.entities.companies": "Companies",
  "admin.page.leftMenu.entities.agents": "Agents",
  "admin.page.leftMenu.entities.catalogs": "Catalogs",
  "admin.page.leftMenu.entities.users": "Users",
  "admin.page.leftMenu.workflow.onboard": "Manual Onboard",
  "admin.page.leftMenu.adminTokens": "Admin API Tokens",

  "admin.apiTokens.title": "Admin API Tokens",
  "admin.apiTokens.subtitle": "Admin API Access",
  "admin.apiTokens.description":
    "Create a refresh token and mint short-lived access JWTs for programmatic admin access.",
  "admin.apiTokens.create.title": "Create a token",
  "admin.apiTokens.create.name": "Token name",
  "admin.apiTokens.create.scopes": "Scopes",
  "admin.apiTokens.create.scopesHelp": "Leave '*' for full access.",
  "admin.apiTokens.create.expires": "Expires in days",
  "admin.apiTokens.create.expiresHelp":
    "If empty, the token does not expire (until revoked).",
  "admin.apiTokens.create.cta": "Create token",
  "admin.apiTokens.working": "Working...",
  "admin.apiTokens.refreshOnce": "Refresh token (shown once)",
  "admin.apiTokens.refreshOnce.help":
    "Copy and store it now (password manager / vault / CI secrets).",
  "admin.apiTokens.tokenLabel": "Token",
  "admin.apiTokens.important": "Important",
  "admin.apiTokens.warning.once":
    "You will not be able to view this refresh token again.",
  "admin.apiTokens.warning.rotation":
    "Refresh tokens rotate: each mint call returns a NEW refresh token and revokes the previous one.",
  "admin.apiTokens.mint.title": "Mint access token",
  "admin.apiTokens.mint.refreshLabel": "Refresh token",
  "admin.apiTokens.mint.cta": "Mint access token",
  "admin.apiTokens.mint.accessLabel": "Access token (JWT)",
  "admin.apiTokens.mint.rotationTitle": "Refresh token rotated",
  "admin.apiTokens.mint.rotationBody":
    "A new refresh token was issued. Update your stored token now.",
  "admin.apiTokens.mint.newRefresh": "New refresh token",
  "admin.apiTokens.existing": "Existing tokens",
  "admin.apiTokens.revokeAll": "Revoke all",
  "admin.apiTokens.none": "No tokens yet.",
  "admin.apiTokens.revoke": "Revoke",
  "admin.apiTokens.tip":
    "Tip: refresh tokens rotate automatically when minting access tokens.",

  "admin.session.cost": "Cost (cents)",
  "admin.session.company": "Company",
  "admin.session.oneSession.cost": "Cost (cents)",
  "admin.session.oneSession.message.functionUsed": "Function:",
  "admin.session.oneSession.message.model": "Model",
  "admin.session.oneSession.message.provider": "Provider",
  "admin.session.oneSession.message.duration": "Duration",
  "admin.session.oneSession.message.cost": "Cost (cents)",
  "admin.subscriptionFormula.add": "Create an offer",
  "admin.subscriptionFormula.id": "Id",
  "admin.subscriptionFormula.fixedPrice": "Base Price",
  "admin.subscriptionFormula.BSPriceResell": "User Discussion Price",
  "admin.subscriptionFormula.isDisplayedOnFrontEnd": "Is Front-end",
  "admin.subscriptionFormula.subscriptionType": "Subscription Type",
  "admin.subscriptionFormula.noOne":
    "There are no susbcription formulas at the moment.",
  "admin.subscriptionFormula.page.create.title":
    "Create a new Subscription Formula",
  "admin.companyPicker.label": "Company",
  "admin.companyPicker.placeholder": "Search by company name or email…",
  "admin.companyPicker.loading": "Searching…",
  "admin.companyPicker.empty": "No company found.",
  "admin.companyPicker.error": "Companies could not be loaded.",
  "admin.companyPicker.unnamed": "Unnamed company",
  "admin.companyPicker.selected": "Selected: {name} (company #{id})",
  "admin.subscriptionOffer.list.eyebrow": "Billing operations",
  "admin.subscriptionOffer.list.description":
    "Create, version and publish public self-service or company-specific commercial terms. Drafts never create Stripe resources.",
  "admin.subscriptionOffer.list.loading": "Loading offers…",
  "admin.subscriptionOffer.list.name": "Name",
  "admin.subscriptionOffer.list.scope": "Scope",
  "admin.subscriptionOffer.list.lifecycle": "Lifecycle",
  "admin.subscriptionOffer.list.usageMode": "Usage mode",
  "admin.subscriptionOffer.list.usageFunding": "Usage funding",
  "admin.subscriptionOffer.list.version": "Version",
  "admin.subscriptionOffer.list.lines": "Price lines",
  "admin.subscriptionOffer.scope.public": "Public",
  "admin.subscriptionOffer.scope.private": "Private",
  "admin.subscriptionOffer.scope.company": "Company #{id}",
  "admin.subscriptionOffer.unnamed": "Unnamed offer",
  "admin.subscriptionOffer.create.eyebrow": "Commercial offer",
  "admin.subscriptionOffer.create.title":
    "Prepare terms without touching Stripe",
  "admin.subscriptionOffer.create.description":
    "Saving creates an internal draft with no customer effect. Review it on the next screen, then publish it explicitly before assigning a contract.",
  "admin.subscriptionOffer.create.saveDraft": "Save draft",
  "admin.subscriptionOffer.create.saving": "Saving…",
  "admin.subscriptionOffer.create.success": "Offer draft created.",
  "admin.subscriptionOffer.create.error": "The offer could not be created.",
  "admin.subscriptionOffer.edit.eyebrow": "Editable draft",
  "admin.subscriptionOffer.edit.title": "Correct the offer before publishing",
  "admin.subscriptionOffer.edit.description":
    "These changes replace this local draft only. They do not create or modify any Stripe resource.",
  "admin.subscriptionOffer.edit.success": "Offer draft updated.",
  "admin.subscriptionOffer.edit.submit": "Save changes",
  "admin.subscriptionOffer.edit.action": "Edit draft",
  "admin.subscriptionOffer.edit.unavailable.title":
    "This offer can no longer be edited",
  "admin.subscriptionOffer.edit.unavailable.description":
    "Only a local draft can be edited. Published terms remain immutable.",
  "admin.subscriptionOffer.version.eyebrow": "New commercial version",
  "admin.subscriptionOffer.version.title": "Prepare version {version}",
  "admin.subscriptionOffer.version.description":
    "Adjust the copied terms safely. The current published version and its contracts remain unchanged until this draft is published.",
  "admin.subscriptionOffer.version.success":
    "Next offer version created as a draft.",
  "admin.subscriptionOffer.version.action": "Prepare version {version}",
  "admin.subscriptionOffer.version.unavailable.title":
    "This offer cannot start a new version",
  "admin.subscriptionOffer.version.unavailable.description":
    "Use a published or retired offer. A private offer also requires its company to still exist.",
  "admin.subscriptionOffer.create.scope.eyebrow": "Offer scope",
  "admin.subscriptionOffer.create.scope.title":
    "Name the offer and choose its audience",
  "admin.subscriptionOffer.create.scope.description":
    "A public offer is available to every company. A private offer is reserved for one selected company.",
  "admin.subscriptionOffer.create.visibility.label": "Offer audience",
  "admin.subscriptionOffer.visibility.public": "Public / self-service",
  "admin.subscriptionOffer.visibility.public.help":
    "Published online for every company and eligible for the public pricing catalogue.",
  "admin.subscriptionOffer.visibility.private": "Private / company-specific",
  "admin.subscriptionOffer.visibility.private.help":
    "Available only to the selected company after publication.",
  "admin.publicOfferCatalog.eyebrow": "Public self-service catalogue",
  "admin.publicOfferCatalog.title": "Arrange the pricing page in one place",
  "admin.publicOfferCatalog.description":
    "Every published, Stripe-ready public offer appears here. Reorder the cards and select exactly one recommendation, then save both decisions together.",
  "admin.publicOfferCatalog.familyTitle":
    "Arrange pricing families in one place",
  "admin.publicOfferCatalog.familyDescription":
    "Pair one monthly and one yearly offer under the same card. Published versions remain immutable; only their public presentation is grouped here.",
  "admin.publicOfferCatalog.familyRecommendation.required":
    "Select the one pricing family customers should see as recommended before saving.",
  "admin.publicOfferCatalog.familyName": "Pricing family name",
  "admin.publicOfferCatalog.familySeparate":
    "Separate this variant into its own family",
  "admin.publicOfferCatalog.familyMissingVariant": "No published variant",
  "admin.publicOfferCatalog.familyPairWith": "Pair with a compatible family",
  "admin.publicOfferCatalog.familyPairChoose": "Choose the other variant…",
  "admin.publicOfferCatalog.familyRecommended": "Recommended family",
  "admin.publicOfferCatalog.save": "Save pricing presentation",
  "admin.publicOfferCatalog.saving": "Saving…",
  "admin.publicOfferCatalog.save.success": "Public pricing presentation saved.",
  "admin.publicOfferCatalog.save.error":
    "The public pricing presentation could not be saved.",
  "admin.publicOfferCatalog.empty":
    "No public offer is online yet. Publish a public draft to add its first card automatically.",
  "admin.publicOfferCatalog.recommendation.required":
    "Select the one offer customers should see as recommended before saving.",
  "admin.publicOfferCatalog.recommended": "Recommended",
  "admin.publicOfferCatalog.moveUp": "Move {name} up",
  "admin.publicOfferCatalog.moveDown": "Move {name} down",
  "admin.publicOfferCatalog.custom.last":
    "The contact card is managed by ChatSystem and always remains last.",
  "admin.subscriptionOffer.help.open": "Explain this field",
  "admin.subscriptionOffer.create.name.label": "Internal offer name",
  "admin.subscriptionOffer.create.name.placeholder":
    "For example: Playin annual 2026",
  "admin.subscriptionOffer.create.name.help":
    "Operator-only reference used to find and audit this exact offer version. Customers never see it.",
  "admin.subscriptionOffer.create.customerFacingName.label": "Commercial name",
  "admin.subscriptionOffer.create.customerFacingName.placeholder":
    "For example: ChatSystem Annual",
  "admin.subscriptionOffer.create.customerFacingName.help":
    "Commercial name shown to the customer in ChatSystem, Stripe Checkout, the invoice and the billing portal. It stays stable when the internal version changes.",
  "admin.subscriptionOffer.create.companyLocked":
    "Company #{id} · fixed for every version in this offer family",
  "admin.subscriptionOffer.create.usageMode.label": "Usage-control mode",
  "admin.subscriptionOffer.create.usageMode.help":
    "The mode records the intended enforcement policy. Runtime enforcement stays disabled until the billing rollout explicitly enables it.",
  "admin.subscriptionOffer.flow.eyebrow": "How this offer works",
  "admin.subscriptionOffer.flow.title": "Payment, credit, then consumption",
  "admin.subscriptionOffer.flow.description":
    "These are three distinct terms. Included credit is not itself a payment. A positive grant requires a recurring charge, but may exceed it as an intentional promotion.",
  "admin.subscriptionOffer.flow.promotion.title": "Promotional usage advantage",
  "admin.subscriptionOffer.flow.promotion.description":
    "{fixedPrice} charged for {credit} of usage value: a {advantage} promotional advantage ({multiplier}×). This is allowed and will require explicit confirmation when publishing.",
  "admin.subscriptionOffer.flow.notConfigured": "Not configured",
  "admin.subscriptionOffer.flow.charge.step": "1 · Customer payment",
  "admin.subscriptionOffer.flow.charge.title": "Stripe charges",
  "admin.subscriptionOffer.flow.charge.detail": "once per {period}",
  "admin.subscriptionOffer.flow.budget.step": "2 · Usage capacity",
  "admin.subscriptionOffer.flow.budget.title": "ChatSystem grants",
  "admin.subscriptionOffer.flow.budget.postpaid": "maximum monthly spend",
  "admin.subscriptionOffer.flow.budget.uncapped.value":
    "No contractual maximum",
  "admin.subscriptionOffer.flow.budget.uncapped":
    "all priced usage is billed later",
  "admin.subscriptionOffer.flow.budget.credit": "shared usage credit",
  "admin.subscriptionOffer.flow.usage.step": "3 · Consumption",
  "admin.subscriptionOffer.flow.usage.title": "Usage debits",
  "admin.subscriptionOffer.flow.usage.value":
    "{count, plural, =0 {No rate} one {# rate} other {# rates}}",
  "admin.subscriptionOffer.flow.usage.detail": "AI responses and priced tools",
  "admin.subscriptionOffer.funding.eyebrow": "2 · Usage capacity",
  "admin.subscriptionOffer.funding.title":
    "Choose how customer usage is funded and controlled",
  "admin.subscriptionOffer.funding.description":
    "Final AI responses and priced tools share this policy. Credit and limits are monetary capacity, while uncapped private usage is billed entirely after consumption.",
  "admin.subscriptionOffer.funding.mode.label": "Usage funding",
  "admin.subscriptionOffer.funding.mode.help":
    "This immutable policy decides whether usage is capped monthly, billed without a contractual maximum for one private customer, deducted from expiring credit, or deducted from credit that rolls forward.",
  "admin.subscriptionOffer.funding.mode.none":
    "Unbounded legacy mode — unavailable for new offers",
  "admin.subscriptionOffer.funding.mode.postpaid":
    "Monthly postpaid spending limit",
  "admin.subscriptionOffer.funding.mode.uncapped":
    "Uncapped postpaid usage — private offers only",
  "admin.subscriptionOffer.funding.mode.periodic":
    "Included credit that expires each billing period",
  "admin.subscriptionOffer.funding.mode.periodic.monthly":
    "Included credit renewed monthly — unused credit expires each month",
  "admin.subscriptionOffer.funding.mode.rolling":
    "Prepaid credit that rolls forward",
  "admin.subscriptionOffer.funding.none.description":
    "This historical mode does not stop usage. Select a bounded budget before saving a new offer version.",
  "admin.subscriptionOffer.funding.uncapped.title":
    "Usage billed without a contractual maximum",
  "admin.subscriptionOffer.funding.uncapped.description":
    "Every priced response and tool call is still reserved, journaled and invoiced. This mode has no recharge or included credit and can only be saved for one selected company.",
  "admin.subscriptionOffer.funding.postpaid.amount.label":
    "Monthly spending limit incl. tax (EUR)",
  "admin.subscriptionOffer.funding.postpaid.amount.help":
    "Maximum customer usage spend during one month. Actual usage is settled later.",
  "admin.subscriptionOffer.funding.postpaid.monthlyOnly":
    "A monthly postpaid limit requires a monthly offer. For an annual offer, choose monthly included credit or rolling prepaid credit.",
  "admin.subscriptionOffer.funding.credit.monthly.amount.label":
    "Usage credit renewed each month (EUR)",
  "admin.subscriptionOffer.funding.credit.monthly.amount.help":
    "Full shared usage credit renewed every month. For an annual offer, enter the monthly amount—not twelve months of credit. This field never creates a payment.",
  "admin.subscriptionOffer.funding.credit.rolling.amount.label":
    "Initial prepaid usage credit (EUR)",
  "admin.subscriptionOffer.funding.credit.rolling.amount.help":
    "Initial shared usage credit granted to the customer and carried forward. This field never creates a payment.",
  "admin.subscriptionOffer.funding.credit.monthly.yearlyNotice":
    "Annual payment, monthly credit: enter one month's credit here. Example: for €9 renewed every month, enter 9—not 108.",
  "admin.subscriptionOffer.funding.credit.monthly.monthlyNotice":
    "This full amount is renewed every month. Unused included credit expires at the next monthly boundary.",
  "admin.subscriptionOffer.funding.rechargeOptions.title":
    "Optional recharge packs",
  "admin.subscriptionOffer.funding.options.periodic.monthly.help":
    "Leave empty to disable recharges. Purchased credit remains valid for one month from its confirmed payment date and is consumed after the monthly included credit.",
  "admin.subscriptionOffer.funding.options.periodic.yearly.help":
    "Leave empty to disable recharges. Purchased credit remains valid for 12 months from its confirmed payment date and is consumed after the monthly included credit.",
  "admin.subscriptionOffer.funding.options.rolling.help":
    "Leave empty to disable recharges. Payment and granted usage credit may be equal or include a promotional bonus. Purchased credit remains available across later billing periods.",
  "admin.subscriptionOffer.funding.options.add": "+ Add a choice",
  "admin.subscriptionOffer.safety.fundingRequired":
    "Select a bounded usage budget. New offers cannot grant unlimited usage.",
  "admin.subscriptionOffer.safety.includedCreditRecurringPaymentRequired":
    "Positive included usage credit requires a positive recurring subscription price. The credit may exceed that price when the difference is an intentional promotion.",
  "admin.subscriptionOffer.safety.baselineRequired":
    "Add the AI responses component. Every customer-visible response must consume the shared budget.",
  "admin.subscriptionOffer.safety.baselinePriceRequired":
    "Set a strictly positive price for AI responses so the shared budget can stop usage.",
  "admin.subscriptionOffer.safety.metricCatalogUnavailable":
    "The required usage metrics could not be loaded. Refresh the page before creating this offer.",
  "admin.subscriptionOffer.funding.options.payment.label":
    "Pack {number}: customer pays incl. tax (EUR)",
  "admin.subscriptionOffer.funding.options.payment.help":
    "Amount collected immediately by Stripe when the customer buys this pack.",
  "admin.subscriptionOffer.funding.options.credit.label":
    "Usage credit granted (EUR)",
  "admin.subscriptionOffer.funding.options.credit.help":
    "Usage value added to the shared customer balance after payment confirmation. Set a higher amount to create a promotional bonus.",
  "admin.subscriptionOffer.funding.options.promotion":
    "Promotional bonus: {bonus} of additional usage value.",
  "admin.subscriptionOffer.funding.options.creditBelowPayment":
    "Granted usage credit must be at least equal to the amount paid.",
  "admin.subscriptionOffer.details.usageFunding": "Usage funding",
  "admin.subscriptionOffer.create.interval.label": "Billing period",
  "admin.subscriptionOffer.create.interval.help":
    "Every fixed and usage-based component follows this period. Publish a new offer version to change it.",
  "admin.subscriptionOffer.interval.monthly": "Monthly",
  "admin.subscriptionOffer.interval.yearly": "Yearly",
  "admin.subscriptionOffer.interval.monthly.short": "month",
  "admin.subscriptionOffer.interval.yearly.short": "year",
  "admin.subscriptionOffer.details.interval": "Billing period",
  "admin.subscriptionOffer.create.paymentGracePeriod.label":
    "Payment grace period (hours)",
  "admin.subscriptionOffer.create.paymentGracePeriod.help":
    "After a recoverable payment failure, access remains available for this duration. Use 0 to suspend access immediately.",
  "admin.subscriptionOffer.details.paymentGracePeriod": "Payment grace period",
  "admin.subscriptionOffer.details.paymentGracePeriod.value":
    "{hours, plural, =0 {Immediate suspension} one {# hour} other {# hours}}",
  "admin.subscriptionOffer.usageMode.observeOnly":
    "Observe only — measure usage without blocking",
  "admin.subscriptionOffer.usageMode.hardCap":
    "Included hard cap — stop when the limit is reached",
  "admin.subscriptionOffer.usageMode.overage":
    "Metered overage — bill usage above the allowance",
  "admin.subscriptionOffer.create.pricing.title": "Pricing components",
  "admin.subscriptionOffer.create.pricing.description":
    "Combine a recurring fixed amount with usage-based components when needed. Amounts are entered including tax.",
  "admin.subscriptionOffer.create.pricing.empty":
    "Add at least one pricing component.",
  "admin.subscriptionOffer.create.addFixed": "+ Fixed amount",
  "admin.subscriptionOffer.create.addMetered": "+ Metered usage",
  "admin.subscriptionOffer.create.fixed.eyebrow": "1 · Customer payment",
  "admin.subscriptionOffer.create.fixed.title":
    "Set the recurring subscription price",
  "admin.subscriptionOffer.create.fixed.description":
    "This is the amount Stripe charges each billing period. Positive included credit requires a positive subscription price, but may intentionally offer more usage value than the amount charged.",
  "admin.subscriptionOffer.create.fixed.empty.title":
    "No recurring customer payment",
  "admin.subscriptionOffer.create.fixed.empty.description":
    "Add a fixed amount if this offer grants included usage credit. The credit field does not charge the customer by itself.",
  "admin.subscriptionOffer.create.metered.eyebrow": "3 · Consumption",
  "admin.subscriptionOffer.create.metered.title":
    "Price what consumes the usage budget",
  "admin.subscriptionOffer.create.metered.description":
    "Each final AI response and each selected tool deducts its configured amount from the shared budget.",
  "admin.subscriptionOffer.create.metered.empty":
    "Add at least the final AI response rate so usage is always bounded.",
  "admin.subscriptionOffer.line.fixed": "Fixed",
  "admin.subscriptionOffer.line.metered": "Metered",
  "admin.subscriptionOffer.line.nickname.placeholder": "Line name (optional)",
  "admin.subscriptionOffer.line.remove": "Remove",
  "admin.subscriptionOffer.fixed.price":
    "Fixed amount per billing period incl. tax (EUR)",
  "admin.subscriptionOffer.fixed.price.placeholder": "For example: 29.00",
  "admin.subscriptionOffer.fixed.price.help":
    "Recurring amount charged once per selected billing period. For a yearly offer, enter the complete annual amount.",
  "admin.subscriptionOffer.price.invalid":
    "Enter a valid amount with at most two decimals.",
  "admin.subscriptionOffer.meter.trigger": "Usage event",
  "admin.subscriptionOffer.meter.trigger.help":
    "Versioned event measured by ChatSystem. Choosing it also fixes its unit, aggregation and block size.",
  "admin.subscriptionOffer.meter.metric.select": "Select measured usage",
  "admin.subscriptionOffer.metric.conversation.started.v1.name":
    "Started conversations",
  "admin.subscriptionOffer.metric.conversation.started.v1.description":
    "Counts conversations created for the company during the billing window.",
  "admin.subscriptionOffer.metric.ai.tokens.v1.name": "AI tokens",
  "admin.subscriptionOffer.metric.ai.tokens.v1.description":
    "Sums input and output tokens recorded for company conversations.",
  "admin.subscriptionOffer.metric.provider.brave.request.v1.name":
    "Brave Search requests",
  "admin.subscriptionOffer.metric.provider.brave.request.v1.description":
    "Counts persisted Brave Search provider requests for the company.",
  "admin.subscriptionOffer.meter.trigger.placeholder":
    "For example: DISCUSSION_ENDED",
  "admin.subscriptionOffer.meter.unit": "Measured unit",
  "admin.subscriptionOffer.meter.unit.help":
    "Canonical raw unit emitted by the selected usage event. It is fixed by the metric definition and cannot drift between offers.",
  "admin.subscriptionOffer.meter.unit.select": "Select a unit",
  "admin.subscriptionOffer.meter.aggregation": "Aggregation",
  "admin.subscriptionOffer.meter.aggregation.help":
    "How measured events are combined. Canonical launch metrics use a sum; this value comes from the metric registry.",
  "admin.subscriptionOffer.meter.aggregation.select": "Select an aggregation",
  "admin.subscriptionOffer.meter.scale": "Units per billed block",
  "admin.subscriptionOffer.meter.scale.help":
    "Number of raw units represented by one priced block. For example, 1,000,000 tokens per block.",
  "admin.subscriptionOffer.meter.scale.placeholder": "For example: 1 or 1000",
  "admin.subscriptionOffer.meter.pricingMode": "Pricing method",
  "admin.subscriptionOffer.meter.pricingMode.select": "Select a method",
  "admin.subscriptionOffer.meter.pricingMode.help":
    "Explicit sell uses the customer price you enter. Cost plus is analysis-only and cannot be published yet.",
  "admin.subscriptionOffer.meter.cost": "Cost per block incl. tax (EUR)",
  "admin.subscriptionOffer.meter.cost.help":
    "Internal estimated cost for one billed block. It is analysis data only and is never shown to customers.",
  "admin.subscriptionOffer.meter.cost.placeholder": "For example: 0.08",
  "admin.subscriptionOffer.meter.margin": "Target margin (%)",
  "admin.subscriptionOffer.meter.margin.help":
    "Analysis target compared with the internal cost. Cost-plus offers remain draft-only until their pricing policy is reproducible.",
  "admin.subscriptionOffer.meter.margin.placeholder": "For example: 40",
  "admin.subscriptionOffer.meter.sell":
    "Selling price per block incl. tax (EUR)",
  "admin.subscriptionOffer.meter.sell.placeholder": "For example: 0.12",
  "admin.subscriptionOffer.meter.sell.help":
    "Tax-inclusive customer charge for one billed block. All priced usage lines consume the offer's shared monetary capacity.",
  "admin.subscriptionOffer.lines.included": "Included usage:",
  "admin.subscriptionOffer.lines.hardCap": "Usage limit:",
  "admin.subscriptionOffer.lines.legacyAllowance":
    "Legacy metric allowance (read-only)",
  "admin.subscriptionOffer.lines.rechargePack": "Metric-specific usage pack:",
  "admin.subscriptionOffer.publish.confirm":
    "Publish this offer online? Its terms will be frozen and ChatSystem will create or verify its Stripe product, prices, meters and secure customer billing portal.",
  "admin.subscriptionOffer.publish.uncappedPostpaid":
    "private postpaid usage has no contractual maximum; every priced event will be billed after consumption",
  "admin.subscriptionOffer.publish.confirmReviewedTerms":
    "Publish this offer with these conditions?\n• {terms}\n\nConfirm that every condition is intentional. The terms will then be frozen and ChatSystem will prepare Stripe.",
  "admin.subscriptionOffer.publish.promotion.includedCredit":
    "subscription: {fixedPrice} charged for {credit} of usage value",
  "admin.subscriptionOffer.publish.promotion.rechargePack":
    "recharge: {price} charged for {credit} of usage credit (+{bonus} bonus)",
  "admin.subscriptionOffer.publish.error":
    "Online publication could not be completed. It is safe to retry.",
  "admin.subscriptionOffer.publish.success":
    "Offer published online. Stripe Checkout and billing management are ready.",
  "admin.subscriptionOffer.publish.publishing": "Publishing…",
  "admin.subscriptionOffer.publish.action": "Publish with Stripe payment",
  "admin.subscriptionOffer.publishOffline.confirm":
    "Publish this private offer for manual invoicing? Its terms will be frozen without creating any Stripe resource.",
  "admin.subscriptionOffer.publishOffline.confirmReviewedTerms":
    "Publish this offer with these conditions?\n• {terms}\n\nConfirm that every condition is intentional. The terms will then be frozen for manual invoicing outside Stripe.",
  "admin.subscriptionOffer.publishOffline.exceptionWarning":
    "⚠️ EXCEPTION — MANUAL INVOICING\n\nThis mode is reserved for exceptional enterprise contracts and must remain rare. It creates no Stripe payment or automatic collection.\n\nBefore continuing, verify that:\n• this company must intentionally be invoiced outside Stripe;\n• the selected company and every price are correct;\n• an operator will issue, follow up and record every invoice and payment.\n\nIf there is any doubt, cancel now and review the offer and customer agreement.",
  "admin.subscriptionOffer.publishOffline.error":
    "Manual-invoice publication could not be completed. It is safe to retry.",
  "admin.subscriptionOffer.publishOffline.success":
    "Private offer published for manual invoicing. No Stripe resource was created.",
  "admin.subscriptionOffer.publishOffline.action":
    "Publish with manual invoicing",
  "admin.subscriptionOffer.publicationChoice.eyebrow":
    "Publication and collection",
  "admin.subscriptionOffer.publicationChoice.title":
    "How should this offer be billed?",
  "admin.subscriptionOffer.publicationChoice.description":
    "Both choices freeze the same commercial version. They differ only in how payment is collected and evidenced.",
  "admin.subscriptionOffer.publicationChoice.stripe.title":
    "Automatic payment with Stripe",
  "admin.subscriptionOffer.publicationChoice.stripe.description":
    "Creates or verifies Stripe products, prices and meters. The customer pays through Checkout and manages billing in the secure portal.",
  "admin.subscriptionOffer.publicationChoice.offline.title":
    "Manual invoicing outside Stripe",
  "admin.subscriptionOffer.publicationChoice.offline.description":
    "Creates no Stripe resource. ChatSystem journals priced usage while an operator records invoice and payment evidence.",
  "admin.subscriptionOffer.details.back": "Back to offers",
  "admin.subscriptionOffer.details.notFound": "Subscription offer not found.",
  "admin.subscriptionOffer.details.draft.title": "Review before publishing",
  "admin.subscriptionOffer.details.draft.description":
    "This draft has no effect on customer access and created no Stripe resource. Verify its audience and every amount, then publish it explicitly.",
  "admin.subscriptionOffer.details.company": "Restricted company",
  "admin.subscriptionOffer.details.internalName": "Internal reference",
  "admin.subscriptionOffer.details.commercialModel": "Commercial model",
  "admin.subscriptionOffer.details.offerKey.help":
    "Stable technical identity shared by every version of the same commercial offer. It lets ChatSystem retire v1 and publish v2 without mixing their contracts or Stripe resources.",
  "admin.subscriptionOffer.details.usageMode": "Usage-control mode",
  "admin.subscriptionOffer.details.commercialPolicy": "Commercial policy",
  "admin.subscriptionOffer.details.created": "Created",
  "admin.subscriptionOffer.details.published": "Published",
  "admin.subscriptionOffer.details.companies": "Assigned customers",
  "admin.subscriptionOffer.details.lines": "Pricing components",
  "admin.subscriptionOffer.details.entitlements": "Entitlements",
  "admin.subscriptionOffer.details.pricing": "Commercial terms",
  "admin.subscriptionOffer.details.audience.public": "Public self-service",
  "admin.subscriptionOffer.details.audience.private": "Private company offer",
  "admin.subscriptionOffer.details.audience.allCompanies":
    "Available to every company",
  "admin.subscriptionOffer.details.visibility.public": "Public offer",
  "admin.subscriptionOffer.details.visibility.private": "Private offer",
  "admin.subscriptionOffer.details.visibility.help.open":
    "Explain this offer audience",
  "admin.subscriptionOffer.details.visibility.public.help":
    "After publication with Stripe, this offer can be subscribed to by every company and can appear in the public /pricing catalogue.",
  "admin.subscriptionOffer.details.visibility.private.help":
    "This offer is reserved for {company}. It never appears in the public /pricing catalogue and cannot be assigned to another company.",
  "admin.subscriptionOffer.details.hero.draft":
    "Review the customer price, included usage and metered rates below. Publication freezes these terms; then choose online collection with Stripe or manual invoicing for an eligible private offer.",
  "admin.subscriptionOffer.details.hero.published":
    "These commercial terms are immutable. Prepare a new version to change them without altering existing contracts.",
  "admin.subscriptionOffer.details.missingRecurringPayment.title":
    "Publication blocked: recurring payment is missing",
  "admin.subscriptionOffer.details.missingRecurringPayment.description":
    "This offer grants {credit} of usage without a positive recurring charge. Add a recurring subscription price. Its amount may remain below the credit when that promotional advantage is intentional.",
  "admin.subscriptionOffer.details.promotion.title": "Promotional usage value",
  "admin.subscriptionOffer.details.promotion.description":
    "The customer pays {fixedPrice} and receives {credit} of usage value per billing period. The {advantage} difference is an intentional commercial advantage, not an additional Stripe payment.",
  "admin.subscriptionOffer.details.promotion.rechargePack":
    "Price paid by the customer: {price} · Usage credit added: {credit} · Promotional bonus: +{bonus}.",
  "admin.subscriptionOffer.details.review.audience": "Audience",
  "admin.subscriptionOffer.summary.eyebrow": "Customer terms",
  "admin.subscriptionOffer.summary.title":
    "What the customer pays and receives",
  "admin.subscriptionOffer.summary.description":
    "This is the commercial contract that will be frozen when the offer is published.",
  "admin.subscriptionOffer.summary.recurring.eyebrow": "Recurring charge",
  "admin.subscriptionOffer.summary.recurring.title": "Subscription price",
  "admin.subscriptionOffer.summary.recurring.empty":
    "No recurring fixed charge is configured for this offer.",
  "admin.subscriptionOffer.summary.fixedFallback": "Recurring subscription",
  "admin.subscriptionOffer.summary.perMonth": "per month",
  "admin.subscriptionOffer.summary.perYear": "per year",
  "admin.subscriptionOffer.summary.usageBudget.eyebrow": "Usage budget",
  "admin.subscriptionOffer.summary.usageBudget.title": "Consumption control",
  "admin.subscriptionOffer.summary.usageBudget.postpaid":
    "Maximum usage billed during each monthly period.",
  "admin.subscriptionOffer.summary.usageBudget.uncapped.title":
    "No contractual maximum",
  "admin.subscriptionOffer.summary.usageBudget.uncapped":
    "Every priced usage event is journaled and billed after consumption. This private offer does not block at a monetary ceiling.",
  "admin.subscriptionOffer.summary.usageBudget.periodic":
    "Usage credit included each billing period; unused credit expires at the boundary.",
  "admin.subscriptionOffer.summary.usageBudget.periodic.monthly":
    "This full usage credit is renewed every month; unused included credit expires at the next monthly boundary.",
  "admin.subscriptionOffer.summary.usageBudget.rolling":
    "Usage credit included at activation; unused credit carries forward.",
  "admin.subscriptionOffer.summary.usageBudget.none":
    "No bounded usage budget is configured.",
  "admin.subscriptionOffer.summary.creditCadence.label":
    "Included-credit cadence",
  "admin.subscriptionOffer.summary.creditCadence.monthly": "Renewed monthly",
  "admin.subscriptionOffer.summary.creditCadence.billingPeriod":
    "Renewed each billing period",
  "admin.subscriptionOffer.summary.recharges": "Optional recharge packs",
  "admin.subscriptionOffer.summary.recharges.pack": "Pack {number}",
  "admin.subscriptionOffer.summary.recharges.promotionalBadge":
    "Promotional pack",
  "admin.subscriptionOffer.summary.recharges.paidLabel":
    "Price paid by the customer",
  "admin.subscriptionOffer.summary.recharges.creditLabel": "Usage credit added",
  "admin.subscriptionOffer.summary.recharges.bonusLabel":
    "Promotional bonus included",
  "admin.subscriptionOffer.summary.recharges.noBonus": "No bonus",
  "admin.subscriptionOffer.summary.recharges.validityLabel": "Credit validity",
  "admin.subscriptionOffer.summary.recharges.validityMonths":
    "{count, plural, one {# month after payment} other {# months after payment}}",
  "admin.subscriptionOffer.summary.recharges.validityLegacy":
    "Historical billing-period terms",
  "admin.subscriptionOffer.summary.usagePrices.eyebrow": "Measured usage",
  "admin.subscriptionOffer.summary.usagePrices.title":
    "What consumes the budget",
  "admin.subscriptionOffer.summary.usagePrices.perBlock":
    "per {count} measured unit(s)",
  "admin.subscriptionOffer.economicsLink.eyebrow": "Internal analysis",
  "admin.subscriptionOffer.economicsLink.title":
    "Analyze profitability separately",
  "admin.subscriptionOffer.economicsLink.description":
    "Project usage, provider costs and margin without changing this offer or customer billing.",
  "admin.subscriptionOffer.economicsLink.action": "Open profitability analysis",
  "admin.subscriptionOffer.technical.title":
    "Technical details and Stripe bindings",
  "admin.subscriptionOffer.technical.description":
    "Stable identifiers, policy versions, raw meters and provider resources.",
  "admin.subscriptionOffer.technical.offerKey": "Offer key",
  "admin.subscriptionOffer.technical.creditCadence": "Included-credit cadence",
  "admin.subscriptionOffer.technical.rechargeValidity":
    "Recharge-credit validity",
  "admin.subscriptionOffer.technical.rechargeValidityPack":
    "Pack {number}: {months, plural, one {# month} other {# months}}",
  "admin.subscriptionOffer.technical.rechargeValidityNone": "No recharge pack",
  "admin.subscriptionOffer.technical.legacyDefault": "legacy default",
  "admin.subscriptionOffer.lines.empty": "This offer has no pricing component.",
  "admin.subscriptionOffer.lines.type": "Type",
  "admin.subscriptionOffer.lines.name": "Name",
  "admin.subscriptionOffer.lines.price": "Price incl. tax",
  "admin.subscriptionOffer.lines.meter": "Usage meter",
  "admin.subscriptionOffer.lines.provider": "Payment-provider binding",
  "admin.subscriptionOffer.lines.kind": "Kind:",
  "admin.subscriptionOffer.lines.amount": "Amount:",
  "admin.subscriptionOffer.lines.meteredAmount": "Defined by the usage meter",
  "admin.subscriptionOffer.lines.unit": "Unit:",
  "admin.subscriptionOffer.lines.aggregation": "Aggregation:",
  "admin.subscriptionOffer.lines.trigger": "Event:",
  "admin.subscriptionOffer.lines.scale": "Block size:",
  "admin.subscriptionOffer.lines.mode": "Pricing method:",
  "admin.subscriptionOffer.lines.cost": "Cost:",
  "admin.subscriptionOffer.lines.margin": "margin",
  "admin.subscriptionOffer.lines.sell": "Selling price:",
  "admin.subscriptionOffer.lines.priceId": "Price ID:",
  "admin.subscriptionOffer.lines.meterId": "Meter ID:",
  "admin.subscriptionOffer.lines.providerEvent": "Provider event:",
  "admin.subscriptionOffer.simulation.eyebrow": "Economics",
  "admin.subscriptionOffer.simulation.back": "Back to the offer",
  "admin.subscriptionOffer.simulation.page.eyebrow":
    "Internal decision support",
  "admin.subscriptionOffer.simulation.page.title":
    "Profitability analysis — {offer}",
  "admin.subscriptionOffer.simulation.page.description":
    "Compare one explicit usage scenario with provider, payment and operating costs before making a commercial decision.",
  "admin.subscriptionOffer.simulation.page.safety":
    "Read-only: this page never changes the offer, Stripe, measured usage or customer access.",
  "admin.subscriptionOffer.simulation.title": "Commercial scenario simulator",
  "admin.subscriptionOffer.simulation.description":
    "Test this exact offer version against an explicit usage mix and cost assumptions. The simulation is read-only and never changes prices, usage, provider costs or customer access.",
  "admin.subscriptionOffer.simulation.usageVersion": "Usage-scenario version",
  "admin.subscriptionOffer.simulation.assumptionVersion":
    "Commercial-assumption version",
  "admin.subscriptionOffer.simulation.tax": "Tax rate (%)",
  "admin.subscriptionOffer.simulation.marginFloor": "Required margin floor (%)",
  "admin.subscriptionOffer.simulation.paymentRate": "Payment fee rate (%)",
  "admin.subscriptionOffer.simulation.paymentFixed": "Fixed payment fee (EUR)",
  "admin.subscriptionOffer.simulation.operatingCost":
    "Allocated infrastructure and support cost (EUR)",
  "admin.subscriptionOffer.simulation.metricMix": "Expected measured usage",
  "admin.subscriptionOffer.simulation.blockSize":
    "Offer block: {count} raw units",
  "admin.subscriptionOffer.simulation.expectedQuantity":
    "Expected raw quantity",
  "admin.subscriptionOffer.simulation.costPerBlock":
    "Estimated cost per block (EUR)",
  "admin.subscriptionOffer.simulation.costVersion": "Cost-assumption version",
  "admin.subscriptionOffer.simulation.running": "Calculating…",
  "admin.subscriptionOffer.simulation.run": "Run simulation",
  "admin.subscriptionOffer.simulation.precision":
    "Money accepts up to six decimals; percentages accept two.",
  "admin.subscriptionOffer.simulation.invalid":
    "Complete every assumption with a non-negative exact value and a version.",
  "admin.subscriptionOffer.simulation.error":
    "The commercial simulation could not be run.",
  "admin.subscriptionOffer.simulation.ready": "Scenario meets the margin floor",
  "admin.subscriptionOffer.simulation.belowFloor":
    "Scenario is below the margin floor",
  "admin.subscriptionOffer.simulation.noRevenue":
    "Scenario has no customer revenue",
  "admin.subscriptionOffer.simulation.fingerprint": "Scenario reference",
  "admin.subscriptionOffer.simulation.fixedRevenue": "Fixed revenue incl. tax",
  "admin.subscriptionOffer.simulation.meteredRevenue":
    "Metered revenue incl. tax",
  "admin.subscriptionOffer.simulation.revenueInclTax": "Revenue incl. tax",
  "admin.subscriptionOffer.simulation.revenueExTax": "Revenue excl. tax",
  "admin.subscriptionOffer.simulation.variableCost": "Estimated variable cost",
  "admin.subscriptionOffer.simulation.operatingCostResult":
    "Allocated operating cost",
  "admin.subscriptionOffer.simulation.paymentCost": "Estimated payment fees",
  "admin.subscriptionOffer.simulation.totalCost": "Estimated total cost",
  "admin.subscriptionOffer.simulation.marginAmount": "Projected margin",
  "admin.subscriptionOffer.simulation.metric": "Metric",
  "admin.subscriptionOffer.simulation.expected": "Expected / included",
  "admin.subscriptionOffer.simulation.billable": "Billable",
  "admin.subscriptionOffer.simulation.metricRevenue": "Customer revenue",
  "admin.subscriptionOffer.simulation.metricCost": "Estimated cost",
  "admin.subscriptionOffer.simulation.costVersionShort": "Cost version",
  "admin.subscriptionOffer.simulation.hardCapWarning":
    "The expected mix exceeds at least one offer usage limit; it is not reachable without additional purchased capacity.",
  "admin.page.leftMenu.entities.tools": "Tools",
  "admin.kpis.eyebrow": "SaaS activity",
  "admin.kpis.title": "KPIs",
  "admin.kpis.subtitle":
    "A cross-company dashboard for discussions and tool activity. Data is served from reporting read models to keep admin pages fast.",
  "admin.kpis.lastUpdated": "Last updated",
  "admin.kpis.refreshCadence": "Materialized views refresh every hour.",
  "admin.kpis.error":
    "We could not load the KPI dashboard. Please try again later.",
  "admin.kpis.empty": "No KPI data available yet.",
  "admin.kpis.monthlyDiscussions.title": "Monthly discussions",
  "admin.kpis.monthlyDiscussions.subtitle":
    "Root non-internal discussions over the last {months} months, split by company.",
  "admin.kpis.dailyDiscussions.title": "Daily discussions this month",
  "admin.kpis.dailyDiscussions.subtitle":
    "Current-month non-internal discussions, split by company.",
  "admin.kpis.monthlyToolUsage.title": "Monthly tool usage",
  "admin.kpis.monthlyToolUsage.subtitle":
    "Tool calls over the last {months} months, split by company.",
  "admin.page.tools.title": "Tools",
  "admin.page.tools.table.name": "Name",
  "admin.page.tools.table.type": "Type",
  "admin.page.tools.table.execution": "Execution",
  "admin.page.tools.table.active": "Active",
  "admin.page.tools.table.public": "Public",
  "admin.page.tools.table.company": "Company",
  "admin.page.tools.table.actions": "Actions",
  "admin.page.tools.scope.title": "Company Availability Management",
  "admin.page.tools.scope.loadingTools": "Loading tools...",
  "admin.page.tools.scope.toolCount": "{count} tools",
  "admin.page.tools.scope.createTool": "Create Tool",
  "admin.page.tools.scope.noToolsFound": "No tools found.",
  "admin.page.tools.scope.toolLabel": "Tool",
  "admin.page.tools.scope.selectTool": "Select a tool",
  "admin.page.tools.scope.companySearchLabel": "Company Search",
  "admin.page.tools.scope.companySearchPlaceholder": "Type company name...",
  "admin.page.tools.scope.searching": "Searching...",
  "admin.page.tools.scope.noCompaniesFound": "No companies found.",
  "admin.page.tools.scope.selectedCompany": "Selected Company:",
  "admin.page.tools.scope.companyIdLabel": "ID",
  "admin.page.tools.scope.noCompanySelected": "No company selected.",
  "admin.page.tools.scope.company.noName": "(no name)",
  "admin.page.tools.scope.offerability.title": "Tool Offerability",
  "admin.page.tools.scope.offerability.subtitle":
    "Define which company can see and receive this tool.",
  "admin.page.tools.scope.offerability.originLabel": "Tool Offerability Origin",
  "admin.page.tools.scope.offerability.originPlaceholder": "admin",
  "admin.page.tools.scope.offerability.submit": "Create / Update Offer",
  "admin.page.tools.scope.offerability.existing": "Existing offers",
  "admin.page.tools.scope.offerability.empty": "No offers for this tool.",
  "admin.page.tools.scope.activation.title": "Tool Activation",
  "admin.page.tools.scope.activation.subtitle":
    "Define if this selected company can actively use this tool.",
  "admin.page.tools.scope.activation.submit": "Create / Update Activation",
  "admin.page.tools.scope.activation.existing": "Existing activations",
  "admin.page.tools.scope.activation.empty": "No activations for this tool.",
  "admin.page.tools.scope.enabled": "Enabled",
  "admin.page.tools.scope.disabled": "Disabled",
  "admin.page.tools.scope.saving": "Saving...",
  "admin.page.tools.scope.loading": "Loading...",
  "admin.page.tools.scope.companyRow": "Company {companyId}",
  "admin.page.tools.scope.remove": "Remove",
  "admin.page.tools.scope.toast.loadTools.error": "Failed to load tools",
  "admin.page.tools.scope.toast.loadOffers.error": "Failed to load tool offers",
  "admin.page.tools.scope.toast.loadActivations.error":
    "Failed to load tool activations",
  "admin.page.tools.scope.toast.loadCompanies.error":
    "Failed to load companies",
  "admin.page.tools.scope.toast.searchCompanies.error":
    "Failed to search companies",
  "admin.page.tools.scope.toast.selectToolFirst": "Select a tool first.",
  "admin.page.tools.scope.toast.selectCompanyFirst": "Select a company first.",
  "admin.page.tools.scope.toast.saveOffer.error": "Failed to save offer",
  "admin.page.tools.scope.toast.saveOffer.updated": "Offer updated.",
  "admin.page.tools.scope.toast.saveOffer.created": "Offer created.",
  "admin.page.tools.scope.toast.saveActivation.error":
    "Failed to save activation",
  "admin.page.tools.scope.toast.saveActivation.updated": "Activation updated.",
  "admin.page.tools.scope.toast.saveActivation.created": "Activation created.",
  "admin.page.tools.scope.toast.deleteOffer.error": "Failed to delete offer",
  "admin.page.tools.scope.toast.deleteOffer.success": "Offer removed.",
  "admin.page.tools.scope.toast.deleteActivation.error":
    "Failed to delete activation",
  "admin.page.tools.scope.toast.deleteActivation.success":
    "Activation removed.",
  "admin.page.tools.scope.toast.toggleActivation.error":
    "Failed to toggle activation",
  "admin.page.agents.tools.title": "Agent Tools",
  "admin.page.agents.tools.description":
    "Manage the capabilities connected to this Agent and whether they are currently active.",
  "admin.page.agents.tools.attach.label": "Attach a tool",
  "admin.page.agents.tools.attach.cta": "Attach",
  "admin.page.agents.tools.table.tool": "Tool",
  "admin.page.agents.tools.table.type": "Type",
  "admin.page.agents.tools.table.enabled": "Enabled",
  "admin.page.agents.tools.table.actions": "Actions",
  "admin.page.agents.tools.empty": "No tools attached yet.",
  "admin.page.agents.tools.detach": "Detach",

  "myAccount.page.myAgents.edit.tabs.search": "Product Search",
  "myAccount.searchProfiles.legacy": "Legacy",
  "myAccount.searchProfiles.collection": "Product collection:",
  "myAccount.searchProfiles.collectionFallback": "Collection #",
  "myAccount.searchProfiles.filters": "Filters",
  "myAccount.searchProfiles.agents": "Agents",
  "myAccount.searchProfiles.edit": "Edit profile",
  "myAccount.searchProfiles.detach": "Detach profile",
  "myAccount.searchProfiles.assign": "Assign profile",
  "myAccount.searchProfiles.delete": "Delete profile",
  "myAccount.searchProfiles.title": "Search profiles",
  "myAccount.tools.browse.all": "All",
  "myAccount.page.myAgents.edit.tools.urlEditor.label": "URLs to consult",
  "myAccount.page.myAgents.edit.tools.urlEditor.hint": "Enter one URL per line.",
  "myAccount.page.myAgents.edit.tools.urlEditor.placeholder": "https://www.my-website.com\nhttps://my-other-website.com",
  "myAccount.tools.browse.loadError": "We couldn’t load your tools. Could you try again?",
  "myAccount.tools.browse.retry": "Try again",
  "myAccount.tools.browse.support": "Customer support",
  "myAccount.tools.browse.information": "Information",
  "myAccount.tools.browse.products": "Products",
  "myAccount.tools.browse.other": "Other tools",
  "myAccount.tools.browse.search": "Find a tool",
  "myAccount.tools.browse.enabledOnly": "Enabled",
  "myAccount.tools.browse.customOnly": "Custom",
  "myAccount.tools.browse.categories": "Tool categories",
  "myAccount.tools.browse.reset": "Clear filters",
  "myAccount.tools.browse.configure": "Configure",
  "myAccount.tools.browse.collapse": "Close settings",
  "myAccount.tools.browse.configureAria": "Configure {name}",
  "myAccount.tools.browse.collapseAria": "Close settings for {name}",
  "myAccount.tools.browse.activationAria": "Enable {name} for this Agent",
  "myAccount.tools.browse.needsAttention": "Needs attention",
  "myAccount.tools.browse.issues": "{count, plural, one {One tool needs attention before saving.} other {# tools need attention before saving.}}",
  "myAccount.tools.browse.showAll": "Show all tools",
  "myAccount.tools.browse.results": "{count, plural, =0 {No matching tools} one {One tool shown} other {# tools shown}}",
  "myAccount.tools.browse.noResults": "Try another name or clear the filters to see your tools.",
  "myAccount.searchProfiles.setup.title": "Help your Agent find the right products",
  "myAccount.searchProfiles.setup.scope": "This tab is for your Agent’s product recommendations. If you don’t use this feature, you can leave it aside.",
  "myAccount.searchProfiles.setup.collection": "Prepare a product collection with its search fields, then import your products.",
  "myAccount.searchProfiles.setup.collectionsLink": "My collections",
  "myAccount.searchProfiles.setup.profile": "Create a profile below to choose the search criteria, or assign an existing profile to this Agent.",
  "myAccount.searchProfiles.setup.tool": "Check that a compatible product-search tool is configured and enabled in",
  "myAccount.searchProfiles.setup.availability": "No product-search tool available? Contact us to prepare your integration. A profile alone does not enable search.",
  "myAccount.searchProfiles.assignedCount":
    "{count, plural, =0 {No profile assigned} one {# profile assigned} other {# profiles assigned}} to this agent",
  "myAccount.searchProfiles.deleteAction": "Delete",
  "myAccount.searchProfiles.new": "New profile",
  "myAccount.searchProfiles.loading": "Loading...",
  "myAccount.searchProfiles.assigned": "Assigned",
  "myAccount.searchProfiles.assignedEmpty": "No search profile assigned.",
  "myAccount.searchProfiles.available": "Available in the company",
  "myAccount.searchProfiles.availableEmpty": "No available search profile.",
  "myAccount.searchProfiles.deleteConfirm": "Delete {name}?",
  "myAccount.searchProfiles.editor.defaultFunctionDescription":
    "Search matching products.",
  "myAccount.searchProfiles.editor.defaultBooleanDescription":
    "Does the product match {field}?",
  "myAccount.searchProfiles.editor.defaultFilterDescription":
    "Requested value for {field}.",
  "myAccount.searchProfiles.editor.editTitle": "Edit search profile",
  "myAccount.searchProfiles.editor.newTitle": "New search profile",
  "myAccount.searchProfiles.editor.collection": "Product collection",
  "myAccount.searchProfiles.editor.function": "Search function",
  "myAccount.searchProfiles.editor.functionName": "Function name",
  "myAccount.searchProfiles.editor.functionDescription": "Function description",
  "myAccount.searchProfiles.editor.filters": "Search filters",
  "myAccount.searchProfiles.editor.productField": "Product field",
  "myAccount.searchProfiles.editor.selectField": "Select a product field",
  "myAccount.searchProfiles.editor.addFilter": "Add filter",
  "myAccount.searchProfiles.editor.filtersEmpty":
    "No search filter configured.",
  "myAccount.searchProfiles.editor.filterName": "Filter name",
  "myAccount.searchProfiles.editor.semanticDescription": "Semantic description",
  "myAccount.searchProfiles.editor.required": "Required",
  "myAccount.searchProfiles.editor.removeFilter": "Remove filter",
  "myAccount.searchProfiles.toast.loadError":
    "Failed to load search configuration.",
  "myAccount.searchProfiles.toast.saveError": "Failed to save search profile.",
  "myAccount.searchProfiles.toast.saved": "Search profile saved.",
  "myAccount.searchProfiles.toast.assignError":
    "Failed to assign search profile.",
  "myAccount.searchProfiles.toast.detachError":
    "Failed to detach search profile.",
  "myAccount.searchProfiles.toast.deleteError":
    "Failed to delete search profile.",

  "chatbot.placeholder.content": "Message the assistant...",
  "chatbot.chatline.label.user": "You",
  "chatbot.chatline.label.assistant": "Assistant",
  "chatbot.chatline.loading.function.genericSearchMessage":
    "I'm looking for products",
  "chatbot.chatline.loading.function.search": "Search",
  "chatbot.chatline.loading.function.extractProductName":
    "Looking into the cavern",
  "chatbot.chatline.loading.function.suggestProductName":
    "Consulting the shadocks",
  "chatbot.chatline.loading.function.criteriaDefinition":
    "Looking for ziboublis",
  "chatbot.chatline.loading.function.searchStock": "Searching Stock",
  "chatbot.chatline.loading.function.step": "Step",

  "footer.tab.title.general": "General",
  "footer.tab.title.about": "About",
  "footer.tab.title.resources": "Resources",
  "footer.tab.title.legal": "Legal",
  "footer.tab.title.social": "Social",
  "footer.tab.title.articles": "Articles",
  "footer.tab.title.chatbot": "Chatbot",
  "footer.tab.title.data_augmentation": "Data Augmentation",
  "footer.tab.search": "Search",
  "footer.tab.pricing": "Pricing",
  "footer.tab.termsAndConditions": "Terms and conditions",
  "footer.tab.documentation": "Documentation",
  "footer.link.email": "Email us",
  "footer.gdpr.compliant": "GDPR Compliant",
  "footer.tab.finalCopyright":
    "Copyright © 2026 Chatsystem, Inc. All rights reserved.",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.loading": "Loading…",
  "myAccount.page.leftMenu.identityDelegation": "Identity Delegation",
  "identityDelegation.eyebrow": "Developer workflow",
  "identityDelegation.title": "Identity Delegation",
  "identityDelegation.documentation.metaTitle":
    "Identity Delegation integration guide | ChatSystem",
  "identityDelegation.documentation.metaDescription":
    "Connect your existing login system to ChatSystem and secure the actions performed for your users.",
  "identityDelegation.subtitle":
    "Let an agent perform authorized, read-only actions for a user already signed in to your website—without exposing your session cookie or customer API credentials to the widget.",
  "identityDelegation.status.ready": "Ready",
  "identityDelegation.status.actionRequired": "Action required",
  "identityDelegation.refresh": "Refresh readiness",
  "identityDelegation.readiness.title": "ChatSystem setup readiness",
  "identityDelegation.readiness.progress":
    "{ready} of {total} platform steps ready",
  "identityDelegation.readiness.application": "Application boundary",
  "identityDelegation.readiness.mintKey": "Mint credential",
  "identityDelegation.readiness.delegatedTool": "Delegated tool",
  "identityDelegation.readiness.agentAssignment": "Agent assignment",
  "identityDelegation.readiness.error":
    "Some readiness information could not be loaded. Refresh to try again.",
  "identityDelegation.readiness.boundary":
    "Readiness confirms saved ChatSystem resources only. Validate your customer endpoint and business authorization in your own integration before using the tool with customers.",
  "identityDelegation.application.title":
    "Choose the widget installation and its allowed websites",
  "identityDelegation.application.description":
    "The app token identifies the widget installation used by this integration. Authorized domains are the website origins allowed to initialize ChatSystem; they protect the widget generally rather than enabling Identity Delegation per domain.",
  "identityDelegation.application.action": "Manage authorized domains",
  "identityDelegation.application.appToken": "Widget app token",
  "identityDelegation.application.noToken":
    "No app token associated with this company",
  "identityDelegation.application.noTokenHelp":
    "App tokens are normally provisioned with the company. Contact ChatSystem support before continuing if none is listed.",
  "identityDelegation.application.noCompanyHelp":
    "Your user is not associated with a company. Associate the account with the intended company before configuring this integration.",
  "identityDelegation.application.domains": "Authorized domains",
  "identityDelegation.mint.title": "Create the server-only mint credential",
  "identityDelegation.mint.description":
    "Your backend uses this narrowly scoped secret to exchange its authenticated user for a short-lived widget identity. Copy it once into your secret manager; never send it to the browser.",
  "identityDelegation.mintKey.title": "Widget identity mint key",
  "identityDelegation.mintKey.subtitle":
    "Create the server-only credential used by your backend to mint short-lived widget identities. It is shown only once.",
  "identityDelegation.mintKey.scopeHelp":
    "This key is locked to widget-identity:mint and must remain on your backend.",
  "identityDelegation.endpoint.title": "Add a same-origin identity endpoint",
  "identityDelegation.endpoint.description":
    "Your server authenticates the visitor using your existing login system, decides what that account may do, and asks ChatSystem for a short-lived identity using the server-only key from the previous step.",
  "identityDelegation.endpoint.serverBoundary.title":
    "This code belongs in your server application",
  "identityDelegation.endpoint.serverBoundary.description":
    "Add an endpoint to the backend that already authenticates your customers. Do not implement this exchange in React, the widget bundle, a tag manager, or any other browser code: the mint key created above is a server secret.",
  "identityDelegation.endpoint.flow.title":
    "What the endpoint must do on every request",
  "identityDelegation.endpoint.flow.authenticate":
    "Authenticate the incoming request using your normal server-side mechanism: for example a secure session cookie, SSO middleware, or an access token already used by your application.",
  "identityDelegation.endpoint.flow.signedOut":
    "If no user is authenticated, return HTTP 204 with no identity. Anonymous chat can continue, but protected tools will request login when needed.",
  "identityDelegation.endpoint.flow.subject":
    "Choose the internal ID that already identifies this customer in your database—for example a customer account UUID. Do not use an email address or phone number, and never reuse this ID for another person.",
  "identityDelegation.endpoint.flow.capabilities":
    "Build the list of actions this account is allowed to perform. For example, add orders:read only if the signed-in customer may view orders. Build this list in your backend, not from values sent by the browser.",
  "identityDelegation.endpoint.flow.mint":
    "Your backend now sends ChatSystem the selected app token, the customer ID and the allowed actions. Authenticate this server-to-server request with the secret key created in step 2.",
  "identityDelegation.endpoint.flow.return":
    "The POST request to ChatSystem returns JSON containing a short-lived token and its expiration time. Your backend passes this JSON response to the widget. This is not the app token: it is a temporary identity created for the signed-in customer. Never send the secret key, your session cookie or the customer’s password to the browser.",
  "identityDelegation.endpoint.context.authentication.title":
    "Reuse your authentication",
  "identityDelegation.endpoint.context.authentication.description":
    "The endpoint may use your existing secure session cookie, SSO middleware, access token, or another backend authentication mechanism. ChatSystem does not choose or replace it.",
  "identityDelegation.endpoint.context.capabilities.title":
    "Grant narrow capabilities",
  "identityDelegation.endpoint.context.capabilities.description":
    "Derive permissions from your current server-side account state—for example orders:read or subscriptions:read. Never accept a capability list supplied by the browser.",
  "identityDelegation.endpoint.context.security.title": "Keep your authority",
  "identityDelegation.endpoint.context.security.description":
    "Your cookie and password never leave your infrastructure. The short-lived identity only tells ChatSystem which opaque user and capabilities your backend has just confirmed.",
  "identityDelegation.endpoint.context.expiration.title":
    "Let ChatSystem manage expiration",
  "identityDelegation.endpoint.context.expiration.description":
    "Do not choose or send a lifetime. ChatSystem currently limits the identity to at most five minutes and returns its expiration. The widget keeps it only in memory and requests a fresh identity shortly before it expires. Authenticate the session and recalculate capabilities on every request; do not cache the minted identity yourself.",
  "identityDelegation.endpoint.stakeholder.title": "In short:",
  "identityDelegation.endpoint.stakeholder.description":
    "you keep authentication and business authorization in your own backend. ChatSystem limits the lifetime of the proof and the widget renews it when needed; you do not manage this duration. Your API still checks current resource ownership whenever the agent uses a protected tool.",
  "identityDelegation.widget.title": "Connect identity to the frontend widget",
  "identityDelegation.widget.description":
    "Choose the npm component or the bundled browser API. Both provide identity on demand and notify the same widget after login, logout or account switching. Identity remains in memory and is never placed in HTML attributes or browser storage.",
  "identityDelegation.widget.explanation.location.title":
    "Choose one frontend integration",
  "identityDelegation.widget.explanation.location.description":
    "Use either the npm component or the programmatic index.js bundle shown below. Both mount the same ChatSystem client and call the server endpoint from step 3; the secret mint key never appears here.",
  "identityDelegation.widget.explanation.getToken.title":
    "Provide identity when requested",
  "identityDelegation.widget.explanation.getToken.description":
    "The widget calls getToken silently when it opens, before a prompt when needed, and near expiration. If a protected tool requires login, interactive becomes true: open your existing login UI, then call the same endpoint again.",
  "identityDelegation.widget.explanation.subscribe.title":
    "Report account changes",
  "identityDelegation.widget.explanation.subscribe.description":
    "Connect subscribe to your existing authentication events. After login, logout or an account switch completes, call the callback supplied by ChatSystem so it discards the old in-memory identity and reads the current one.",
  "identityDelegation.widget.npm.title": "If you use React",
  "identityDelegation.widget.npm.codeLabel":
    "Frontend code / @chatsystem/client",
  "identityDelegation.widget.bundle.title": "If you use the bundled script",
  "identityDelegation.widget.bundle.codeLabel":
    "Frontend code / bundled script",
  "identityDelegation.widget.tabs.label": "Frontend integration method",
  "identityDelegation.widget.scriptBoundary":
    'The existing declarative <script data-appToken="…"> embed remains supported for anonymous widgets. Identity Delegation uses the same index.js bundle without data-appToken, followed by ChatSystem.mount(...) so your frontend can provide the identity functions.',
  "identityDelegation.verifier.title": "Protect your tool endpoint",
  "identityDelegation.verifier.description":
    "Add this check to the customer backend route that receives ChatSystem tool calls. It confirms who sent the request and which customer it represents; your backend then decides whether that customer may access the requested data.",
  "identityDelegation.verifier.explanation.location.title":
    "Put this in your tool endpoint",
  "identityDelegation.verifier.explanation.location.description":
    "This code belongs in the customer backend, at the start of the HTTPS route that ChatSystem will call. It does not belong in React, index.js, or any other browser code.",
  "identityDelegation.verifier.explanation.proof.title":
    "Confirm the call came from ChatSystem",
  "identityDelegation.verifier.explanation.proof.description":
    "The maintained verifier checks the signature, expiration, intended company, widget and tool, required capabilities, and that the same request is not used twice. If valid, it returns the customer’s opaque subject.",
  "identityDelegation.verifier.explanation.authorization.title":
    "Check access in your own database",
  "identityDelegation.verifier.explanation.authorization.description":
    "Use that subject to find the current customer account, then verify that it may still access the requested order, subscription, or other resource. A valid ChatSystem proof never grants access by itself.",
  "identityDelegation.verifier.tabs.label": "Customer backend code",
  "identityDelegation.verifier.tabs.endpoint": "In your endpoint",
  "identityDelegation.verifier.tabs.utilities": "Node utilities",
  "identityDelegation.verifier.endpoint.codeLabel":
    "Customer endpoint / TypeScript",
  "identityDelegation.verifier.utilities.codeLabel":
    "Node utilities / TypeScript",
  "identityDelegation.guide.action":
    "Open the complete integration guide and maintained examples",
  "identityDelegation.tool.title":
    "Register the protected API as a delegated tool",
  "identityDelegation.tool.description":
    "Describe the fixed HTTPS endpoint, exact audience, required capabilities and request/response schemas. ChatSystem—not the browser—adds the short-lived invocation JWT.",
  "identityDelegation.tool.action": "Create delegated tool",
  "identityDelegation.tool.existing.title": "Existing delegated tools",
  "identityDelegation.tool.existing.active": "Active",
  "identityDelegation.tool.existing.inactive": "Inactive",
  "identityDelegation.tool.existing.edit": "Open configuration",
  "identityDelegation.tool.existing.loading": "Loading delegated tools…",
  "identityDelegation.tool.existing.empty":
    "No delegated tool has been created for this company yet.",
  "identityDelegation.tool.create.title": "Create a delegated identity tool",
  "identityDelegation.tool.defaultParameterDescription":
    "Stable identifier of the resource to read",
  "identityDelegation.agent.title": "Enable the tool for an agent",
  "identityDelegation.agent.description":
    "Open the target agent’s Tools tab, enable the delegated tool, and make its prompt describe the customer capability without exposing authentication internals.",
  "identityDelegation.agent.action": "Configure agent tools",
  "toolForm.httpConfig.authentication": "Authentication",
  "toolForm.httpConfig.authentication.none": "No ChatSystem delegated identity",
  "toolForm.httpConfig.authentication.delegated":
    "ChatSystem delegated identity (signed JWT)",
  "toolForm.httpConfig.delegated.title": "Read-only delegated customer API",
  "toolForm.httpConfig.delegated.help":
    "ChatSystem injects a short-lived signed JWT. Never configure a static Authorization header here.",
  "toolForm.httpConfig.method": "HTTP method",
  "toolForm.httpConfig.audience": "Exact token audience",
  "toolForm.httpConfig.urlTemplate": "Fixed HTTPS URL template",
  "toolForm.httpConfig.capabilities": "Required capabilities",
  "toolForm.httpConfig.capabilities.help":
    "Comma-separated, narrow permissions such as orders:read.",
  "toolForm.outputSchema.title": "Customer API response schema",
  "toolForm.outputSchema.help":
    "Describe the JSON the endpoint returns so the agent receives a bounded, validated result.",
  "toolForm.toast.delegatedConfig.invalid":
    "Complete the fixed HTTPS endpoint, audience, supported method, and required capabilities.",
  "toolForm.toast.outputSchema.invalid":
    "Delegated tools require a valid customer API response schema.",
  "myAccount.page.myTools.create.toast.success": "Tool created successfully.",
  "myAccount.page.myTools.create.toast.error": "Failed to create tool.",
  "myAccount.page.myTools.edit.cta": "Edit configuration",
  "myAccount.page.myTools.edit.title": "Edit company-owned tool",
  "myAccount.page.myTools.edit.back": "Back to tools",
  "myAccount.page.myTools.edit.unavailable":
    "This company-owned tool cannot be edited here.",
  "myAccount.page.myTools.edit.toast.loadError": "Failed to load the tool.",
  "myAccount.page.myTools.edit.toast.error": "Failed to update the tool.",
  "myAccount.page.myTools.edit.toast.success": "Tool configuration updated.",
  "dev.companyApiKey.column.name": "Name",
  "dev.companyApiKey.column.scopes": "Scopes",
  "dev.companyApiKey.column.created": "Created",
  "dev.companyApiKey.column.expires": "Expires",
  "dev.companyApiKey.column.lastUsed": "Last used",
  "dev.companyApiKey.column.status": "Status",
  "dev.companyApiKey.status.active": "active",
  "dev.companyApiKey.status.revoked": "revoked",
  "toolForm.httpConfig.advanced": "Advanced HTTP configuration",
  "myAccount.page.leftMenu.billing": "Billing",
  "billing.portal.eyebrow": "Billing",
  "billing.portal.title": "Your subscription",
  "billing.portal.description": "Review your current plan, usage and billing.",
  "billing.portal.interval.month": "month",
  "billing.portal.interval.year": "year",
  "billing.portal.frequency.monthly": "Monthly",
  "billing.portal.frequency.yearly": "Annual",
  "billing.portal.current.eyebrow": "Your current plan",
  "billing.portal.current.status.scheduled": "Your plan is scheduled.",
  "billing.portal.current.status.active": "Your access is active.",
  "billing.portal.current.status.grace":
    "Your access remains active while a payment issue is resolved.",
  "billing.portal.current.graceEndsAt":
    "Update your payment method before {date} to keep access active.",
  "billing.portal.current.status.suspended": "Your access is suspended.",
  "billing.portal.current.status.cancelled": "Your plan has been cancelled.",
  "billing.portal.current.status.ended": "Your plan has ended.",
  "billing.portal.current.statusLabel.scheduled": "Scheduled",
  "billing.portal.current.statusLabel.active": "Active",
  "billing.portal.current.statusLabel.grace": "Payment issue",
  "billing.portal.current.statusLabel.suspended": "Suspended",
  "billing.portal.current.statusLabel.cancelled": "Cancelled",
  "billing.portal.current.statusLabel.ended": "Ended",
  "billing.portal.current.frequency": "Billing frequency: {interval}.",
  "billing.portal.current.nextBillingDate": "Next billing date: {date}.",
  "billing.portal.current.cancellationScheduled":
    "Cancellation is scheduled for {date}. Your access remains active until then and the subscription will not renew.",
  "billing.portal.current.pricing.title": "Your billing details",
  "billing.portal.current.pricing.empty":
    "The detailed terms of this existing plan are not available online yet.",
  "billing.portal.funding.postpaid":
    "All priced usage shares this monthly spending limit. Actual usage is billed after consumption.",
  "billing.portal.funding.uncapped.title":
    "Postpaid usage without a contractual maximum",
  "billing.portal.funding.uncapped":
    "All priced usage is billed after consumption. Your private agreement has no contractual usage maximum.",
  "billing.portal.funding.periodic":
    "All priced usage shares this included credit. Any unused amount expires at the end of the billing period.",
  "billing.portal.funding.rolling":
    "All priced usage shares this prepaid credit. Any unused amount remains available in later billing periods.",
  "billing.portal.funding.base": "Shared usage budget: {amount}",
  "billing.portal.funding.used": "Used: {amount}",
  "billing.portal.funding.inProgress": "In progress: {amount}",
  "billing.portal.funding.remaining.postpaid":
    "Remaining usage limit this month",
  "billing.portal.funding.remaining.periodic.monthly":
    "Usage credit remaining this month",
  "billing.portal.funding.remaining.periodic.period":
    "Usage credit remaining this billing period",
  "billing.portal.funding.remaining.rolling": "Available usage credit",
  "billing.portal.usageCredit.title": "Usage credit",
  "billing.portal.usageCredit.periodLabel": "Billing period",
  "billing.portal.usageCredit.periodValue": "{start} – {end}",
  "billing.portal.usageCredit.policyLabel": "Usage terms",
  "billing.portal.usageActivity.eyebrow": "Current billing period",
  "billing.portal.usageActivity.title": "Your usage",
  "billing.portal.usageActivity.description":
    "Follow each measured resource included in your current plan.",
  "billing.portal.usageActivity.used": "used this period",
  "billing.portal.usage.period": "Usage period: {start} to {end}",
  "billing.portal.usage.included":
    "{quantity} included in each billing period.",
  "billing.portal.usage.limit":
    "Current usage limit: {quantity} for this billing period.",
  "billing.portal.usage.consumed": "Used this period: {quantity}",
  "billing.portal.usage.reserved": "Currently in progress: {quantity}",
  "billing.portal.usage.additionalAllowance":
    "Additional allowance this period: {quantity}",
  "billing.portal.usage.remaining": "Remaining before the limit: {quantity}",
  "billing.portal.usage.billable":
    "Billable usage above your included amount: {quantity}",
  "billing.portal.usage.noOverage":
    "No usage is currently billable above your included amount.",
  "billing.portal.metric.conversations": "started conversations",
  "billing.portal.metric.aiResponses": "AI responses",
  "billing.portal.metric.productSearches": "product searches",
  "billing.portal.metric.completedConversations": "completed conversations",
  "billing.portal.metric.aiTokens": "AI tokens",
  "billing.portal.metric.braveRequests": "Brave Search requests",
  "billing.portal.recharge.title": "Add usage for this billing period",
  "billing.portal.recharge.shared.title": "One-time usage top-ups",
  "billing.portal.recharge.shared.action": "Buy a one-time top-up — {price}",
  "billing.portal.recharge.shared.promotion":
    "Pay {price}, receive {credit} usage credit",
  "billing.portal.recharge.card.title": "Add usage credit",
  "billing.portal.recharge.card.creditAmount": "{credit} usage credit",
  "billing.portal.recharge.card.payment": "One-time payment: {price}",
  "billing.portal.recharge.card.action": "Buy {credit} usage credit",
  "billing.portal.recharge.card.bonus": "Includes {bonus} bonus credit",
  "billing.portal.recharge.shared.periodic":
    "The credit is added after payment confirmation and expires at the end of the current billing period.",
  "billing.portal.recharge.shared.rolling":
    "The credit is added after payment confirmation and rolls forward with this subscription.",
  "billing.portal.recharge.pack":
    "{quantity} {metric} per additional pack at {price}.",
  "billing.portal.recharge.quantity": "Number of packs",
  "billing.portal.recharge.action":
    "Buy {quantity} additional {metric} — {total}",
  "billing.portal.recharge.opening": "Opening secure payment…",
  "billing.portal.recharge.confirmation":
    "The additional allowance is applied after secure payment confirmation and remains available until the end of the current billing period.",
  "billing.portal.recharge.error":
    "Additional usage payment could not be opened. Refresh the page and try again, or contact support.",
  "billing.portal.recharge.return.success":
    "Secure checkout is complete. Your additional usage will appear here as soon as the payment is confirmed.",
  "billing.portal.recharge.return.cancelled":
    "Payment was cancelled. No additional usage has been added.",
  "billing.portal.pricing.taxIncluded":
    "Prices are shown in {currency} including tax. Stripe confirms the applicable tax from your billing details at checkout and on the invoice.",
  "billing.portal.planDetails.title": "Plan details",
  "billing.portal.management.heroAction": "Manage billing",
  "billing.portal.history.title": "Recent billing activity",
  "billing.portal.history.description":
    "See your latest invoices, adjustments and additional usage purchases.",
  "billing.portal.history.recharge.title": "Additional usage purchased",
  "billing.portal.history.recharge.sharedCredit": "Shared usage credit added",
  "billing.portal.history.recharge.availability": "Availability",
  "billing.portal.history.recharge.rollsForward":
    "Carries forward while this subscription remains active",
  "billing.portal.history.recharge.appliedRefundTitle":
    "Refund recorded — review required",
  "billing.portal.history.recharge.reviewTitle":
    "Payment received — review required",
  "billing.portal.history.recharge.partialRefundTitle":
    "Payment partially refunded — review required",
  "billing.portal.history.recharge.refundedTitle": "Payment refunded",
  "billing.portal.history.recharge.appliedRefundDescription":
    "{amount} was refunded after the additional usage had already been added. The usage remains available while support reviews the adjustment.",
  "billing.portal.history.recharge.reviewDescription":
    "The intended billing period ended before payment confirmation, so no usage was added automatically. Please contact support so we can review the payment.",
  "billing.portal.history.recharge.reviewContractChangedDescription":
    "Your subscription changed before payment confirmation, so this purchase could not be added automatically. Please contact support so we can review the payment.",
  "billing.portal.history.recharge.partialRefundDescription":
    "The intended billing period ended before confirmation, so no usage was added. {amount} has been refunded so far; please contact support.",
  "billing.portal.history.recharge.partialRefundContractChangedDescription":
    "Your subscription changed before payment confirmation, so no usage was added. {amount} has been refunded so far; please contact support.",
  "billing.portal.history.recharge.refundedDescription":
    "The intended billing period had already ended, so no usage was added. The full payment of {amount} was refunded.",
  "billing.portal.history.recharge.refundedContractChangedDescription":
    "Your subscription changed before payment confirmation, so no usage was added. The full payment of {amount} was refunded.",
  "billing.portal.history.recharge.paidAt": "Paid on {date}",
  "billing.portal.history.recharge.availableUntil": "Available until",
  "billing.portal.history.recharge.intendedAvailableUntil":
    "Intended availability until",
  "billing.portal.history.recharge.periodEnded": "Intended period ended",
  "billing.portal.invoice.title": "Invoice",
  "billing.portal.invoice.updatedAt": "Last updated {date}",
  "billing.portal.invoice.total": "Invoice total",
  "billing.portal.invoice.totalPaid": "Total paid",
  "billing.portal.invoice.alreadyPaid": "Already paid",
  "billing.portal.invoice.remaining": "Remaining",
  "billing.portal.invoice.viewDetail": "View details",
  "billing.portal.invoice.downloadPdf": "Download PDF",
  "billing.portal.invoice.opening": "Opening…",
  "billing.portal.invoice.documentError":
    "This invoice document could not be opened. Please try again or use Manage billing.",
  "billing.portal.invoice.attempts":
    "{count, plural, one {# payment attempt} other {# payment attempts}} recorded.",
  "billing.portal.paymentActionRequired.title":
    "Your bank needs you to confirm this payment",
  "billing.portal.paymentActionRequired.description":
    "Confirm securely before {date} to keep your subscription active.",
  "billing.portal.paymentActionRequired.invoiceHelp":
    "Open the secure invoice to complete authentication. ChatSystem never receives your bank credentials.",
  "billing.portal.paymentActionRequired.action": "Confirm payment securely",
  "billing.portal.invoice.status.draft": "Being prepared",
  "billing.portal.invoice.status.open": "Payment pending",
  "billing.portal.invoice.status.paid": "Paid",
  "billing.portal.invoice.status.uncollectible": "Payment required",
  "billing.portal.invoice.status.void": "Cancelled",
  "billing.portal.invoice.status.unknown": "Being updated",
  "billing.portal.creditNote.title": "Adjustments",
  "billing.portal.creditNote.issued": "Credit note",
  "billing.portal.creditNote.void": "Cancelled credit note",
  "billing.portal.creditNote.detail": "Effective {date}",
  "billing.portal.creditNote.detailWithReason": "Effective {date} · {reason}",
  "billing.portal.creditNote.truncated":
    "Only the most recent adjustments are shown here. Contact support for the complete history.",
  "billing.portal.creditNote.reason.duplicate": "Duplicate charge",
  "billing.portal.creditNote.reason.fraudulent": "Reported transaction",
  "billing.portal.creditNote.reason.orderChange": "Order change",
  "billing.portal.creditNote.reason.productUnsatisfactory":
    "Product or service issue",
  "billing.portal.current.help.change":
    "Choose another available plan below to schedule a change.",
  "billing.portal.current.help.scheduled":
    "Your current plan remains available until its scheduled start.",
  "billing.portal.current.help.paymentIssue":
    "Contact support if the payment issue persists.",
  "billing.portal.current.help.restoreAccess":
    "Contact support to restore your access.",
  "billing.portal.current.help.inactive":
    "Contact us if you would like to choose another plan.",
  "billing.portal.offer.private": "Offer prepared for your company",
  "billing.portal.offer.current": "Current plan",
  "billing.portal.offer.scheduled": "Scheduled",
  "billing.portal.planChange.action": "Change at period end",
  "billing.portal.planChange.alreadyScheduled": "Another change is scheduled",
  "billing.portal.planChange.unavailable": "Plan change unavailable",
  "billing.portal.planChange.confirm.title":
    "Change from {source} to {target} on {date}?",
  "billing.portal.planChange.confirm.help":
    "Nothing is charged today. Your current plan remains active until the paid period ends, and you can cancel this change before then.",
  "billing.portal.planChange.confirm.action": "Confirm plan change",
  "billing.portal.planChange.confirm.back": "Go back",
  "billing.portal.planChange.scheduling": "Scheduling change…",
  "billing.portal.planChange.scheduled":
    "{offer} will become your plan on {date}.",
  "billing.portal.planChange.scheduled.help":
    "Your current plan and prices remain unchanged until then. No charge is made today.",
  "billing.portal.planChange.cancel": "Cancel scheduled change",
  "billing.portal.planChange.cancelling": "Cancelling change…",
  "billing.portal.planChange.error":
    "Your plan change could not be scheduled. Refresh the page and try again, or contact support.",
  "billing.portal.planChange.rollingCredit":
    "This plan still has usage credit that must be preserved. Use the remaining credit before changing plans, or contact support.",
  "billing.portal.planChange.cancel.error":
    "The scheduled change could not be cancelled. Refresh the page and try again, or contact support.",
  "billing.portal.paymentGracePeriod":
    "Payment grace period: {hours, plural, one {# hour} other {# hours}}",
  "billing.portal.offer.public": "Standard offer",
  "billing.portal.available.title": "Plans available to your company",
  "billing.portal.available.description":
    "Compare the public and private plans currently available to your company.",
  "billing.portal.available.back": "Back to my subscription",
  "billing.portal.selected.header.title": "Complete your subscription",
  "billing.portal.selected.header.description":
    "Review the selected terms, then continue to Stripe’s secure checkout.",
  "billing.portal.selected.title": "Your selected plan",
  "billing.portal.selected.compare": "Compare all plans",
  "billing.portal.checkout.action": "Continue to secure checkout",
  "billing.portal.checkout.opening": "Opening secure checkout…",
  "billing.portal.checkout.error":
    "Checkout could not be opened. Please try again or contact support.",
  "billing.portal.checkout.return.success":
    "Secure checkout is complete. Your subscription will appear here as soon as the payment is confirmed.",
  "billing.portal.checkout.return.continueProduction":
    "Continue setting up my Agent",
  "billing.portal.checkout.return.cancelled":
    "Checkout was cancelled. Your subscription has not changed.",
  "billing.portal.management.title": "Manage your subscription and billing",
  "billing.portal.management.description":
    "Open Stripe’s secure billing area to update your payment method, download invoices, or schedule cancellation at the end of your paid period. Your ChatSystem plan and quantities cannot be changed there.",
  "billing.portal.management.action": "Manage billing securely",
  "billing.portal.management.opening": "Opening secure billing…",
  "billing.portal.management.error":
    "Secure billing management could not be opened. Please try again or contact support.",
  "billing.portal.load.error":
    "Your billing information could not be loaded. Please refresh the page or contact support.",
  "billing.portal.empty.current.title": "No other plan is currently available",
  "billing.portal.empty.current.description":
    "Your current access remains unchanged. Contact us if you would like to discuss another plan.",
  "billing.portal.empty.noCurrent.title":
    "No subscription is currently available online",
  "billing.portal.empty.noCurrent.description":
    "Contact us to discuss the plan best suited to your company.",
  "admin.subscriptionOffer.stripe.title": "Online payment readiness",
  "admin.subscriptionOffer.stripe.description":
    "The local terms are frozen. Complete or retry their idempotent Stripe projection; no duplicate provider resource will be created.",
  "admin.subscriptionOffer.stripe.ready":
    "Ready: {count} pricing components are bound to the {interval} Checkout offer, and the Customer Portal is configured.",
  "admin.subscriptionOffer.stripe.prepare": "Complete online publication",
  "admin.subscriptionOffer.stripe.preparing": "Preparing…",
  "admin.subscriptionOffer.stripe.verify": "Verify online setup",
  "admin.subscriptionOffer.stripe.confirm":
    "Create or verify the Stripe product, billing components, and secure customer portal for this exact published offer version?",
  "admin.subscriptionOffer.stripe.error":
    "Online setup could not be completed. It is safe to retry.",
  "admin.subscriptionOffer.stripe.success":
    "Stripe Checkout and secure customer billing management are ready.",
  "admin.subscriptionOffer.publicationMode.stripe": "Stripe payment",
  "admin.subscriptionOffer.publicationMode.offline": "Manual invoicing",
  "admin.subscriptionOffer.publicationMode.internal":
    "Internal / complimentary",
  "admin.subscriptionOffer.publicationMode.legacy": "Historical mode to review",
  "admin.subscriptionOffer.offline.eyebrow": "Collection method",
  "admin.subscriptionOffer.offline.title": "Manual invoicing outside Stripe",
  "admin.subscriptionOffer.offline.description":
    "This payment route was intentionally selected for this immutable offer version. ChatSystem records priced usage while the operator invoices the customer directly and retains control over settlements.",
  "admin.subscriptionOffer.offline.paymentRoute.title":
    "Confirmed payment route",
  "admin.subscriptionOffer.offline.paymentRoute.description":
    "Intentionally outside Stripe: the customer is invoiced and pays the operator directly. No Stripe product, price, or Checkout is therefore expected.",
  "admin.subscriptionOffer.offline.evidence.title":
    "ChatSystem financial tracking",
  "admin.subscriptionOffer.offline.evidence.description":
    "Priced usage, invoice references, and settlement statuses are retained in the provider-neutral financial journal.",
  "company.members.title": "Company members",
  "company.members.description":
    "Invite people using the email address they use to sign in to ChatSystem.",
  "company.members.email.placeholder": "name@company.com",
  "company.members.invite": "Create invitation link",
  "company.members.invitation.share":
    "Send this secure link to the invited person.",
  "company.members.invitation.copy": "Copy invitation link",
  "company.members.invitation.copied": "Invitation link copied",
  "company.members.invitation.pending": "Invitation pending",
  "company.members.invitation.revoke": "Revoke invitation",
  "company.members.owner": "Owner",
  "company.members.transfer": "Transfer ownership",
  "company.members.transfer.confirm":
    "Transfer company ownership to this member?",
  "company.members.remove": "Remove member",
  "company.members.remove.confirm": "Remove this member from the company?",
  "company.invitation.accept.title": "Join the company on ChatSystem",
  "company.invitation.accepted.title": "You joined the company",
  "company.invitation.invalid": "This invitation link is invalid.",
  "company.invitation.usedWorkspace":
    "Your current company contains data or activity. Contact a ChatSystem administrator to complete the transfer safely.",
  "company.invitation.failed":
    "The invitation is invalid, expired, or does not match the email address used to sign in to ChatSystem.",
  "company.invitation.signIn": "Sign in to accept",
  "admin.subscriptionOffer.capabilities.eyebrow": "Customer capabilities",
  "admin.subscriptionOffer.capabilities.title": "Define what this offer allows",
  "admin.subscriptionOffer.capabilities.description":
    "These limits are enforced by the API and displayed consistently on the pricing page. Use Unlimited only when the commercial terms truly allow it.",
  "admin.subscriptionOffer.capabilities.summary":
    "Resources and service included",
  "admin.subscriptionOffer.capabilities.agents": "Maximum Agents",
  "admin.subscriptionOffer.capabilities.domains": "Maximum root domains",
  "admin.subscriptionOffer.capabilities.members": "Maximum company members",
  "admin.subscriptionOffer.capabilities.unlimited": "Unlimited",
  "admin.subscriptionOffer.capabilities.poweredBy.title":
    "Display “Powered by ChatSystem”",
  "admin.subscriptionOffer.capabilities.poweredBy.description":
    "The widget receives this server-owned branding decision.",
  "admin.subscriptionOffer.capabilities.branding": "Widget branding",
  "admin.subscriptionOffer.capabilities.branding.hidden": "White-label",
  "admin.subscriptionOffer.capabilities.branding.visible":
    "Powered by ChatSystem",
  "admin.subscriptionOffer.capabilities.support": "Support level",
  "admin.subscriptionOffer.capabilities.support.standard": "Standard",
  "admin.subscriptionOffer.capabilities.support.direct":
    "Dedicated direct email",
  "workspace.capacity.comparePlans": "Compare plans",
  "workspace.capacity.viewPlans": "View plans",
  "workspace.capacity.askOwner.choosePlan":
    "Ask the company owner to choose a plan.",
  "workspace.capacity.askOwner.higherPlan":
    "Ask the company owner to choose a higher plan.",
  "workspace.capacity.scheduledChange":
    "The limits of your next plan already apply to new creations.",
  "workspace.capacity.agents": "Agents",
  "workspace.capacity.domains": "Authorized domains",
  "workspace.capacity.members": "Team seats",
  "workspace.capacity.agents.reached":
    "You have created all the Agents included in your plan.",
  "workspace.capacity.agents.reached.preparation":
    "You have reached the maximum number of Agents you can create without a plan.",
  "workspace.capacity.agents.reached.scheduled":
    "You have reached the number of Agents included in your next scheduled plan.",
  "workspace.capacity.agents.upgrade": "To create more, choose a higher plan.",
  "workspace.capacity.agents.choosePlan": "To create more, choose a plan.",
  "workspace.capacity.domains.reached":
    "You have authorized all the domains included in your plan.",
  "workspace.capacity.domains.reached.preparation":
    "You have reached the maximum number of domains you can authorize without a plan.",
  "workspace.capacity.domains.reached.scheduled":
    "You have reached the number of domains included in your next scheduled plan.",
  "workspace.capacity.domains.upgrade": "To add more, choose a higher plan.",
  "workspace.capacity.domains.choosePlan": "To add more, choose a plan.",
  "workspace.capacity.members.reached":
    "All the team seats included in your plan are in use.",
  "workspace.capacity.members.reached.preparation":
    "You have reached the maximum number of team members allowed without a plan.",
  "workspace.capacity.members.reached.scheduled":
    "All the team seats included in your next scheduled plan are already in use.",
  "workspace.capacity.members.upgrade":
    "To add more members, choose a higher plan.",
  "workspace.capacity.members.choosePlan":
    "To add more members, choose a plan.",
  "workspace.capacity.agents.error":
    "Your current plan does not allow another Agent.",
  "workspace.capacity.domains.error":
    "Your current plan does not allow this additional domain.",
  "workspace.capacity.members.error":
    "Your current plan does not include another team seat.",
  "workspace.capacity.agents.duplicateBlocked":
    "Your Agent limit is reached. Existing settings remain editable.",
  "workspace.capabilities.title": "Plan and capabilities",
  "workspace.capabilities.loadError":
    "Plan capabilities could not be loaded. Refresh the page before adding resources.",
  "workspace.capabilities.preparation":
    "Prepare your first Agent and domain now. Choose a plan before testing AI and publishing the widget.",
  "workspace.capabilities.active": "Your {plan} capabilities are active.",
  "workspace.capabilities.inactive":
    "Your workspace remains configurable, but AI access requires an active plan.",
  "workspace.capabilities.aiActive": "AI active",
  "workspace.capabilities.preparationBadge": "Preparation",
  "workspace.capabilities.suspendedBadge": "Access suspended",
  "workspace.capabilities.endedBadge": "Plan ended",
  "workspace.capabilities.scheduled":
    "{plan} is scheduled for {date}; its lower limits already prevent new resources without removing existing ones.",
  "myAccount.page.myAgents.create": "Create an Agent",
  "myAccount.page.myAgents.create.title": "Create an Agent",
  "myAccount.page.myAgents.create.description":
    "Start with a name, then configure its instructions, appearance and Tools.",
  "myAccount.page.myAgents.create.error": "The Agent could not be created.",
  "myAccount.page.myDNS.rootDomainHint":
    "Authorize the root domain once; its subdomains are included automatically.",
  "myAccount.page.myDNS.includedSubdomains":
    "All your subdomains are included by default. Examples: www.{domain}, shop.{domain}.",
  "myAccount.page.myChatbot.planRequired.badge": "One last step",
  "myAccount.page.myChatbot.planRequired.title":
    "Your Agent is almost ready to talk to your visitors",
  "myAccount.page.myChatbot.planRequired.description":
    "Finish personalizing it now. Once you choose a plan, you can talk to it here, then install it on your website.",
  "myAccount.page.myChatbot.planRequired.available.title":
    "Prepare your Agent now",
  "myAccount.page.myChatbot.planRequired.available.agent":
    "Personalize its answers, appearance and Tools",
  "myAccount.page.myChatbot.planRequired.available.domain":
    "Authorize the website where it will be available",
  "myAccount.page.myChatbot.planRequired.locked.title": "Then, with your plan",
  "myAccount.page.myChatbot.planRequired.locked.test":
    "Try a real conversation on this page",
  "myAccount.page.myChatbot.planRequired.locked.publish":
    "Install your Agent and welcome your visitors",
  "myAccount.page.myChatbot.planRequired.configureAgent":
    "Personalize my Agent",
  "myAccount.page.myChatbot.planRequired.configureDomain": "Choose my website",
  "myAccount.page.myChatbot.planRequired.activate":
    "Choose a plan and try my Agent",
  "myAccount.page.leftMenu.onboarding": "Create my demo",
  "myAccount.page.leftMenu.projects": "Projects",
  "myAccount.page.leftMenu.demos": "My demos",
  "myAccount.page.leftMenu.production": "Put into production",
  "home.personalizedDemo.promise":
    "Create a free chatbot inspired by your website in 10 minutes",
  "home.personalizedDemo.websiteLabel": "Your website address",
  "home.personalizedDemo.cta": "Create my free demo",
  "home.personalizedDemo.reassurance":
    "No card required. Your private preview is ready to review before it can be shared.",
  "home.personalizedDemo.error":
    "We couldn't prepare this website. Check the address and try again.",
  "onboarding.badge": "Personalized demo",
  "onboarding.title": "See your future Agent in action",
  "onboarding.description":
    "We use the public information on your website to prepare a private preview. Once you have reviewed it and completed a few details, you can test the chatbot for free and share it with your team.",
  "onboarding.step.website": "Your website",
  "onboarding.step.discovery": "Discovery",
  "onboarding.step.agent": "Your Agent",
  "onboarding.step.capabilities": "Capabilities",
  "onboarding.step.review": "Agent and capabilities",
  "onboarding.step.demo": "Shareable demo",
  "onboarding.progress.label": "Demo preparation progress",
  "onboarding.error.start": "The demo could not be started.",
  "onboarding.error.retry": "The website analysis could not be retried.",
  "onboarding.error.saveProposal": "The proposal could not be saved.",
  "onboarding.error.approveProposal": "The proposal could not be approved.",
  "onboarding.error.activate": "The demo could not be activated.",
  "onboarding.error.share": "The demo link could not be copied.",
  "onboarding.error.revoke": "The demo link could not be disabled.",
  "onboarding.error.agentAlreadyConfigured":
    "Your existing Agent is already configured. To protect your work, this demo will not replace it. Contact us if you would like a separate personalized demo.",
  "onboarding.website.title": "Which website should we use to build your demo?",
  "onboarding.website.inputLabel": "Public website address",
  "onboarding.website.inputPlaceholder": "https://your-website.com",
  "onboarding.website.description":
    "Enter its address. ChatSystem prepares a personalized Agent from your business, content and visual identity.",
  "onboarding.website.cta": "Prepare my demo",
  "onboarding.website.duplicate": "A demo already exists for this website.",
  "onboarding.website.resume": "Resume this demo",
  "onboarding.website.newVersion": "Create another version",
  "onboarding.website.reassurance":
    "You will be able to try a free demo chatbot built from this website.",
  "onboarding.discovery.title": "We are getting to know your company",
  "onboarding.discovery.description":
    "We review information from your website to prepare your personalized demo.",
  "onboarding.discovery.failure.title": "We need another attempt",
  "onboarding.discovery.failure.description":
    "The website did not provide enough usable public information. You can retry without losing your progress.",
  "onboarding.discovery.retry": "Try again",
  "onboarding.review.eyebrow": "Step 3 of 5",
  "onboarding.review.title": "Review your Agent",
  "onboarding.review.description":
    "A well-informed Agent gives your visitors more relevant answers. Check that the information below is accurate and reflects your company, its culture and the way it works.",
  "onboarding.review.partial": "Please verify",
  "onboarding.personalizationRecovery.eyebrow": "Your personalized Agent",
  "onboarding.personalizationRecovery.retryable.title":
    "Your Agent needs a little more time",
  "onboarding.personalizationRecovery.retryable.description":
    "We saved the information discovered on your website, but the personalized proposal was not completed. Retry the preparation to obtain an Agent that is genuinely useful and faithful to your company.",
  "onboarding.personalizationRecovery.unavailable.title":
    "Your project is safely saved",
  "onboarding.personalizationRecovery.unavailable.description":
    "We saved your website and project, but personalized preparation is temporarily unavailable. The ChatSystem team has been notified and will contact you very shortly. Your changes are saved.",
  "onboarding.personalizationRecovery.retry.cta": "Retry the preparation",
  "onboarding.personalizationRecovery.retry.loading": "Preparing your Agent…",
  "onboarding.personalizationRecovery.manual.cta": "Fill in my Agent manually",
  "onboarding.personalizationRecovery.saved":
    "You can complete the information manually while waiting. No demo allowance is consumed until your Agent is ready to test.",
  "onboarding.review.continueToCapabilities":
    "Continue to my Agent's capabilities",
  "onboarding.review.approve": "Approve and prepare the demo",
  "onboarding.field.businessName": "Company name",
  "onboarding.field.businessDescription": "Your business in a few words",
  "onboarding.field.websiteContext": "Your Agent's knowledge briefing",
  "onboarding.field.websiteContext.help":
    "We have turned the useful information found on your website into an operational briefing. Review, correct or enrich it before testing your Agent.",
  "onboarding.field.agentName": "Agent name",
  "onboarding.field.welcome": "Welcome message",
  "onboarding.field.welcome.help":
    "This is the first message your visitors will read. You can use short paragraphs, lists and a touch of your brand's personality.",
  "onboarding.field.color": "Primary color",
  "onboarding.field.logo": "Logo or favicon URL",
  "onboarding.field.starters": "Suggested first questions (optional)",
  "onboarding.field.starter.placeholder": "Suggested question {number}",
  "onboarding.field.starters.help":
    "Leave any suggestion empty if it would not help your visitors.",
  "onboarding.preview.label": "Live preview",
  "onboarding.preview.agentFallback": "Your Agent",
  "onboarding.preview.welcomeFallback":
    "Your welcome message will appear here.",
  "onboarding.capability.eyebrow": "Step 4 of 5",
  "onboarding.capability.title": "Your Agent's capabilities",
  "onboarding.capability.description":
    "We selected capabilities that match what visitors need on your website. Choose the ones you want to make available in the free demo.",
  "onboarding.capability.testable.title": "Ready for your free demo",
  "onboarding.capability.testable.description":
    "These capabilities work with the information already prepared from your website.",
  "onboarding.capability.future.title": "More capabilities for your Agent",
  "onboarding.capability.future.description":
    "Add the capabilities that are ready now. The others can be configured from your workspace or prepared with ChatSystem.",
  "onboarding.capability.future.more":
    "Discover even more capabilities that can be added to your Agent.",
  "onboarding.capability.none":
    "No additional capability was preselected for this first preview. You can add a ready capability below.",
  "onboarding.capability.more":
    "Need a personalized customer journey or a Tool tailored to your company's specific needs? ChatSystem can build custom Tools for your Agent. Contact us to design the right solution.",
  "onboarding.capability.availability.demoReady": "Ready to test",
  "onboarding.capability.availability.readyToAdd": "Ready to add",
  "onboarding.capability.availability.setupRequired": "To configure",
  "onboarding.capability.availability.productionOnly": "Contact us",
  "onboarding.capability.configuration.autoFilled":
    "Prepared from your website",
  "onboarding.capability.back": "Back to my Agent",
  "onboarding.activation.title": "Your proposal is approved",
  "onboarding.activation.description":
    "Activate your private demo to receive a shareable link and test up to {responseLimit, plural, one {# AI response} other {# AI responses}}. Its exact expiration date will be shown after activation. Nothing can be installed on a live site from this demo.",
  "onboarding.activation.cta": "Activate my free demo",
  "onboarding.demo.active": "Demo active",
  "onboarding.demo.title": "Your shareable demo is ready",
  "onboarding.demo.description":
    "Open it yourself or send this link to your team. Visitors do not need a ChatSystem account.",
  "onboarding.demo.responses": "responses left",
  "onboarding.demo.expiry": "available until",
  "onboarding.demo.copy": "Copy link",
  "onboarding.demo.linkLabel": "Shareable demo link",
  "onboarding.demo.copied": "Copied",
  "onboarding.demo.view": "View my demo",
  "onboarding.demo.production": "Ready for production? Compare plans",
  "onboarding.demo.revoke": "Disable this link",
  "onboarding.demo.revoke.confirm": "Make this shared demo unavailable?",
  "onboarding.closed.title": "Your personalized work is preserved",
  "onboarding.closed.description":
    "This demo can no longer receive responses, but your reviewed Agent remains available. Choose a production plan to continue without starting over.",
  "onboarding.closed.cta": "Continue to production",
  "publicDemo.free": "Free personalized demo",
  "publicDemo.availableUntil": "Available until {date}",
  "publicDemo.title": "A first glimpse of your future Agent",
  "publicDemo.globalResponses": "responses left in this demo",
  "publicDemo.viewerResponses": "responses for this visit",
  "publicDemo.tools.title": "Capabilities tailored to this Agent",
  "publicDemo.tools.active.title": "Ready to try in this demo",
  "publicDemo.tools.future.title":
    "More capabilities can be added to your Agent",
  "publicDemo.tools.more":
    "Need a personalized customer journey or a Tool tailored to your company's specific needs? ChatSystem can build custom Tools for your Agent. Contact us to design the right solution.",
  "publicDemo.tools.informationOnly":
    "This preview answers from the company information reviewed by its owner.",
  "publicDemo.tools.demoReady": "Active in this demo",
  "publicDemo.tools.setupRequired": "To configure",
  "publicDemo.tools.productionOnly": "Contact us",
  "publicDemo.cta": "Put my Agent into production",
  "publicDemo.agentStatus": "Personalized preview",
  "publicDemo.thinking": "The Agent is thinking…",
  "publicDemo.recentMessages": "Latest messages",
  "publicDemo.input": "Ask a question…",
  "publicDemo.inputLabel": "Message for the Agent",
  "publicDemo.sessionPreparing": "Preparing the conversation…",
  "publicDemo.inputTemporarilyUnavailable":
    "Conversation temporarily unavailable",
  "publicDemo.inputUnavailable": "Conversation limit reached",
  "publicDemo.send": "Send",
  "publicDemo.disclaimer": "Demo answers may require verification.",
  "publicDemo.share.action": "Share this demo",
  "publicDemo.share.copied": "Link copied",
  "publicDemo.share.error": "The link could not be copied. Please try again.",
  "publicDemo.preparingConversation": "Preparing your conversation…",
  "publicDemo.sessionError":
    "This demo cannot start a new conversation right now.",
  "publicDemo.quotaError": "This free demo has reached its conversation limit.",
  "publicDemo.promptError":
    "The Agent could not answer this time. Please try again.",
  "publicDemo.expired.title": "This demo has ended",
  "publicDemo.expired.description":
    "The personalized preview for {company} is no longer public. Contact its owner or create your own demo.",
  "publicDemo.expired.cta": "Create my own demo",
  "admin.page.leftMenu.acquisition": "Acquisition",
  "admin.page.leftMenu.entities.discussions": "Discussions",
  "admin.page.leftMenu.entities.subscriptionFormulas": "Subscription Formulas",
  "navigation.sidebar.label": "Workspace navigation",
  "navigation.breadcrumb.label": "Breadcrumb",
  "navigation.breadcrumb.create": "Create",
  "navigation.breadcrumb.edit": "Edit",
  "navigation.breadcrumb.details": "Details",
  "navigation.breadcrumb.agentDisplays": "Agent displays",
  "navigation.breadcrumb.editDisplay": "Edit display",
  "navigation.breadcrumb.editFacet": "Edit facet",
  "navigation.breadcrumb.visitorDiscussions": "Visitor",
  "navigation.breadcrumb.byVisitor": "By visitor",
  "navigation.breadcrumb.discoveryArtifact": "Discovery artifact",
  "navigation.breadcrumb.llmOperation": "LLM operation",
  "navigation.breadcrumb.report": "Report",
  "navigation.breadcrumb.breakdown": "Breakdown",
  "navigation.breadcrumb.profitability": "Profitability",
  "admin.acquisition.eyebrow": "Growth overview",
  "admin.acquisition.title": "Acquisition",
  "admin.acquisition.subtitle":
    "Monitor every acquisition channel through its funnel, conversion and exact provider costs.",
  "admin.acquisition.channel": "Acquisition channel",
  "admin.acquisition.onboarding.title": "Personalized onboarding",
  "admin.acquisition.onboarding.subtitle":
    "From website submission to a shareable demo and paid conversion. The indicators below belong only to this acquisition journey.",
  "admin.acquisition.updated": "Calculated",
  "admin.acquisition.error":
    "The acquisition dashboard could not be loaded. Please try again.",
  "admin.acquisition.kpi.websites": "Websites submitted",
  "admin.acquisition.kpi.activated": "Demos activated",
  "admin.acquisition.kpi.conversion": "Paid conversion",
  "admin.acquisition.kpi.responses": "Completed demo responses",
  "admin.acquisition.funnel.title": "Onboarding funnel",
  "admin.acquisition.funnel.subtitle":
    "Idempotent product events make abandonment visible at every meaningful step.",
  "admin.acquisition.funnel.website": "Website submitted",
  "admin.acquisition.funnel.discovery": "Usable website analysis",
  "admin.acquisition.funnel.preview": "Preview viewed",
  "admin.acquisition.funnel.approved": "Proposal approved",
  "admin.acquisition.funnel.activated": "Demo activated",
  "admin.acquisition.funnel.firstResponse": "First response completed",
  "admin.acquisition.funnel.shared": "Demo shared",
  "admin.acquisition.funnel.opened": "Shared demo opened",
  "admin.acquisition.funnel.offer": "Production plans viewed",
  "admin.acquisition.funnel.checkoutStarted": "Checkout opened",
  "admin.acquisition.funnel.checkoutCompleted": "Paid conversion confirmed",
  "admin.acquisition.cost.today": "Provider cost today",
  "admin.acquisition.cost.total": "Provider cost since launch",
  "admin.acquisition.cost.empty": "No provider cost has been recorded yet.",
  "admin.acquisition.unitEconomics.title": "Unit economics",
  "admin.acquisition.operations.title": "Operational safeguards",
  "admin.acquisition.operations.discovery": "Analyses requiring attention",
  "admin.acquisition.operations.unresolvedCosts": "Unresolved provider costs",
  "admin.acquisition.operations.activeCosts": "Provider calls in progress",
  "admin.acquisition.operations.failedResponses":
    "Failed or interrupted responses",
  "admin.acquisition.operations.exhausted": "Exhausted allowances",
  "admin.acquisition.unitEconomics.activated": "Cost per activated demo",
  "admin.acquisition.unitEconomics.converted": "Cost per paid conversion",
  "admin.acquisition.demos.title": "Recent demos",
  "admin.acquisition.demos.subtitle":
    "Operational state, engagement and exact provider cost for the latest acquisition journeys.",
  "admin.acquisition.demos.open": "Open",
  "admin.acquisition.personalization.retryable": "Personalization to retry",
  "admin.acquisition.personalization.blocked": "Intervention required",
  "admin.acquisition.table.company": "Company",
  "admin.acquisition.table.status": "Status",
  "admin.acquisition.table.engagement": "Engagement",
  "admin.acquisition.table.cost": "Provider cost",
  "admin.acquisition.table.created": "Created",
  "admin.acquisition.table.responses": "responses",
  "admin.acquisition.table.viewers": "viewers",
  "admin.acquisition.llm.title": "Onboarding LLM operations",
  "admin.acquisition.llm.subtitle":
    "Inspect personalization calls, provider fallbacks, retained evidence and exact linked cost.",
  "admin.acquisition.llm.error": "LLM operations could not be loaded.",
  "admin.acquisition.llm.empty": "No onboarding LLM operation has run yet.",
  "admin.acquisition.llm.operation": "Operation",
  "admin.acquisition.llm.attempts": "Attempts",
  "admin.acquisition.llm.inspect": "Inspect",
  "admin.acquisition.llm.detail.error":
    "This LLM operation could not be loaded.",
  "admin.acquisition.llm.detail.back": "Back to acquisition",
  "admin.acquisition.llm.detail.schema": "Schema",
  "admin.acquisition.llm.detail.prompt": "Prompt",
  "admin.acquisition.llm.detail.operationId": "Operation ID",
  "admin.acquisition.llm.detail.promptFingerprint": "Prompt fingerprint",
  "admin.acquisition.llm.detail.schemaFingerprint": "Schema fingerprint",
  "admin.acquisition.llm.detail.payloadUnavailable":
    "Payload expired or unavailable.",
  "admin.acquisition.llm.detail.context": "Operation context",
  "admin.acquisition.llm.detail.created": "Created",
  "admin.acquisition.llm.detail.website": "Website",
  "admin.acquisition.llm.detail.demo": "Public demo",
  "admin.acquisition.llm.detail.attempts": "Provider attempts and fallbacks",
  "admin.acquisition.llm.detail.attempts.help":
    "Snapshots are bounded, redacted and removed after their retention period. Exact cost remains in the provider journal.",
  "admin.acquisition.llm.detail.request": "Retained request",
  "admin.acquisition.llm.detail.response": "Retained response",
  "admin.acquisition.llm.detail.sources": "Discovery source evidence",
  "admin.acquisition.llm.detail.sources.help":
    "Open the exact bounded HTTP or Brave evidence retained for this analysis.",
  "admin.acquisition.llm.detail.sources.empty":
    "No retained discovery artifact is linked to this operation.",
  "admin.acquisition.artifact.error":
    "This source artifact is unavailable or its retention period has ended.",
  "admin.acquisition.artifact.title": "Retained discovery evidence",
  "admin.acquisition.artifact.size": "Original / retained size",
  "admin.acquisition.artifact.expires": "Payload retained until",
  "admin.acquisition.artifact.mediaType": "Media type",
  "toolForm.acquisitionDemo.title": "Personalized demo policy",
  "toolForm.acquisitionDemo.description":
    "Review separately whether this public Tool may be recommended and whether an anonymous demo may execute it. Recommendation never grants execution.",
  "toolForm.acquisitionDemo.publicRequired":
    "Only active public Tools enter the demo catalogue. Make this Tool public or disable its demo recommendation.",
  "toolForm.acquisitionDemo.recommendationEnabled":
    "May appear in personalized demos",
  "toolForm.acquisitionDemo.selectedByDefault": "Strong default recommendation",
  "toolForm.acquisitionDemo.availability": "Customer-facing availability",
  "toolForm.acquisitionDemo.availability.demoReady": "Ready in this demo",
  "toolForm.acquisitionDemo.availability.setupRequired":
    "Available after configuration",
  "toolForm.acquisitionDemo.availability.productionOnly": "Production only",
  "toolForm.acquisitionDemo.analysis.title":
    "Functional guidance for website analysis",
  "toolForm.acquisitionDemo.analysis.purpose": "What this Tool enables",
  "toolForm.acquisitionDemo.analysis.purpose.help":
    "Explain the visitor or company outcome, independently from a specific website.",
  "toolForm.acquisitionDemo.analysis.recommendWhen":
    "Recommend when (one condition per line)",
  "toolForm.acquisitionDemo.analysis.doNotRecommendWhen":
    "Do not recommend when (one condition per line)",
  "toolForm.acquisitionDemo.analysis.setupContext": "Configuration context",
  "toolForm.acquisitionDemo.analysis.setupContext.help":
    "State honestly what is already demonstrable and what must be configured for production.",
  "toolForm.acquisitionDemo.language.en": "English",
  "toolForm.acquisitionDemo.copy.title": "Customer-facing title",
  "toolForm.acquisitionDemo.copy.description": "Customer-facing description",
  "toolForm.acquisitionDemo.executionEnabled":
    "Allow anonymous execution in the demo",
  "toolForm.acquisitionDemo.effect": "Tool effect",
  "toolForm.acquisitionDemo.effect.readOnly": "Read-only",
  "toolForm.acquisitionDemo.effect.sideEffecting": "Side-effecting",
  "onboarding.field.agentTone.professional": "Professional",
  "onboarding.field.agentTone.warm": "Warm",
  "onboarding.field.agentTone.direct": "Direct",
  "onboarding.field.agentTone.playful": "Playful",
  "admin.page.tools.table.demo": "Personalized demo",
  "admin.page.tools.demo.ready": "Demo ready",
  "admin.page.tools.demo.setup": "After setup",
  "admin.page.tools.demo.production": "Production only",
  "admin.page.tools.demo.notReviewed": "Not approved",
  "company.members.invitation.error":
    "The invitation link could not be created.",
  "common.cancel": "Cancel",
  "common.create": "Create",
  "common.creating": "Creating...",
  "common.paginatedEntities.loadError": "The data could not be loaded.",
  "common.paginatedEntities.retry": "Retry",
  "projects.error": "Your demo projects could not be loaded.",
  "projects.badge": "Your projects",
  "projects.title": "My demos",
  "projects.description":
    "Resume a proposal, share an active demo or prepare the Agent you want to put into production.",
  "projects.create": "Create another demo",
  "projects.creation.suspended.title":
    "Demo creation is temporarily unavailable",
  "projects.creation.suspended":
    "New demo creation is temporarily suspended for your company. Contact us to learn more.",
  "projects.creation.freeLimit.title": "Your two trial demos have been used",
  "projects.creation.freeLimit":
    "You have used your two trial demos. Choose a ChatSystem plan to create new projects throughout the year and put your Agent into production.",
  "projects.creation.openLimit.title": "Two demos are already open",
  "projects.creation.openLimit":
    "Close a finished demo from My demos before preparing a new one. Your work will remain available in your history.",
  "projects.creation.thirtyDayLimit.title":
    "Your monthly creation allowance has been reached",
  "projects.creation.thirtyDayLimit":
    "You have created three demos in the last 30 days. Capacity will become available progressively throughout the month.",
  "projects.creation.twelveMonthLimit.title":
    "All ten annual demos have been created",
  "projects.creation.twelveMonthLimit":
    "You have created the ten demos included over the last 12 months. Contact us if your team is preparing more projects.",
  "projects.creation.action.manage": "Manage my demos",
  "projects.creation.action.plans": "View plans",
  "projects.creation.action.contact": "Contact us",
  "projects.comparePlans": "Discover production plans",
  "projects.resume": "Resume preparation",
  "projects.open": "Open demo",
  "projects.production": "Put into production",
  "projects.close": "Close demo",
  "projects.closing": "Closing…",
  "projects.close.success":
    "Your demo has been closed. Its link is no longer active, and its history remains available.",
  "projects.close.error": "The demo could not be closed. Please try again.",
  "projects.close.confirm":
    "Close this demo link? Its history will remain available, but visitors will no longer be able to use it.",
  "projects.responses": "{remaining} of {total} demo responses remaining",
  "projects.created": "Created on {date}",
  "projects.usage": "Demo conversations",
  "projects.status.draft": "In preparation",
  "projects.status.active": "Active",
  "projects.status.expired": "Expired",
  "projects.status.revoked": "Closed",
  "projects.status.converted": "In production",
  "projects.empty.title": "Create your first personalized demo",
  "projects.empty.description":
    "Enter a website and ChatSystem will prepare an Agent you can review, test and share.",
  "production.empty.title": "Choose the Agent you want to launch",
  "production.empty.description":
    "Create a personalized demo first. Your reviewed work will become the starting point for production.",
  "production.empty.cta": "Create a demo",
  "production.badge": "Launch guide",
  "production.title": "Put your Agent into production",
  "production.description":
    "Follow these steps to activate the Agent from your demo and install it on your website.",
  "production.demoSelector.label": "Demo project to put into production",
  "production.demoSelector.help":
    "The Agent, identity and capabilities reviewed in this demo will be preserved.",
  "production.access.title":
    "A ChatSystem subscription is required to put this Agent into production.",
  "production.access.cta": "View plans",
  "production.prepare.cta": "Continue with this Agent",
  "production.agent.title": "Activate your reviewed Agent",
  "production.agent.activating": "Your Agent is being added to your workspace…",
  "production.agent.readyToAdd":
    "This Agent is ready to be added to your workspace. Domain authorization, testing and installation come next.",
  "production.agent.addToWorkspace": "Continue with this Agent",
  "production.agent.capacityLoadError":
    "Your Agent capacity could not be checked. Please try again.",
  "production.agent.activationError":
    "Your Agent could not be activated this time. Please try again.",
  "production.agent.retry": "Try again",
  "production.agent.capacityReached.title":
    "Your plan has reached its active Agent limit",
  "production.agent.capacityReached.description":
    "Your plan includes {limit} active Agents and all {current} places are in use. Archive an existing Agent to continue with this one.",
  "production.agent.archiveLabel": "Agent to archive",
  "production.agent.archivePlaceholder": "Choose an Agent to archive",
  "production.agent.noArchivableAgent":
    "No active Agent can be archived from this workspace. Refresh the page or contact support.",
  "production.agent.cta": "Archive this Agent and continue",
  "production.steps.title": "Your launch steps",
  "production.steps.description":
    "Start with the highlighted step. Each button opens the exact setting you need.",
  "production.steps.contractError.title":
    "The launch guide needs to be refreshed",
  "production.steps.contractError.description":
    "The application has just been updated. Refresh this page in a few moments to continue.",
  "production.step.access": "Choose a ChatSystem plan",
  "production.step.access.completed": "ChatSystem plan active",
  "production.step.access.description":
    "Choose the plan that matches the traffic expected on your website.",
  "production.step.agent_readiness": "Activate your Agent",
  "production.step.agent_readiness.completed": "Agent activated",
  "production.step.agent_readiness.description":
    "Your Agent will be added to your workspace. Domain authorization, testing and installation come next.",
  "production.step.agent_readiness.description.completed":
    "Your Agent is now available in your workspace. Next, authorize your domain, test it and install it.",
  "production.step.domain": "Authorize your domain",
  "production.step.domain.completed": "Company domain authorized",
  "production.step.domain.description":
    "Authorize the website on which your Agent will be installed.",
  "production.step.domain.description.completed":
    "The website used for your demo is now authorized for your company.",
  "production.step.production_test": "Test in production conditions",
  "production.step.production_test.description":
    "Try your production Agent before showing it to your visitors.",
  "production.step.install": "Install on your website",
  "production.step.install.description":
    "Copy the installation code and add it to your website.",
  "production.step.go_live": "Check your website",
  "production.step.go_live.description":
    "Open your website and check the final experience offered to your visitors.",
  "production.step.status.completed": "Completed",
  "production.step.status.current": "Next step",
  "production.step.status.locked.paid_access":
    "Available after choosing a plan",
  "production.step.status.locked.active_agent":
    "Available after Agent activation",
  "production.step.status.todo": "To do",
  "production.action.review_agent": "Review my Agent",
  "production.action.configure_domain": "Authorize my domain",
  "production.action.test_agent": "Test my Agent",
  "production.action.install_agent": "View installation instructions",
  "production.action.open_website": "Open my website",
  "production.finalActions.ready.title": "Your Agent is ready to install",
  "production.finalActions.ready.description":
    "Add ChatSystem to your website, then open it to verify the experience offered to your visitors.",
  "production.finalActions.locked.title":
    "Installation comes after these checks",
  "production.finalActions.locked.description":
    "Complete the steps above first. We will then guide you through installation and final verification on your website.",
  "production.error.prepare": "The production journey could not be prepared.",
  "production.error.promote":
    "This Agent could not be activated. Select an existing Agent to archive if your plan limit is reached.",
  "production.error.lifecycle": "This Agent status could not be changed.",
  "production.agents.title": "Agents in your workspace",
  "production.agents.description":
    "Find and manage the Agents that have already been created in your workspace.",
  "production.agents.active": "Available",
  "production.agents.archived": "Archived",
  "production.agents.archive": "Archive",
  "production.agents.restore": "Restore",
  "myAccount.page.myAgents.lifecycle.actions": "Actions",
  "myAccount.page.myAgents.archive.confirm":
    "Archive “{name}”? Its configuration will be preserved and you can restore it later when a slot is available.",
  "myAccount.page.myAgents.archived.title": "Archived Agents",
  "myAccount.page.myAgents.archived.description":
    "Their settings are preserved. Restore an Agent when your plan has an available slot.",
  "pricing.production.title": "Your Agent is ready for production",
  "pricing.production.description":
    "Choose the plan that fits your traffic. Your Agent and every choice reviewed in the demo are preserved; after subscribing, simply continue from Put into production.",
  "admin.acquisition.policy.title": "Demo capacity by company",
  "admin.acquisition.policy.description":
    "Inspect the effective quota and record exceptional capacity or a creation suspension with an audit reason.",
  "admin.acquisition.policy.company": "Choose a company",
  "admin.acquisition.policy.lifetime": "Lifetime",
  "admin.acquisition.policy.open": "Open",
  "admin.acquisition.policy.thirtyDays": "30 days",
  "admin.acquisition.policy.twelveMonths": "12 months",
  "admin.acquisition.policy.allowed": "Creation currently allowed",
  "admin.acquisition.policy.blocked": "Creation blocked: {reason}",
  "admin.acquisition.policy.reason": "Required audit reason",
  "admin.acquisition.policy.grant": "Grant one additional demo",
  "admin.acquisition.policy.revoke": "Revoke one additional demo",
  "admin.acquisition.policy.resume": "Resume creation",
  "admin.acquisition.policy.suspend": "Suspend creation",
  "publicDemo.tools.readyToAdd": "Ready to use",
  "discussion.agent.label": "Agent",
  "discussion.agent.id": "Agent ID",
  "discussion.agent.filter.apply": "Apply filter",
};
